
    /* ============================================================
       AV-CINE CORE — socle JS des futures cinématiques.
       Inerte tant qu'aucune scène n'appelle AVCine.onFrame().
       API :
         AVCine.onFrame(fn)      -> enregistre fn(t, state) dans la boucle
                                    rAF unique ; retourne une fonction de
                                    désinscription. La boucle s'arrête
                                    d'elle-même quand plus rien n'est inscrit.
         AVCine.progress(el)     -> 0..1 : traversée du viewport par el
         AVCine.pinProgress(el)  -> 0..1 : progression d'une scène épinglée
                                    (section plus haute que l'écran, .cine-viewport sticky)
         AVCine.state()          -> { scrollY, vw, vh, pointer{x,y,active}, reduced, isTouch }
         AVCine.reduced/isTouch  -> booléens d'environnement
       ============================================================ */
    window.AVCine = (function () {
      var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isTouch = window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches;
      var frames = new Set();
      var running = false;
      var vw = window.innerWidth, vh = window.innerHeight;
      var pointer = { x: 0.5, y: 0.5, active: false };

      function state() {
        return { scrollY: window.scrollY, vw: vw, vh: vh, pointer: pointer, reduced: reduced, isTouch: isTouch };
      }
      function loop(t) {
        if (!frames.size) { running = false; return; }
        var s = state();
        frames.forEach(function (fn) { try { fn(t, s); } catch (e) {} });
        requestAnimationFrame(loop);
      }
      function wake() { if (!running && frames.size) { running = true; requestAnimationFrame(loop); } }

      window.addEventListener('resize', function () { vw = window.innerWidth; vh = window.innerHeight; }, { passive: true });
      if (!isTouch) window.addEventListener('mousemove', function (e) {
        pointer.x = e.clientX / vw; pointer.y = e.clientY / vh; pointer.active = true;
      }, { passive: true });
      window.addEventListener('touchmove', function (e) {
        var t0 = e.touches && e.touches[0]; if (!t0) return;
        pointer.x = t0.clientX / vw; pointer.y = t0.clientY / vh; pointer.active = true;
      }, { passive: true });

      function progress(el, margin) {
        margin = margin || 0;
        var r = el.getBoundingClientRect();
        var total = r.height + vh - margin * 2;
        if (total <= 0) return 0;
        return Math.min(1, Math.max(0, (vh - margin - r.top) / total));
      }
      function pinProgress(el) {
        var r = el.getBoundingClientRect();
        var scrollable = r.height - vh;
        if (scrollable <= 0) return 0;
        return Math.min(1, Math.max(0, -r.top / scrollable));
      }

      return { onFrame: function (fn) { frames.add(fn); wake(); return function () { frames.delete(fn); }; },
               progress: progress, pinProgress: pinProgress, state: state,
               reduced: reduced, isTouch: isTouch };
    })();
    
;
(function(){
      var pl = document.querySelector('.intro-veil');
      if (!pl || !document.documentElement.classList.contains('js')) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var seen = false;
      try { seen = sessionStorage.getItem('av-seen') === '1'; } catch (e) {}
      // Adaptation à l'appareil : sur mobile, entrée immédiate (réseau/CPU limités)
      var skip = window.matchMedia('(max-width: 760px)').matches;
      var MIN = skip ? 0 : (reduced || seen) ? 600 : 2600, MAX = skip ? 400 : 4000;
      if (reduced || seen || skip) pl.classList.add('pl-fast');
      if (skip) pl.classList.add('pl-skip');
      var t0 = performance.now(), pct = 0, loaded = false, fin = false;
      window.addEventListener('load', function () { loaded = true; });
      var pctEl = document.getElementById('pl-pct'), bar = document.getElementById('pl-bar');
      function done() {
        if (fin) return;
        fin = true;
        pctEl.textContent = '100';
        if (bar) bar.style.transform = 'scaleX(1)';
        pl.classList.add('pl-out');
        document.documentElement.classList.add('av-go');
        try { window.dispatchEvent(new Event('av:go')); } catch (e) {}
        try { sessionStorage.setItem('av-seen', '1'); } catch (e) {}
        setTimeout(function () { if (pl.parentNode) pl.parentNode.removeChild(pl); }, 1200);
      }
      function frame(now) {
        var t = now - t0;
        var target = Math.min(99, t / MIN * 104);
        if (t >= MIN) target = 100.4;
        pct += (target - pct) * 0.11;
        if (t > MIN * 0.5) pl.classList.add('pl-s2');
        var v = Math.min(100, Math.round(pct));
        pctEl.textContent = v;
        if (bar) bar.style.transform = 'scaleX(' + (v / 100) + ')';
        if (pct >= 99.9) { done(); return; }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      setTimeout(done, MAX + 900);
    })();
;
(function(){if(window.matchMedia&&(matchMedia('(prefers-reduced-motion: reduce)').matches||matchMedia('(max-width: 760px)').matches))return;var t=document.querySelector('.hero-title');if(!t)return;var c=0,f=document.createDocumentFragment();Array.prototype.slice.call(t.childNodes).forEach(function(ch){function tok(s,cls){String(s).split(/(\s+)/).forEach(function(k){if(!k)return;if(/^\s+$/.test(k)){f.appendChild(document.createTextNode(' '));return;}var w=document.createElement('span');w.className='w';var i=document.createElement('span');i.className=cls?'wi '+cls:'wi';i.style.setProperty('--i',c++);i.textContent=k;w.appendChild(i);f.appendChild(w);});}if(ch.nodeType===3){tok(ch.textContent,'');}else if(ch.tagName==='BR'){f.appendChild(document.createElement('br'));}else{tok(ch.textContent,ch.className);}});t.innerHTML='';t.appendChild(f);t.classList.add('split');t.style.setProperty('--base','0.15s');requestAnimationFrame(function(){requestAnimationFrame(function(){t.classList.add('split-in');});});})();
;
window.AV_I18N = {"Faites défiler": "Scroll", "Passer l'intro": "Skip intro", "Introduction": "Introduction", "La version standard, prête à utiliser": "The standard version, ready to use","Carte NFC 29,99 € · Plaque NFC 34,99 €": "NFC card €29.99 · NFC plaque €34.99","Support programmé vers votre lien": "Programmed to your link","Prêt à utiliser dès réception": "Ready to use on arrival","La version personnalisée à votre image": "The personalised version, in your brand","Carte personnalisée 44,99 € · Plaque 59,99 €": "Personalised card €44.99 · plaque €59.99","Logo, couleurs et textes de votre marque": "Your brand's logo, colours and text","Aperçu en direct et validation du BAT": "Live preview and proof approval","QR code imprimé en option (+4,99 €)": "Printed QR code option (+€4.99)","Tous formats acceptés — PNG, JPG, SVG, PDF, AI, PSD, EPS… (25 Mo max)": "All formats accepted — PNG, JPG, SVG, PDF, AI, PSD, EPS… (25 MB max)","Fichier trop lourd (25 Mo max). Compressez votre fichier et réessayez.": "File too large (25 MB max). Compress your file and try again.","Voir toutes les questions": "See all questions","NFC & Sites web — Côte d'Azur": "NFC & Websites — French Riviera", "Aller au contenu principal": "Skip to main content", "Méthode": "Method", "Collection": "Collection", "Sites web": "Websites", "Tarifs": "Pricing", "Contact": "Contact", "Devis site web": "Website quote", "Ouvrir ou fermer le menu": "Open or close the menu", "Avis Azur — retour à l'accueil": "Avis Azur — back to home", "Navigation principale": "Main navigation", "Ouvrir le panier": "Open the cart", "Basés sur la Côte d'Azur": "Based on the French Riviera", "— livraison partout en France": "— delivery all over France", "La plaque NFC récolte vos avis. Le site internet les transforme en clients.": "The NFC plaque collects your reviews. The website turns them into customers.", "Deux leviers, un seul partenaire.": "Two levers, one partner.", "Commander ma plaque": "Order my plaque", "Créer mon site": "Build my website", "Aucune application requise": "No app required", "Configuration incluse": "Setup included", "Design personnalisé": "Custom design", "Sans abonnement": "No subscription", "Laissez-nous": "Leave us", "un avis": "a review", "Avis Google · Le Cannet": "Google Reviews · Le Cannet", "Publier mon avis": "Post my review", "Posez le téléphone sur la carte": "Rest your phone on the card", "La page d'avis s'ouvre — sans application": "The review page opens — no app needed", "L'avis est publié en 3 secondes": "The review is live in 3 seconds", "Découvrir": "Discover", "Pour laisser un avis": "To leave a review", "Coût pour le client": "Cost for your customer", "Plus d'avis en moyenne": "More reviews on average", "Prêt à l'emploi": "Ready to use", "Un geste — et vos clients atterrissent sur": "One tap — and your customers land on", "La méthode Avis Azur": "The Avis Azur method", "Chapitre 01 · La méthode Avis Azur": "Chapter 01 · The Avis Azur method", "La plaque récolte vos avis, Google vous met en avant, votre site convainc. Une seule chaîne — nous la fournissons de bout en bout.": "The plaque collects your reviews, Google pushes you up, your website seals the deal. One single chain — we provide it end to end.", "La plaque récolte vos avis": "The plaque collects your reviews", "Chaque client satisfait pose son téléphone sur la plaque : avis Google 5 étoiles publié en 3 secondes.": "Every happy customer rests their phone on the plaque: a 5-star Google review, live in 3 seconds.", "Voir la collection": "Browse the collection", "Google vous met en avant": "Google pushes you up", "Plus d'avis récents, meilleure place dans les recherches locales : les clients vous trouvent en premier.": "More recent reviews, a better spot in local searches: customers find you first.", "Effet automatique": "Automatic effect", "Votre site les convainc": "Your website seals the deal", "Ils cliquent et découvrent un site remarquable — puis appellent, réservent ou commandent.": "They click and discover a remarkable website — then call, book or order.", "Voir la création de site": "See website creation", "Chaque levier fonctionne séparément — ensemble, ils se renforcent.": "Each lever works on its own — together, they compound.", "Création de sites — notre second métier": "Website creation — our second craft", "On le construit": "We build it", "Vous êtes": "You are", "en ligne": "online", "Réserver": "Book", "En ligne ✓": "Online ✓", "Chiffres clés": "Key figures", "Création de votre site internet, en direct": "Your website, built live", "Levier nº1 · Récolter des avis": "Lever #1 · Collect reviews", "Choisissez votre support — livré": "Choose your product — delivered", "prêt à poser": "ready to use", ": design, programmation et accompagnement inclus.": ": design, programming and support included.", "Le plus polyvalent": "The most versatile", "Carte de visite NFC": "NFC business card", "Partagez coordonnées, réseaux et site d'un simple geste.": "Share your details, socials and website with a single tap.", "Idéal pour :": "Perfect for:", "indépendants, commerciaux, artisans.": "freelancers, sales reps, artisans.", "Voir la fiche produit": "View product page", "Ajouter au panier · 44,99 €": "Add to cart · €44.99", "★ Best-seller": "★ Best seller", "Laissez-nous un avis": "Leave us a review", "Plaque avis Google": "Google review plaque", "Une interaction ouvre votre fiche Google. Plus d'avis, plus de visibilité locale.": "One tap opens your Google listing. More reviews, more local visibility.", "salons, restaurants, hôtels, boutiques.": "salons, restaurants, hotels, shops.", "Ajouter au panier · 59,99 €": "Add to cart · €59.99", "Restauration": "Restaurants", "à chaque table": "on every table", "Menu NFC restaurant": "NFC restaurant menu", "Menu, allergènes et offres du jour, sur une plaque discrète à chaque table.": "Menu, allergens and daily specials, on a discreet plaque at every table.", "restaurants, bars, cafés.": "restaurants, bars, cafés.", "Location": "Rentals", "Bienvenue !": "Welcome!", "Wi-Fi · consignes": "Wi-Fi · house rules", "Support Airbnb & location": "Airbnb & rental stand", "Wi-Fi, consignes, bonnes adresses — tout pour vos voyageurs, en un geste.": "Wi-Fi, house rules, local tips — everything your guests need, in one tap.", "hôtes Airbnb, gîtes, hôtels.": "Airbnb hosts, guesthouses, hotels.", "Envie d'une carte à l'image de votre plateforme ?": "Want a card that matches your platform?", "Découvrez la collection ci-dessous.": "Browse the collection below.", "Aussi : bracelets, stickers, projets sur mesure — programmation incluse,": "Also: wristbands, stickers, custom projects — programming included,", "paiement par lien sécurisé": "payment by secure link", "après confirmation.": "after confirmation.", "Catégories de produits": "Product categories", "Produit précédent": "Previous product", "Produit suivant": "Next product", "Catalogue Avis Azur — faites défiler puis touchez un produit": "Avis Azur catalogue — scroll, then tap a product", "Tous les produits": "All products", "Quantité": "Quantity", "Réduire la quantité": "Decrease quantity", "Augmenter la quantité": "Increase quantity", "Ajouter au panier": "Add to cart", "Personnaliser": "Customise", "Voir la fiche produit complète": "View full product page", "Envie d'un modèle 100 % à votre image ?": "Want a design that is 100% you?", "Créez-le dans le configurateur": "Create it in the configurator", "— logo, couleurs, texte, aperçu immédiat.": "— logo, colours, text, instant preview.", "Prix unitaire · dégressif dès 10": "Unit price · volume discount from 10", "Tout": "All", "Avis Google": "Google Reviews", "Réseaux sociaux": "Social networks", "Plaques": "Plaques", "Cartes": "Cards", "Business": "Business", "Posée au comptoir, elle récolte vos avis toute la journée.": "On your counter, it collects reviews all day long.", "Fiche Google boostée": "Boosted Google listing", "Avis publié en 3 secondes": "Review posted in 3 seconds", "Comptoir ou murale": "Counter or wall-mounted", "Laissez-nous un avis !": "Leave us a review!", "Support rond": "Round disc", "Carte format bancaire": "Credit-card format card", "Plaques comptoir": "Counter plaques", "Ronds table & véhicule": "Round · table & vehicle", "Cartes de visite": "Business cards", "Sur mesure": "Bespoke", "Comptoir, caisse ou vitrine : chaque client satisfait devient un avis Google.": "Counter, till or window: every happy customer becomes a Google review.", "Comptoir · Caisse · Vitrine": "Counter · Till · Window", "À l’accueil ou en vitrine : votre communauté grandit toute seule.": "At the front desk or in the window: your community grows on its own.", "Vitrine · Comptoir · Accueil": "Window · Counter · Front desk", "Sur le comptoir : votre page suivie pendant l’attente.": "On the counter: your page followed while they wait.", "Comptoir · Salle d’attente": "Counter · Waiting room", "À la caisse : votre Snap ajouté le temps d’un passage.": "At the till: your Snap added in passing.", "Caisse · Comptoir": "Till · Counter", "Plaque Snapchat": "Snapchat plaque", "À l’accueil de l’entreprise : le réseau se construit tout seul.": "At the company front desk: the network builds itself.", "Accueil · Bureau · Salons": "Front desk · Office · Trade shows", "En vitrine : votre site s’ouvre sans taper d’adresse.": "In the window: your website opens with no address to type.", "Vitrine · Comptoir": "Window · Counter", "À l’accueil du logement : tout pour vos voyageurs.": "At the property entrance: everything your guests need.", "Logements · Hôtels": "Rentals · Hotels", "Wi-Fi & consignes": "Wi-Fi & house rules", "Rond WhatsApp véhicule": "WhatsApp vehicle disc", "Collé sur la vitre ou la portière : vos clients vous écrivent direct.": "Stuck on the window or door: customers message you directly.", "Taxis · VTC · Livreurs": "Taxis · Ride-hail · Couriers", "Se colle partout": "Sticks anywhere", "Menu NFC de table": "NFC table menu", "Posé sur chaque table : le menu s’ouvre d’un geste.": "On every table: the menu opens with a tap.", "Restaurants · Bars · Hôtels": "Restaurants · Bars · Hotels", "Posé sur la table": "Sits on the table", "La carte de visite qui ne s’épuise jamais.": "The business card that never runs out.", "Indépendants · Artisans": "Freelancers · Artisans", "Coordonnées en un geste": "Details in one tap", "Enregistrez-moi !": "Save my contact!", "Carte Contact NFC": "NFC Contact card", "Votre fiche contact enregistrée en un clic.": "Your contact file saved in one click.", "Rendez-vous · Salons": "Meetings · Trade shows", "Échange instantané": "Instant exchange", "Zéro papier": "Zero paper", "Carte Entreprise": "Company card", "Votre Société": "Your Company", "Équipe & collaborateurs": "Team & staff", "Toute votre équipe, une seule identité.": "Your whole team, one identity.", "Équipes · Commerciaux": "Teams · Sales reps", "Logo de la société": "Company logo", "Commande groupée": "Group order", "Découvrez-nous !": "Discover us!", "Carte Professionnelle": "Professional card", "Profession libérale": "Professional practice", "L’élégance d’un métier d’exigence.": "The elegance of a demanding profession.", "Avocats · Médecins · Conseil": "Lawyers · Doctors · Consulting", "Finition soignée": "Refined finish", "Image irréprochable": "Impeccable image", "Prenons rendez-vous !": "Let’s meet!", "Carte VIP": "VIP card", "Accès privilégié": "Privileged access", "Pour vos clients les plus précieux.": "For your most valued clients.", "Clubs · Conciergeries": "Clubs · Concierge services", "Fidélité & privilèges": "Loyalty & privileges", "Effet mémorable": "Memorable effect", "Bienvenue au club !": "Welcome to the club!", "Carte Digitale": "Digital card", "Profil Digital": "Digital Profile", "Tous vos liens": "All your links", "Tous vos réseaux et liens en une seule carte.": "All your networks and links in a single card.", "Créateurs · Freelances": "Creators · Freelancers", "Profil tout-en-un": "All-in-one profile", "Modifiable à volonté": "Editable at will", "Retrouvez-moi !": "Find me!", "Choisir : Plaque Snapchat": "Select: Snapchat plaque", "Choisir : Rond WhatsApp véhicule": "Select: WhatsApp vehicle disc", "Choisir : Menu NFC de table": "Select: NFC table menu", "Choisir : Carte de visite NFC": "Select: NFC business card", "Choisir : Carte Contact NFC": "Select: NFC Contact card", "Choisir : Carte Entreprise": "Select: Company card", "Choisir : Carte Professionnelle": "Select: Professional card", "Choisir : Carte VIP": "Select: VIP card", "Choisir : Carte Digitale": "Select: Digital card", "Votre métier · Votre ville": "Your trade · Your city", "Avis & Google": "Reviews & Google", "Business & services": "Business & services", "Plaque Avis Google": "Google Reviews plaque", "Plaque Facebook": "Facebook plaque", "Plaque TikTok": "TikTok plaque", "Plaque YouTube": "YouTube plaque", "Plaque LinkedIn": "LinkedIn plaque", "Plaque Discord": "Discord plaque", "Plaque Spotify": "Spotify plaque", "Plaque Apple Music": "Apple Music plaque", "Plaque Google Maps": "Google Maps plaque", "Plaque Contact NFC": "NFC Contact plaque", "Plaque Site Internet": "Website plaque", "Plaque E-mail": "Email plaque", "Plaque Boutique en ligne": "Online shop plaque", "Vos vidéos lancées d’un geste.": "Your videos launched with a tap.", "Abonnés en direct": "Subscribers on the spot", "Chaîne ouverte direct": "Channel opens instantly", "Zéro recherche": "No searching", "Regardez nos vidéos !": "Watch our videos!", "Votre communauté à un geste.": "Your community one tap away.", "Invitation instantanée": "Instant invite", "Serveur rejoint en 3 s": "Server joined in 3 s", "Communauté fidèle": "Loyal community", "Rejoignez le serveur !": "Join the server!", "Votre musique, sans rien chercher.": "Your music, no searching needed.", "Playlist ouverte direct": "Playlist opens instantly", "Abonnés artiste": "Artist followers", "Idéal bars & boutiques": "Great for bars & shops", "Écoutez-nous !": "Listen to us!", "Votre univers musical d’un geste.": "Your musical universe in one tap.", "Profil artiste direct": "Artist profile direct", "Playlist partagée": "Shared playlist", "Écoute immédiate": "Instant listening", "Notre playlist !": "Our playlist!", "On vous trouve du premier coup.": "They find you first time.", "Itinéraire en un geste": "Directions in one tap", "Fiche Google ouverte": "Google listing opens", "Idéal vitrines": "Great for storefronts", "Trouvez-nous !": "Find us!", "Comptoir ou accueil": "Counter or front desk", "Enregistrez-nous !": "Save our contact!", "Votre site s’ouvre — sans taper d’adresse.": "Your website opens — no address to type.", "Trafic direct": "Direct traffic", "Zéro faute de frappe": "No typos", "Image pro": "Professional image", "Visitez notre site !": "Visit our website!", "Un geste, un e-mail prêt à envoyer.": "One tap, an email ready to send.", "Adresse pré-remplie": "Pre-filled address", "Zéro erreur de saisie": "No typing errors", "Contact facile": "Easy contact", "Contactez-nous !": "Contact us!", "Votre boutique en ligne dans leur poche.": "Your online shop in their pocket.", "Panier direct": "Straight to cart", "Vitrine → vente": "Storefront → sale", "Idéal click & collect": "Great for click & collect", "Commandez en ligne !": "Order online!", "Écrivez-nous !": "Message us!", "Suivez notre page !": "Follow our page!", "Notre site": "Our website", "E-mail": "Email", "Boutique": "Shop", "Contact": "Contact", "Choisir : Plaque Avis Google": "Select: Google Reviews plaque", "Choisir : Plaque Facebook": "Select: Facebook plaque", "Choisir : Plaque TikTok": "Select: TikTok plaque", "Choisir : Plaque YouTube": "Select: YouTube plaque", "Choisir : Plaque LinkedIn": "Select: LinkedIn plaque", "Choisir : Plaque Discord": "Select: Discord plaque", "Choisir : Plaque Spotify": "Select: Spotify plaque", "Choisir : Plaque Apple Music": "Select: Apple Music plaque", "Choisir : Plaque Google Maps": "Select: Google Maps plaque", "Choisir : Plaque Contact NFC": "Select: NFC Contact plaque", "Choisir : Plaque Site Internet": "Select: Website plaque", "Choisir : Plaque E-mail": "Select: Email plaque", "Choisir : Plaque Boutique en ligne": "Select: Online shop plaque", "Choisir : Menu NFC restaurant": "Select: NFC restaurant menu", "Choisir : Plaque WhatsApp": "Select: WhatsApp plaque", "Choisir : Plaque Instagram": "Select: Instagram plaque", "Choisir : Support Airbnb": "Select: Airbnb stand", "Choisir : Plaque personnalisée": "Select: custom plaque", "Chapitre 02 · Notre second métier": "Chapter 02 · Our second craft", "Vos avis travaillent.": "Your reviews are working.", "Place à votre": "Now for your", "site": "website", "Des sites qui transforment vos visiteurs en clients — construits sous vos yeux.": "Websites that turn visitors into customers — built before your eyes.", "La plaque NFC récolte vos avis Google — posée au comptoir, prête en 3 secondes.": "The NFC plaque collects your Google reviews — on your counter, ready in 3 seconds.", "Sans application, sans abonnement, sans effort.": "No app, no subscription, no effort.", "Nous créons aussi des sites internet": "We also build websites", "Référencement local": "Local SEO", "Chargement éclair": "Lightning-fast loading", "Design sur mesure": "Bespoke design", "Notre second métier": "Our second craft", "« Laissez-nous un avis ! »": "“Leave us a review!”", "Levier nº1 · La collection": "Lever #1 · The collection", "Cartes format CB, plaques comptoir, sur mesure. Touchez un produit pour ouvrir sa fiche.": "Credit-card-size cards, counter plaques, bespoke. Tap a product to open its page.", "La version poche : tendez-la, l’avis est publié.": "The pocket version: hand it over, the review is live.", "Carte Avis Google": "Google review card", "Carte NFC Avis Google": "Google review NFC card", "Se glisse partout": "Fits anywhere", "Idéal en tournée & livraison": "Great on rounds & deliveries", "Avis en 3 secondes": "Review in 3 seconds", "Vos coordonnées, enregistrées en un clic.": "Your details, saved in one click.", "Enregistrez-moi !": "Save my contact!", "Carte de visite": "Business card", "Numéro, mail, site, réseaux": "Phone, email, website, socials", "Toujours à jour": "Always up to date", "Fini les cartes jetées": "No more binned cards", "Votre profil suivi en une seconde.": "Your profile followed in a second.", "Abonnés en direct": "Followers on the spot", "Portfolio vivant": "A living portfolio", "Un geste, un follow": "One tap, one follow", "La conversation commence d’un geste.": "The conversation starts with a tap.", "Restez en contact !": "Stay in touch!", "Message instantané": "Instant messaging", "Zéro numéro à taper": "No number to type", "Idéal devis & réservations": "Great for quotes & bookings", "Ajoutez-vous en un snap.": "Add yourself in a snap.", "Rejoignez-nous !": "Join us!", "Add instantané": "Instant add", "Audience jeune": "Young audience", "Vos stories suivies": "Your stories followed", "Vos vidéos, un geste suffit.": "Your videos, one tap away.", "Abonnez-vous !": "Follow us!", "Abonnés TikTok": "TikTok followers", "Profil ouvert direct": "Profile opens instantly", "Créateurs & commerces": "Creators & businesses", "Votre réseau pro se construit en un geste.": "Your professional network, built one tap at a time.", "Connectons-nous !": "Let’s connect!", "Networking sans friction": "Frictionless networking", "Salons & rendez-vous": "Trade shows & meetings", "Recruteurs & clients": "Recruiters & clients", "Votre page, vos avis, vos événements.": "Your page, your reviews, your events.", "Suivez notre page !": "Follow our page!", "Page suivie en un geste": "Page followed in one tap", "Avis Facebook": "Facebook reviews", "Communauté locale": "Local community", "En vitrine ou au comptoir : votre communauté grandit toute seule.": "In your window or on the counter: your community grows on its own.", "Visible de loin": "Visible from afar", "Fixation ou posée": "Mounted or freestanding", "Suivi en un geste": "Followed in one tap", "Vos clients vous écrivent sans taper votre numéro.": "Customers message you without typing your number.", "Réservations directes": "Direct bookings", "Comptoir ou vitrine": "Counter or window", "Votre logo, vos couleurs, votre texte — créez-la en direct.": "Your logo, your colours, your text — create it live.", "Votre design ici": "Your design here", "Aperçu immédiat": "Instant preview", "Votre identité": "Your identity", "Carte ou plaque": "Card or plaque", "Le menu du jour s’ouvre d’un geste — sans réimpression.": "Today’s menu opens with a tap — no reprinting.", "Découvrez la carte !": "See the menu!", "Menu resto": "Restaurant menu", "Menu toujours à jour": "Menu always up to date", "Allergènes & suggestions": "Allergens & specials", "Dégressif dès 10 tables": "Volume discount from 10 tables", "Wi-Fi, consignes, bonnes adresses — en un geste.": "Wi-Fi, house rules, local tips — in one tap.", "Wi-Fi partagé en un geste": "Wi-Fi shared in one tap", "Consignes à jour": "House rules up to date", "Commentaires 5 étoiles": "5-star guest reviews", "Posée sur le comptoir ou à table, elle transforme chaque client satisfait en avis Google — au moment exact où il est le plus content. Plus d'avis récents, plus de visibilité locale, plus de nouveaux clients.": "On the counter or the table, it turns every happy customer into a Google review — at the exact moment they are happiest. More recent reviews, more local visibility, more new customers.", "Discussion directe": "Direct conversation", "@votre-compte": "@your-account", "@votre-snap": "@your-snap", "Profil professionnel": "Professional profile", "Votre page": "Your page", "« Suivez-nous ! »": "“Follow us!”", "« Restez en contact ! »": "“Stay in touch!”", "Sur mesure": "Bespoke", "Votre design": "Your design", "« Votre design ici »": "“Your design here”", "« Découvrez la carte ! »": "“See the menu!”", "« Bienvenue ! »": "“Welcome!”", "Plaque Avis Google": "Google review plaque", "Plaque Instagram": "Instagram plaque", "Plaque WhatsApp": "WhatsApp plaque", "Plaque personnalisée": "Custom plaque", "Menu NFC": "NFC menu", "Support Airbnb": "Airbnb stand", "Carte NFC Instagram": "Instagram NFC card", "Carte NFC WhatsApp": "WhatsApp NFC card", "Carte NFC Snapchat": "Snapchat NFC card", "Carte NFC TikTok": "TikTok NFC card", "Carte NFC LinkedIn": "LinkedIn NFC card", "Carte NFC Facebook": "Facebook NFC card", "Choisir : Plaque avis Google": "Select: Google review plaque", "Choisir : Carte NFC Avis Google": "Select: Google review NFC card", "Choisir : Carte de visite NFC": "Select: NFC business card", "Choisir : Carte NFC Instagram": "Select: Instagram NFC card", "Choisir : Carte NFC WhatsApp": "Select: WhatsApp NFC card", "Choisir : Carte NFC Snapchat": "Select: Snapchat NFC card", "Choisir : Carte NFC TikTok": "Select: TikTok NFC card", "Choisir : Carte NFC LinkedIn": "Select: LinkedIn NFC card", "Choisir : Carte NFC Facebook": "Select: Facebook NFC card", "Choisir : Plaque Instagram": "Select: Instagram plaque", "Choisir : Plaque WhatsApp": "Select: WhatsApp plaque", "Choisir : Plaque personnalisée": "Select: custom plaque", "Choisir : Menu NFC": "Select: NFC menu", "Choisir : Support Airbnb": "Select: Airbnb stand", "Votre Nom": "Your Name", "Votre activité · Votre ville": "Your business · Your city", "vCard complète": "Full vCard", "Le configurateur": "The configurator", "Logo, couleurs, textes : composez votre carte ou votre plaque et voyez exactement ce que vous recevrez.": "Logo, colours, text: compose your card or plaque and see exactly what you will receive.", "Approchez votre téléphone": "Bring your phone close", "ou scannez le QR code": "or scan the QR code", "↻ Voir le verso": "↻ See the back", "↻ Voir le recto": "↻ See the front", "↶ Annuler": "↶ Undo", "Centrer le logo": "Centre the logo", "Réinitialiser": "Reset", "Personnalisez votre modèle": "Customise your design", "Personnalisez votre": "Customise your", "Votre support": "Your product", "Carte NFC": "NFC card", "format carte bancaire": "credit-card format", "Plaque NFC": "NFC plaque", "carrée, comptoir & vitrine": "square, counter & window", "Le fond": "Background", "Navy Azur": "Navy Azur", "Noir": "Black", "Ivoire": "Ivory", "Couleur réseau": "Platform colour", "Couleur": "Colour", "Couleur personnalisée": "Custom colour", "La plateforme": "Platform", "(optionnel)": "(optional)", "Aucune plateforme": "No platform", "Vos textes": "Your text", "Nom affiché — ex. Salon Sofia": "Displayed name — e.g. Salon Sofia", "Sous-titre — ex. Coiffure · Le Cannet": "Subtitle — e.g. Hair salon · Le Cannet", "Votre logo ou votre design": "Your logo or your design", "Choisissez un fichier": "Choose a file", "ou déposez-le ici": "or drop it here", "Tous formats acceptés — PNG, JPG, SVG, PDF, AI, PSD, EPS… (25 Mo max)": "All formats accepted — PNG, JPG, SVG, PDF, AI, PSD, EPS… (25 MB max)", "Logo": "Logo", "Design complet": "Full design", "Taille du logo": "Logo size", "Rotation": "Rotation", "Rotation du logo": "Logo rotation", "Glissez votre logo directement sur l'aperçu pour le placer.": "Drag your logo straight onto the preview to position it.", "Retirer le fichier": "Remove the file", "Votre fichier reste sur votre appareil — après la commande, nous vous recontactons pour récupérer l'original en haute définition et valider le BAT ensemble.": "Your file stays on your device — after your order, we contact you to collect the high-definition original and approve the proof together.", "Format non pris en charge — envoyez un PNG, JPG, SVG ou WebP.": "Unsupported format — send a PNG, JPG, SVG or WebP.", "Fichier trop lourd (10 Mo max). Compressez votre image et réessayez.": "File too large (10 MB max). Compress your image and try again.", "Image illisible — essayez un autre fichier.": "Unreadable image — try another file.", "Format paysage détecté : appliqué en design complet. Passez sur « Logo » pour le réduire.": "Landscape format detected: applied as a full design. Switch to “Logo” to shrink it.", "Logo détecté : glissez-le directement sur l'aperçu pour le placer.": "Logo detected: drag it straight onto the preview to position it.", "Fond": "Background", "design complet fourni": "full design provided", "logo fourni": "logo provided", "Votre logo": "Your logo", "Levier nº2 · Convertir en clients": "Lever #2 · Convert into customers", "Des sites cinématiques comme celui-ci — pensés pour convertir.": "Cinematic websites like this one — built to convert.", "Cinématique & ultra-rapide": "Cinematic & lightning fast", "Animations de niveau international, chargement éclair, mobile parfait.": "World-class animations, instant loading, flawless mobile.", "Référencement local Google": "Local Google SEO", "Votre commerce trouvé à Cannes, Mougins, Nice — données structurées incluses.": "Your business found in Cannes, Mougins, Nice — structured data included.", "Couplé à vos plaques NFC": "Paired with your NFC plaques", "La plaque ouvre votre site. Personne d'autre ne vend ce duo.": "The plaque opens your website. Nobody else sells this duo.", "À partir de 890 € — et votre démo est sous vos yeux :": "From €890 — and the demo is right in front of you:", "ce site est notre vitrine.": "this website is our showcase.", "Nos formules": "Our plans", "Formules indicatives, adaptables à votre projet. Devis personnalisé sous 24h.": "Indicative plans, tailored to your project. Personalised quote within 24h.", "Essentiel": "Essential", "Pour démarrer simplement": "To start simply", "À partir de": "From", "Un support NFC standard": "One standard NFC product", "Programmation du lien": "Link programming", "Design simple": "Simple design", "Assistance à la mise en service": "Setup assistance", "Choisir un modèle": "Choose a model", "★ Le plus choisi": "★ Most popular", "Professionnel": "Professional", "La formule complète": "The complete plan", "Support NFC personnalisé": "Customised NFC product", "Logo et couleurs de votre marque": "Your brand’s logo and colours", "Page de destination personnalisée": "Custom landing page", "Programmation complète": "Full programming", "QR code complémentaire": "Backup QR code", "Assistance dédiée": "Dedicated support", "Personnaliser le mien": "Customise mine", "Pour projets ambitieux": "For ambitious projects", "Tarif": "Price", "Sur devis": "On quote", "Plusieurs supports": "Multiple products", "Design entièrement personnalisé": "Fully custom design", "Installation possible sur place": "On-site installation available", "Pages et liens multiples": "Multiple pages and links", "Accompagnement personnalisé": "Personalised guidance", "Solutions multi-établissements": "Multi-location solutions", "Parler sur WhatsApp": "Chat on WhatsApp", "Prix TTC. Tarif dégressif dès 2 exemplaires — jusqu'à −33 % en volume, appliqué automatiquement. QR code imprimé +4,99 € · socle en option +7,99 €.": "Prices incl. tax. Volume pricing from 2 units — up to −33%, applied automatically. Printed QR code +€4.99 · stand optional +€7.99.", "★ Le duo gagnant": "★ The winning duo", "Pack Visibilité — plaque avis": "Visibility Pack — review plaque", "site internet": "website", "Les deux leviers en une seule commande : la plaque fait grimper vos avis, le site transforme les visites en clients. Tarif pack avantageux, étudié sur devis.": "Both levers in a single order: the plaque grows your reviews, the website turns visits into customers. Advantageous pack price, quoted individually.", "Devis du pack": "Pack quote", "Sans abonnement — support à vie": "No subscription — product for life", "NFC + QR code inclus": "NFC + QR code included", "Compatible iPhone & Android": "Works with iPhone & Android", "Ils nous font confiance": "They trust us", "Exemples — à remplacer par vos vrais avis.": "Examples — to be replaced with your real reviews.", "Depuis qu'on a posé la plaque à l'accueil, les avis Google tombent tous seuls après chaque rendez-vous. Un vrai game changer pour le salon.": "Since we placed the plaque at the front desk, Google reviews roll in on their own after every appointment. A real game changer for the salon.", "Salon de coiffure — Le Cannet": "Hair salon — Le Cannet", "Une carte NFC beaucoup plus classe qu'un bristol qui traîne dans une poche. Je partage mes coordonnées d'un geste, mes clients sont bluffés.": "An NFC card far classier than a paper card lost in a pocket. I share my details with one tap — my clients are amazed.", "Agent immobilier — Cannes": "Real-estate agent — Cannes", "Les voyageurs trouvent le Wi-Fi, les infos du logement et les bonnes adresses du coin en approchant leur téléphone. Zéro question, zéro appel.": "Guests find the Wi-Fi, the house info and the best local spots just by tapping their phone. Zero questions, zero calls.", "Hôte Airbnb — Antibes": "Airbnb host — Antibes", "On a équipé chaque table avec un menu NFC. Les serveurs gagnent un temps fou et les cartes sont toujours à jour. Bluffant.": "We fitted every table with an NFC menu. Waiters save a huge amount of time and the menus are always current. Stunning.", "Restaurant — Antibes": "Restaurant — Antibes", "J'ai équipé toute l'agence. Nos clients partagent nos annonces d'un simple geste, et le rendu très chic colle parfaitement à notre positionnement.": "I equipped the whole agency. Our clients share our listings with a single tap, and the very chic finish fits our positioning perfectly.", "Agence immobilière — Nice": "Real-estate agency — Nice", "Service impeccable et livraison rapide. Le design personnalisé aux couleurs de mon institut est superbe. Mes clientes adorent.": "Impeccable service and fast delivery. The custom design in my salon’s colours is superb. My clients love it.", "Institut de beauté — Mougins": "Beauty salon — Mougins", "Cannes · Nice · Antibes · Monaco — et livraison partout en France.": "Cannes · Nice · Antibes · Monaco — and delivery all over France.", "Parler de mon projet": "Discuss my project", "Témoignage précédent": "Previous testimonial", "Témoignage suivant": "Next testimonial", "Choisir un témoignage": "Choose a testimonial", "Aller au groupe 1": "Go to group 1", "Aller au groupe 2": "Go to group 2", "Aller au groupe 3": "Go to group 3", "Aller au groupe 4": "Go to group 4", "Ancrés sur la Côte d'Azur": "Rooted on the French Riviera", "Nos garanties": "Our guarantees", "5 étoiles": "5 stars", "Vous vous demandez…": "You might be wondering…", "Qu'est-ce qu'une puce NFC ?": "What is an NFC chip?", "Une puce NFC est un tout petit composant sans pile qui contient une information (un lien, un contact, un texte). Lorsqu'un smartphone compatible l'approche, il lit cette information et propose l'action correspondante.": "An NFC chip is a tiny battery-free component that holds a piece of information (a link, a contact, a text). When a compatible smartphone comes close, it reads it and offers the matching action.", "Faut-il télécharger une application ?": "Do I need to download an app?", "Non, dans la très grande majorité des cas. La lecture NFC est intégrée nativement aux smartphones récents.": "No, in the vast majority of cases. NFC reading is built natively into recent smartphones.", "Le NFC fonctionne-t-il sur iPhone et Android ?": "Does NFC work on iPhone and Android?", "Oui. Les iPhone récents et la plupart des téléphones Android lisent le NFC. Sur certains iPhone anciens, l'activation peut se faire via l'appareil photo ou le centre de contrôle.": "Yes. Recent iPhones and most Android phones read NFC. On some older iPhones, it can be activated via the camera or the control centre.", "Peut-on modifier le lien après la livraison ?": "Can the link be changed after delivery?", "Cela dépend de la solution choisie. Avec une page de destination que nous gérons, vous pouvez faire évoluer le contenu sans changer de support. Certaines puces peuvent aussi être reprogrammées.": "It depends on the chosen solution. With a landing page we manage, you can update the content without changing the product. Some chips can also be reprogrammed.", "Combien de temps pour recevoir la commande ?": "How long until I receive my order?", "Le délai dépend du support, du niveau de personnalisation et de la quantité. Nous communiquons un délai précis lors du devis — généralement 5 à 15 jours ouvrés.": "Lead time depends on the product, the level of customisation and the quantity. We confirm a precise date with the quote — usually 5 to 15 working days.", "Proposez-vous la création de sites internet ?": "Do you build websites?", "Oui. Nous créons des sites vitrines modernes, rapides et optimisés pour Google — souvent couplés à vos supports NFC : la plaque ou la carte ouvre directement votre site.": "Yes. We build modern, fast, Google-optimised showcase websites — often paired with your NFC products: the plaque or card opens your website directly.", "Parlons de votre projet": "Let’s talk about your project", "Un site pensé pour votre image, votre activité et vos objectifs — configurez votre projet en 2 minutes.": "A website designed around your image, your business and your goals — set up your project in 2 minutes.", "Contactez-nous": "Contact us", "Basés à Mougins, à votre écoute du lundi au samedi.": "Based in Mougins, at your service Monday to Saturday.", "Mougins — 06250 Côte d'Azur": "Mougins — 06250 French Riviera", "Cannes · Nice · Monaco · Antibes": "Cannes · Nice · Monaco · Antibes", "Nous contacter sur WhatsApp": "Contact us on WhatsApp", "Votre fiche projet": "Your project brief", "5 étapes, 2 minutes — vos données restent confidentielles.": "5 steps, 2 minutes — your data stays confidential.", "Étape 01 · Votre activité": "Step 01 · Your business", "Quelle est votre": "What is your", "activité": "business", "Restaurant": "Restaurant", "Hôtel / Airbnb": "Hotel / Airbnb", "Commerce": "Shop", "Artisan": "Artisan", "Entreprise": "Company", "Indépendant": "Freelancer", "Agence": "Agency", "Autre": "Other", "Quel est votre": "What is your", "projet": "project", "Site vitrine": "Showcase website", "E-commerce": "E-commerce", "Refonte d’un site": "Website redesign", "Landing page": "Landing page", "Site personnalisé": "Custom website", "De quoi votre site a-t-il": "What does your website", "besoin": "need", "(plusieurs choix possibles)": "(multiple choices allowed)", "Présentation de l’entreprise": "Company presentation", "Prise de rendez-vous": "Appointment booking", "Vente en ligne": "Online sales", "Réservation": "Booking", "Formulaire de contact": "Contact form", "Référencement Google (SEO)": "Google search ranking (SEO)", "Votre": "Your", "identité visuelle": "visual identity", "Un logo ?": "A logo?", "Disponible": "Available", "À créer": "To be created", "Une charte graphique ?": "Brand guidelines?", "Des photos ?": "Photos?", "Disponibles": "Available", "À prévoir": "To be planned", "Vos éléments": "Your assets", "(logo, images, PDF, vidéos, documents — optionnel)": "(logo, images, PDF, videos, documents — optional)", "Ajoutez vos fichiers": "Add your files", "ou glissez-les ici": "or drag them here", "Logo · photos · charte graphique · PDF · vidéos — 25 Mo max par fichier": "Logo · photos · brand guidelines · PDF · videos — 25 MB max per file", "Vos fichiers restent sur votre appareil — après votre demande, nous vous envoyons un lien sécurisé pour nous les transmettre.": "Your files stay on your device — after your request, we send you a secure link to share them with us.", "15 fichiers maximum — retirez-en un pour continuer.": "15 files maximum — remove one to continue.", "Fichier trop lourd (25 Mo max) : ": "File too large (25 MB max): ", "Retirer ce fichier": "Remove this file", "fichier": "file", "fichiers": "files", "Aucun fichier (envoi possible ensuite)": "No files (can be sent later)", "coordonnées": "contact details", "Nom et prénom": "Full name", "Nom de l'entreprise": "Company name", "Téléphone": "Phone", "Adresse e-mail": "Email address", "Un mot sur votre projet": "A word about your project", "Ambiance souhaitée, exemples de sites aimés, délai…": "Desired mood, websites you like, timeline…", "J'accepte que mes informations soient utilisées pour être recontacté, conformément à la": "I agree that my information may be used to contact me back, in accordance with the", "politique de confidentialité": "privacy policy", "est prêt": "is ready", "Modifier": "Edit", "Envoyer ma demande": "Send my request", "← Retour": "← Back", "Continuer →": "Continue →", "Réponse sous 24h · Sans engagement · Données confidentielles": "Reply within 24h · No commitment · Confidential data", "Activité": "Business", "Type de site": "Website type", "Besoins": "Needs", "Identité": "Identity", "Éléments": "Assets", "À préciser ensemble": "To be defined together", "Merci de renseigner nom, téléphone, e-mail valide et d'accepter la politique de confidentialité.": "Please provide your name, phone, a valid email, and accept the privacy policy.", "Ce champ est requis.": "This field is required.", "Nom et prénom *": "Full name *", "Téléphone *": "Phone *", "Adresse e-mail *": "Email address *", "Adresse de livraison": "Delivery address", "Précisions (logo, couleurs, lien Google…)": "Details (logo, colours, Google link…)", "Plaques avis Google": "Google review plaques", "Cartes de visite NFC": "NFC business cards", "Sites internet": "Websites", "Menus NFC": "NFC menus", "Supports Airbnb": "Airbnb stands", "Votre commerce mérite": "Your business deserves", "d’être": "to be", "remarqué": "noticed", "Une plaque qui récolte vos avis. Un site qui convertit. La Côte d’Azur comme signature.": "A plaque that collects your reviews. A website that converts. The French Riviera as a signature.", "↑ Revivre l’expérience": "↑ Relive the experience", "Épilogue": "Epilogue", "Un geste pour partager, connecter, fidéliser.": "One tap to share, connect and retain.", "Navigation": "Navigation", "Accueil": "Home", "La méthode": "The method", "La collection": "The collection", "Création de sites": "Website creation", "Informations": "Information", "Mentions légales": "Legal notice", "Politique de confidentialité": "Privacy policy", "CGV": "Terms of sale", "— NFC & création de sites internet sur la Côte d'Azur. Tous droits réservés.": "— NFC & website creation on the French Riviera. All rights reserved.", "Retour en haut de la page": "Back to top", "06 37 87 11 19 · Côte d'Azur": "06 37 87 11 19 · French Riviera", "Fiche produit": "Product page", "Fermer la fiche produit": "Close the product page", "CARTE DE VISITE NFC": "NFC BUSINESS CARD", "Suivez-nous !": "Follow us!", "Un geste — tous vos réseaux": "One tap — all your socials", "La carte de visite qui ne s'épuise jamais : un geste, et votre interlocuteur reçoit votre fiche contact, votre site et vos réseaux. Vous changez de numéro ? Le lien se met à jour — la carte, elle, reste.": "The business card that never runs out: one tap, and the person you meet receives your contact file, your website and your socials. New number? The link updates — the card stays.", "Comment ça marche": "How it works", "Approchez le téléphone de la carte": "Bring the phone close to the card", "Votre profil s'affiche — sans application": "Your profile appears — no app needed", "Vos coordonnées sont enregistrées en un clic": "Your details are saved in one click", "Caractéristiques & contenu": "Features & contents", "Format carte bancaire": "Credit-card format", "NFC + QR code": "NFC + QR code", "iPhone & Android": "iPhone & Android", "Sans application": "No app needed", "Inclus dans votre commande": "Included in your order", "Carte NFC programmée avec votre lien": "NFC card programmed with your link", "QR code de secours intégré": "Built-in backup QR code", "Design à vos couleurs (formule Professionnel)": "Design in your colours (Professional plan)", "Lien modifiable après livraison, selon la solution choisie": "Link editable after delivery, depending on the chosen solution", "Livraison & paiement": "Delivery & payment", "Paiement <strong>sécurisé</strong> — visuel sur demande avant fabrication": "Secure payment — <strong>proof on request</strong> before production", "lien sécurisé": "secure link", "après confirmation": "after confirmation", "Livraison": "Delivery", "5 à 15 jours ouvrés": "5 to 15 working days", ", partout en France": ", anywhere in France", "Assistance incluse": "Support included", "jusqu'à la mise en service": "until everything is up and running", "Faut-il une application ?": "Is an app required?", "Non. La lecture NFC est intégrée aux smartphones récents — et un QR code de secours couvre les autres.": "No. NFC reading is built into recent smartphones — and a backup QR code covers the rest.", "Je change de numéro ou de poste ?": "What if I change number or role?", "Le lien de la carte est modifiable après livraison, selon la solution choisie : la carte reste, le contenu évolue.": "The card’s link can be changed after delivery, depending on the chosen solution: the card stays, the content evolves.", "Combien de temps pour la recevoir ?": "How long until it arrives?", "5 à 15 jours ouvrés selon la personnalisation et la quantité — délai précis confirmé à la commande.": "5 to 15 working days depending on customisation and quantity — exact date confirmed at order.", "Une question ?": "A question?", "WhatsApp direct": "Direct WhatsApp", "— réponse rapide.": "— quick reply.", "Le client pose son téléphone sur la plaque": "The customer rests their phone on the plaque", "Votre page d'avis Google s'ouvre instantanément": "Your Google review page opens instantly", "L'avis 5 étoiles est publié en 3 secondes": "The 5-star review is live in 3 seconds", "Comptoir ou fixation murale": "Counter or wall mounting", "Plaque programmée vers votre fiche Google": "Plaque programmed to your Google listing", "Lien direct « laisser un avis » réglé sur votre établissement": "Direct “leave a review” link set to your business", "QR code intégré pour les téléphones plus anciens": "Built-in QR code for older phones", "Personnalisation logo & couleurs (formule Professionnel)": "Logo & colour customisation (Professional plan)", "Non. Le client pose son téléphone, votre page d'avis Google s'ouvre — un QR code de secours couvre les téléphones plus anciens.": "No. The customer rests their phone, your Google review page opens — a backup QR code covers older phones.", "Compatible iPhone et Android ?": "Works with iPhone and Android?", "Oui. Les iPhone récents et la quasi-totalité des Android lisent le NFC nativement.": "Yes. Recent iPhones and nearly all Android phones read NFC natively.", "Peut-on changer le lien plus tard ?": "Can the link be changed later?", "Oui, selon la solution choisie : page de destination modifiable sans changer de plaque, ou puce reprogrammable.": "Yes, depending on the chosen solution: an editable landing page without changing the plaque, or a reprogrammable chip.", "Entrées · Plats · Desserts": "Starters · Mains · Desserts", "Allergènes & suggestions du jour": "Allergens & today’s specials", "Posez votre téléphone": "Rest your phone here", "Une plaque élégante à chaque table : vos clients ouvrent le menu du jour, les allergènes et vos suggestions — toujours à jour, sans jamais réimprimer.": "An elegant plaque on every table: your customers open today’s menu, allergens and specials — always current, never reprinted.", "Le client approche son téléphone de la plaque": "The customer brings their phone to the plaque", "Votre menu s'ouvre : plats, prix, allergènes": "Your menu opens: dishes, prices, allergens", "Vous modifiez le contenu quand vous voulez": "You update the content whenever you want", "Format table & comptoir": "Table & counter format", "Menu modifiable à volonté": "Menu editable at will", "Support programmé vers votre menu en ligne": "Stand programmed to your online menu", "QR code intégré": "Built-in QR code", "Lien modifiable : changement de carte, offres du jour": "Editable link: menu changes, daily offers", "Tarif dégressif à partir de 10 tables": "Volume discount from 10 tables", "Comment mettre à jour mon menu ?": "How do I update my menu?", "Vous modifiez le contenu du lien quand vous voulez — carte du jour, allergènes, suggestions — sans jamais réimprimer.": "You update the link’s content whenever you want — today’s menu, allergens, specials — without ever reprinting.", "Non. Le client approche son téléphone de la plaque et le menu s'ouvre — QR code de secours inclus.": "No. The customer brings their phone to the plaque and the menu opens — backup QR code included.", "J'ai plusieurs tables ?": "I have several tables?", "Tarif dégressif à partir de 10 exemplaires — idéal pour équiper toute la salle.": "Volume discount from 10 units — perfect for fitting out the whole room.", "Wi-Fi · Code d'entrée": "Wi-Fi · Entry code", "Consignes · Bonnes adresses": "House rules · Local tips", "Le compagnon de vos voyageurs : Wi-Fi, consignes d'arrivée, bonnes adresses et demande de commentaire — réunis sur un support élégant posé dans l'entrée.": "Your guests’ companion: Wi-Fi, check-in instructions, local tips and a review request — together on an elegant stand in the entrance.", "Le voyageur pose son téléphone sur le support": "The guest rests their phone on the stand", "Votre page d'accueil s'ouvre : Wi-Fi, consignes, adresses": "Your welcome page opens: Wi-Fi, rules, addresses", "À son départ, il laisse son commentaire 5 étoiles": "At checkout, they leave their 5-star review", "Posé ou fixé dans le logement": "Freestanding or mounted in the property", "Contenu modifiable": "Editable content", "Support programmé vers votre page voyageurs": "Stand programmed to your guest page", "Contenu modifiable à distance, selon la solution choisie": "Content editable remotely, depending on the chosen solution", "Page voyageurs personnalisée (formule Professionnel)": "Custom guest page (Professional plan)", "Mes voyageurs doivent-ils installer une app ?": "Do my guests need to install an app?", "Non. Un geste du téléphone sur le support et votre page d'accueil s'ouvre — QR code de secours inclus.": "No. One tap of the phone on the stand and your welcome page opens — backup QR code included.", "Puis-je modifier le Wi-Fi ou les consignes ?": "Can I update the Wi-Fi or house rules?", "Oui, le contenu est modifiable à distance selon la solution choisie — le support, lui, ne change pas.": "Yes, the content can be updated remotely depending on the chosen solution — the stand itself never changes.", "Compatible avec tous les téléphones ?": "Compatible with every phone?", "iPhone récents et quasi-totalité des Android lisent le NFC nativement ; le QR code couvre le reste.": "Recent iPhones and nearly all Androids read NFC natively; the QR code covers the rest.", "votre téléphone": "your phone", "le QR code": "the QR code", "Carte": "Card", "Plaque": "Plaque", "Votre client approche son téléphone de la carte": "Your customer brings their phone to the card", "Votre profil s'ouvre — sans application": "Your profile opens — no app needed", "Il vous suit, vous écrit ou vous enregistre — en 3 secondes": "They follow you, message you or save you — in 3 seconds", "Carte NFC programmée vers votre profil": "NFC card programmed to your profile", "Non. La lecture NFC est intégrée aux smartphones récents — et le QR code de secours couvre les autres.": "No. NFC reading is built into recent smartphones — and the backup QR code covers the rest.", "Je change de compte ou de lien ?": "What if I change account or link?", "Le lien est modifiable après livraison, selon la solution choisie : la carte reste, le contenu évolue.": "The link can be changed after delivery, depending on the chosen solution: the card stays, the content evolves.", "Carte, plaque ou sticker ?": "Card, plaque or sticker?", "La carte se glisse dans la poche, la plaque s'installe au comptoir, le sticker se colle partout. Même puce, même lien — précisez le format souhaité au devis ou en commentaire de commande.": "The card slips into a pocket, the plaque sits on the counter, the sticker goes anywhere. Same chip, same link — state your preferred format in the quote or order note.", "Plaque comptoir & vitrine": "Counter & window plaque", "Votre carte NFC": "Your NFC card", "La plaque comptoir assortie": "The matching counter plaque", "Formats": "Formats", "Format carte": "Card format", "Format plaque": "Plaque format", "Visuels du produit": "Product visuals", "Visuel carte": "Card visual", "Visuel réseaux sociaux": "Social networks visual", "Visuel plaque": "Plaque visual", "Visuel menu": "Menu visual", "Visuel support": "Stand visual", "Photo 1": "Photo 1", "Photo 2": "Photo 2", "Carte de visite NFC Avis Azur": "Avis Azur NFC business card", "Carte NFC réseaux sociaux : Google, Instagram, Snapchat, WhatsApp, TikTok": "Social NFC card: Google, Instagram, Snapchat, WhatsApp, TikTok", "Plaque avis Google Avis Azur": "Avis Azur Google review plaque", "Menu NFC restaurant Avis Azur": "Avis Azur NFC restaurant menu", "Support Airbnb et location Avis Azur": "Avis Azur Airbnb & rental stand", "Ajouté": "Added", "ajouté au panier": "added to cart", "Voir le panier": "View cart", "Votre panier": "Your cart", "Votre panier est vide.": "Your cart is empty.", "Ajoutez une plaque ou une carte NFC.": "Add an NFC plaque or card.", "Découvrir la collection": "Browse the collection", "Total": "Total", "Paiement par": "Payment by", "envoyé après confirmation — aucun débit maintenant.": "— secure payment, proof on request before production.", "Valider ma commande": "Place my order", "← Continuer mes achats": "← Continue shopping", "Finaliser ma commande": "Complete my order", "Finaliser la commande": "Complete the order", "Récapitulatif :": "Summary:", "Confirmer ma commande": "Confirm my order", "Confirmation sous 24h · Paiement sécurisé · Visuel sur demande": "Confirmation within 24h · Payment by secure link · No commitment", "Commande reçue !": "Order received!", "Merci ! Nous vous confirmons la commande sous 24h avec le": "Thank you! We confirm your order within 24h with the", "lien de paiement sécurisé": "secure payment link", "et le point de départ de la personnalisation.": "and the starting point of your customisation.", "Panier": "Cart", "Fermer le panier": "Close the cart", "Fermer": "Close", "Aperçu statique — pour l'expérience animée, ouvrez ce fichier dans": "Static preview — for the animated experience, open this file in", "Safari ou Chrome": "Safari or Chrome", "Informations légales": "Legal information", "Éditeur du site": "Website publisher", "— Solutions NFC & création de sites internet.": "— NFC solutions & website creation.", "Mougins — 06250, Côte d'Azur, France.": "Mougins — 06250, French Riviera, France.", "Téléphone :": "Phone:", "· E-mail :": "· Email:", "SIREN : 108 508 508 — Registre national des entreprises.": "SIREN: 108 508 508 — French national business register.", "Forme juridique et directeur de la publication :": "Legal form and publication director:", "à compléter avant mise en ligne": "to be completed before going live", "Hébergement": "Hosting", "Nom et coordonnées de l'hébergeur du site :": "Name and contact details of the website host:", "à compléter": "to be completed", "(ex. OVH, o2switch, Netlify…).": "(e.g. OVH, o2switch, Netlify…).", "Propriété intellectuelle": "Intellectual property", "L'ensemble des contenus de ce site (textes, visuels, logo, design) est la propriété d'Avis Azur, sauf mention contraire. Toute reproduction sans autorisation écrite préalable est interdite.": "All contents of this website (texts, visuals, logo, design) are the property of Avis Azur unless stated otherwise. Any reproduction without prior written consent is prohibited.", "Données collectées": "Data collected", "Via les formulaires de devis et de commande : nom et prénom, entreprise, téléphone, e-mail, ville, adresse de livraison, secteur d'activité et description du projet. Aucune donnée n'est collectée à votre insu ; ce site n'utilise pas de cookies de suivi publicitaire.": "Through the quote and order forms: full name, company, phone, email, city, delivery address, business sector and project description. No data is collected without your knowledge; this website uses no advertising tracking cookies.", "Finalité et base légale": "Purpose and legal basis", "Ces informations servent uniquement à établir votre devis et à vous recontacter (base légale : votre consentement, exprimé via la case à cocher du formulaire). Elles ne sont ni vendues ni transmises à des tiers.": "This information is used solely to prepare your quote and contact you back (legal basis: your consent, given via the form checkbox). It is neither sold nor shared with third parties.", "Durée de conservation": "Retention period", "Les données sont conservées au maximum 3 ans après le dernier contact, puis supprimées.": "Data is kept for a maximum of 3 years after the last contact, then deleted.", "Vos droits (RGPD)": "Your rights (GDPR)", "Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité. Pour l'exercer :": "You have the right to access, rectify, erase, object and port your data. To exercise it:", ". Vous pouvez également saisir la CNIL (cnil.fr).": ". You may also contact the CNIL (cnil.fr).", "Conditions générales de vente": "Terms of sale", "Objet": "Purpose", "Les présentes CGV encadrent la vente de supports NFC personnalisés (cartes, plaques, stickers, bracelets) et des prestations associées (design, programmation, configuration), ainsi que la création de sites internet, par Avis Azur (SIREN 108 508 508), Mougins — 06250.": "These terms govern the sale of customised NFC products (cards, plaques, stickers, wristbands) and related services (design, programming, setup), as well as website creation, by Avis Azur (SIREN 108 508 508), Mougins — 06250.", "Devis et commande": "Quote and order", "Toute commande fait l'objet d'un devis gratuit, valable 30 jours, ou peut être passée directement sur le site. La commande est confirmée à l'acceptation du devis ou du récapitulatif envoyé par e-mail, puis au règlement du lien de paiement sécurisé transmis.": "Every order is covered by a free quote, valid for 30 days, or can be placed directly on the website. The order is confirmed upon acceptance of the quote or emailed summary, then upon payment of the secure payment link provided.", "Prix et paiement": "Prices and payment", "Les prix affichés sur le site sont indicatifs, exprimés en euros TTC. Le prix définitif figure sur le devis. Tarifs dégressifs à partir de 10 exemplaires.": "Prices shown on the website are indicative, in euros including VAT. The final price appears on the quote. Volume discounts from 10 units.", "Délais et livraison": "Lead times and delivery", "Délai indicatif de 5 à 15 jours ouvrés selon le support, la quantité et le niveau de personnalisation. Livraison en France ; intervention possible sur place sur la Côte d'Azur.": "Indicative lead time of 5 to 15 working days depending on product, quantity and customisation level. Delivery within France; on-site service available on the French Riviera.", "Rétractation et garanties": "Withdrawal and warranties", "Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux biens personnalisés. Les supports bénéficient des garanties légales de conformité et des vices cachés. En cas de défaut de programmation, le support est reprogrammé ou remplacé sans frais.": "In accordance with article L221-28 of the French Consumer Code, the right of withdrawal does not apply to personalised goods. Products are covered by the legal warranties of conformity and hidden defects. In case of a programming fault, the product is reprogrammed or replaced free of charge.", "Document type à faire valider par un professionnel du droit avant mise en ligne.": "Template document to be validated by a legal professional before going live.", "Professionnel partageant sa carte de visite NFC d'un geste": "Professional sharing their NFC business card with one tap", "Cliente laissant un avis Google au comptoir grâce au sans-contact": "Customer leaving a Google review at the counter via contactless", "Service d'un plat gastronomique au restaurant": "A gourmet dish being served at a restaurant", "Chambre lumineuse d'une location saisonnière sur la Côte d'Azur": "Bright bedroom of a seasonal rental on the French Riviera", "Un geste du téléphone suffit pour partager ses coordonnées": "One tap of the phone shares your details", "Le client laisse son avis depuis son téléphone": "The customer leaves their review from their phone", "Une table dressée, le menu accessible en un geste": "A set table, the menu one tap away", "Un intérieur soigné, prêt à accueillir les voyageurs": "A polished interior, ready to welcome guests", "Portrait de Sofia L.": "Portrait of Sofia L.", "Portrait de Marc D.": "Portrait of Marc D.", "Portrait d'Élodie R.": "Portrait of Élodie R.", "Portrait de Thomas B.": "Portrait of Thomas B.", "Portrait de Camille V.": "Portrait of Camille V.", "Portrait de Nadia F.": "Portrait of Nadia F.", "Avis Azur — Plaques avis Google, NFC & création de sites internet | Côte d'Azur": "Avis Azur — Google review plaques, NFC & website creation | French Riviera", "Créateur de solutions NFC pour commerçants sur la Côte d'Azur. Cartes de visite, plaques avis Google, menus, supports Airbnb et création de sites internet — livrés prêts à l'emploi. Devis rapide.": "NFC solutions for businesses on the French Riviera. Business cards, Google review plaques, menus, Airbnb stands and website creation — delivered ready to use. Fast quote."};
window.AV_I18N_HTML = {"Un geste suffit. Vos clients laissent un avis Google.": "One <span class=\"h-accent\">tap</span> is enough.<br> Your customers leave<br> a Google review.", "Deux leviers, un seul objectif : plus de clients": "Two levers, <span class=\"h-accent\">one goal</span> : more customers", "La solution qui vous ressemble": "The <span class=\"h-accent\">solution</span> that fits you", "Choisissez votre modèle": "Choose your <span class=\"h-accent\">model</span>", "Créez votre modèle": "Create your <span class=\"h-accent\">design</span>", "Nous créons aussi votre site internet": "We also build your <span class=\"h-accent\">website</span>", "Des tarifs transparents": "Transparent <span class=\"h-accent\">pricing</span>", "Ce qu'ils en disent": "What our clients <span class=\"h-accent\">say</span>", "« Conçu à Mougins, pensé pour toute la Côte d'Azur. »": "“Designed in Mougins, made for the whole Côte d’Azur.”", "Questions fréquentes": "Frequently asked <span class=\"h-accent\">questions</span>", "Créons votre site": "Let’s build <span class=\"h-accent\">your website</span>", "Nous créons aussi des sites internet.": "<span class=\"a2-l1\"><span class=\"aw\"><span class=\"lt\" style=\"--i:0\">W</span><span class=\"lt\" style=\"--i:1\">e</span></span> <span class=\"aw\"><span class=\"lt\" style=\"--i:2\">a</span><span class=\"lt\" style=\"--i:3\">l</span><span class=\"lt\" style=\"--i:4\">s</span><span class=\"lt\" style=\"--i:5\">o</span></span> <span class=\"aw\"><span class=\"lt\" style=\"--i:6\">c</span><span class=\"lt\" style=\"--i:7\">r</span><span class=\"lt\" style=\"--i:8\">e</span><span class=\"lt\" style=\"--i:9\">a</span><span class=\"lt\" style=\"--i:10\">t</span><span class=\"lt\" style=\"--i:11\">e</span></span></span>\n              <span class=\"a2-l2\"><span class=\"aw emph\"><span class=\"lt\" style=\"--i:12\">w</span><span class=\"lt\" style=\"--i:13\">e</span><span class=\"lt\" style=\"--i:14\">b</span><span class=\"lt\" style=\"--i:15\">s</span><span class=\"lt\" style=\"--i:16\">i</span><span class=\"lt\" style=\"--i:17\">t</span><span class=\"lt\" style=\"--i:18\">e</span><span class=\"lt\" style=\"--i:19\">s</span><span class=\"lt\" style=\"--i:20\">.</span></span></span>"};
;

  /* =========================================================
     1. CONFIG — modifiez ici vos coordonnées en un seul endroit
     ========================================================= */
window.__avLockY = 0;
window.__avLockN = 0; /* verrou à compteur : les calques empilés (fiche + lightbox…) n'écrasent plus la position */
window.avLock = function () {
  if (++window.__avLockN > 1) return;
  window.__avLockY = window.scrollY || window.pageYOffset || 0;
  var s = document.body.style;
  s.overflow = 'hidden'; s.position = 'fixed'; s.top = (-window.__avLockY) + 'px';
  s.left = '0'; s.right = '0'; s.width = '100%';
};
window.avUnlock = function () {
  if (window.__avLockN === 0) return;
  if (--window.__avLockN > 0) return;
  var s = document.body.style;
  s.overflow = ''; s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.width = '';
  try { window.scrollTo({ top: window.__avLockY, left: 0, behavior: 'instant' }); }
  catch (e) { window.scrollTo(0, window.__avLockY); }
};

/* ============ AV_PRICING — SOURCE UNIQUE DES PRIX (V54) ============
   Piloté par : produit -> version (standard/personnalisé) -> options -> quantité.
   Les barèmes sont keyés par PRIX DE BASE (centimes). Aucun prix ailleurs. */
window.AV_PRICING = {
  /* prix par produit — chaque produit PEUT avoir son propre prix */
  byKey: {
    avisplq:  { standard: 3490, personalized: 5990 },
    plqinsta: { standard: 3490, personalized: 5990 },
    facebook: { standard: 3490, personalized: 5990 },
    snapchat: { standard: 3490, personalized: 5990 },
    linkedin: { standard: 3490, personalized: 5990 },
    site:     { standard: 3490, personalized: 5990 },
    airbnb:   { standard: 2990, personalized: 4490 },
    plqwa:    { standard: 2990, personalized: 4490 },
    menu:     { standard: 4490, personalized: 5990 },
    perso:    { standard: null, personalized: 5990 }, /* sur mesure = toujours personnalisé */
    visite:   { standard: 2990, personalized: 4490 },
    contact:  { standard: 2990, personalized: 4490 },
    entreprise: { standard: 2990, personalized: 4490 },
    pro:      { standard: 2990, personalized: 4490 },
    vip:      { standard: 2990, personalized: 4490 },
    digitale: { standard: 2990, personalized: 4490 }
  },
  /* options — UNE SEULE constante par option. null = non défini : jamais inventé,
     jamais ajouté au total. qr = 0 : prix réel actuel du projet (QR inclus). */
  /* qr : 499 = +4,99 € (valeur EXEMPLE de votre brief §7/§8 — modifiez ICI et
     tout se met à jour : prix, résumé, panier). socle : null tant que non défini. */
  options: { qr: 490, socle: 790 },
  /* barèmes dégressifs par prix de base */
  tiers: {
    4990: [[1, 4990], [2, 4740], [5, 4390], [10, 4140], [25, 3890], [50, 3590]],
    6990: [[1, 6990], [2, 6640], [5, 6190], [10, 5790], [25, 5440], [50, 4990]],
    2990: [[1, 2990], [2, 2840], [5, 2690], [10, 2490], [25, 2290], [50, 2090]],
    4490: [[1, 4490], [2, 4290], [5, 3990], [10, 3490], [25, 3290], [50, 2990]],
    3490: [[1, 3490], [2, 3340], [5, 3090], [10, 2890], [25, 2690], [50, 2490]],
    5990: [[1, 5990], [2, 5690], [5, 5290], [10, 4990], [25, 4690], [50, 4290]]
  },
  badges: {
    4990: { 2: 'Petite équipe', 5: 'Bon plan', 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' },
    6990: { 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' },
    2990: { 2: 'Petite équipe', 5: 'Bon plan', 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' },
    4490: { 2: 'Petite équipe', 5: 'Bon plan', 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' },
    3490: { 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' },
    5990: { 10: '⭐ Populaire', 25: '🔥 Meilleure valeur', 50: 'Pro' }
  }
};
window.AV_OPTION_PRICES = window.AV_PRICING.options; /* compat */
/* normalise n'importe quel prix de base vers sa clé de barème */
window.avKind = function (basePrice) {
  basePrice = +basePrice;
  if (window.AV_PRICING.tiers[basePrice]) return basePrice;
  return basePrice <= 4490 ? 4490 : 5990; /* héritage V53 */
};
window.avTier = function (baseKey, qty) {
  var tiers = window.AV_PRICING.tiers[baseKey];
  if (!tiers) return null;
  qty = Math.max(1, qty | 0);
  var unit = tiers[0][1], next = null, seuil = 1;
  for (var i = 0; i < tiers.length; i++) {
    if (qty >= tiers[i][0]) { unit = tiers[i][1]; seuil = tiers[i][0]; }
    else { next = tiers[i]; break; }
  }
  var base = tiers[0][1];
  var total = unit * qty, pub = base * qty, save = pub - total;
  return { unit: unit, seuil: seuil, base: base, total: total, pub: pub, save: save,
           pct: pub ? Math.round(save / pub * 100) : 0, next: next, devis: qty >= 100 };
};
/* prix des options par unité (jamais remisées) — 0 si non défini */
window.avOptCents = function (qr, socle) {
  var o = window.AV_PRICING.options;
  return (qr && o.qr ? o.qr : 0) + (socle && o.socle ? o.socle : 0);
};


  const CONFIG = {
    brandName: "Avis Azur",
    phone: "06 37 87 11 19",
    phoneClean: "+33637871119",
    email: "contact@avisazur.com",     // <-- votre e-mail
    address: "72 Boulevard Sadi Carnot — 06110 Le Cannet",
    area: "Cannes · Le Cannet · Antibes · Nice · Monaco",
    instagram: "https://www.instagram.com/avis.azur/",
    whatsapp:  "https://wa.me/33637871119"
  };

  /* Injection dans la page */
  (function applyConfig() {
    document.querySelectorAll('[data-config]').forEach(el => {
      const key = el.dataset.config;
      const isLink = el.tagName === 'A';
      switch (key) {
        case 'brandName':     el.textContent = CONFIG.brandName; break;
        case 'phoneText':     el.textContent = CONFIG.phone; break;
        case 'phoneLink':     if (isLink) { el.href = 'tel:' + CONFIG.phoneClean; el.textContent = CONFIG.phone; } break;
        case 'emailText':     el.textContent = CONFIG.email; break;
        case 'emailLink':     if (isLink) { el.href = 'mailto:' + CONFIG.email; el.textContent = CONFIG.email; } break;
        case 'address':       el.textContent = CONFIG.address; break;
        case 'area':          el.textContent = CONFIG.area; break;
        case 'instagramLink': if (isLink) el.href = CONFIG.instagram; break;
        case 'whatsappLink':  if (isLink) el.href = CONFIG.whatsapp; break;
      }
    });
  })();

  /* =========================================================
     2. Menu mobile
     ========================================================= */
  (function menuMobile() {
    const check = document.getElementById('nav-check');
    const nav = document.getElementById('main-nav');
    if (!check || !nav) return;
    nav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => { check.checked = false; check.dispatchEvent(new Event('change')); });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') check.checked = false; check.dispatchEvent(new Event('change'));
    });
  })();

  /* =========================================================
     3. Header scroll + progress bar
     ========================================================= */
  (function headerScroll() {
    const header = document.getElementById('site-header');
    const progress = document.getElementById('scroll-progress');
    const stickyCta = document.getElementById('mobile-sticky-cta');
    if (!header) return;

    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
      if (progress) {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        const pct = h > 0 ? window.scrollY / h : 0;
        progress.style.transform = `scaleX(${pct})`;
      }
      if (stickyCta && window.innerWidth <= 860) {
        stickyCta.classList.toggle('visible', window.scrollY > 600);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* =========================================================
     4. Accordéon FAQ
     ========================================================= */
  (function faqAccordion() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const btn = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      if (!btn || !answer) return;
      btn.addEventListener('click', () => {
        const open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open);
        answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0';
      });
    });
    // V51 : dérouleur global — 3 questions visibles, le reste plié
    const list = document.querySelector('.faq-list');
    const items = list ? Array.from(list.querySelectorAll('.faq-item')) : [];
    if (list && items.length > 4) {
      const rest = items.slice(3);
      rest.forEach((it) => it.classList.add('faq-folded'));
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'faq-more-btn';
      const label = (window.avT ? window.avT('Voir toutes les questions') : 'Voir toutes les questions');
      more.innerHTML = label + ' <span class="fmb-n">(' + rest.length + ')</span>';
      more.setAttribute('aria-expanded', 'false');
      list.appendChild(more);
      more.addEventListener('click', () => {
        rest.forEach((it, k) => {
          it.classList.remove('faq-folded');
          it.classList.add('faq-unfolded');
          it.style.setProperty('--fd', (k * 0.07) + 's');
        });
        more.remove();
      });
    }
  })();

  /* =========================================================
     5. Démonstration interactive
     ========================================================= */
  (function demoInteractive() {
    const screen = document.getElementById('demo-screen');
    if (!screen) return;

    const CONFIG_UI = {
      carte: {
        photo: window.__AV["img-demo-biz-photo.jpg"],
        avatarImg: window.__AV["img-demo-biz-avatar.jpg"],
        title: 'Sofia Laurent',
        subtitle: 'Coiffeuse — Le Cannet',
        lines: [
          { icon: '📞', text: '06 37 87 11 19' },
          { icon: '✉️', text: 'contact@avisazur.com' },
          { icon: '🌐', text: 'avisazur.com' },
          { icon: '📸', text: '@avis.azur' }
        ],
        pill: { text: 'Ajouter à mes contacts', bg: '#0B1620', color: '#fff' }
      },
      instagram: {
        photo: window.__AV["img-demo-instagram.jpg"],
        avatarBg: 'linear-gradient(135deg, #833AB4, #E1306C 60%, #F77737)',
        avatarText: '📸',
        title: '@avis.azur',
        subtitle: 'Solutions NFC · Côte d\'Azur',
        lines: [
          { icon: '🎥', text: '128 publications' },
          { icon: '❤️', text: '2 340 abonnés' },
          { icon: '🔗', text: 'avisazur.com' }
        ],
        pill: { text: 'S\'abonner', bg: '#E1306C', color: '#fff' }
      },
      avis: {
        photo: window.__AV["img-demo-avis.jpg"],
        avatarBg: 'linear-gradient(135deg, #F0DCA8, #C89238)',
        avatarText: '★',
        title: 'Salon Sofia',
        subtitle: 'Le Cannet · 4,9/5 (128 avis)',
        stars: true,
        lines: [
          { icon: '📝', text: 'Comment était votre visite ?' },
          { icon: '📷', text: 'Ajouter des photos' }
        ],
        pill: { text: 'Publier mon avis Google', bg: 'linear-gradient(135deg, #F0DCA8, #C89238)', color: '#052538' }
      },
      menu: {
        photo: window.__AV["img-demo-menu.jpg"],
        avatarBg: 'rgba(255,255,255,0.16)',
        avatarText: '🍽️',
        title: 'La Riviera',
        subtitle: 'Cuisine méditerranéenne',
        lines: [
          { icon: '🍅', text: 'Entrées' },
          { icon: '🐟', text: 'Poissons du jour' },
          { icon: '🥩', text: 'Viandes' },
          { icon: '🍷', text: 'Vins & boissons' }
        ],
        pill: { text: 'Voir le menu complet', bg: '#C89238', color: '#052538' }
      },
      wifi: {
        photo: window.__AV["img-demo-wifi.jpg"],
        avatarBg: 'rgba(255,255,255,0.16)',
        avatarText: '📶',
        title: 'Villa Azur — Wi-Fi',
        subtitle: 'Bienvenue sur la Côte d\'Azur',
        lines: [
          { icon: '📡', text: 'Réseau : Villa_Azur' },
          { icon: '🔑', text: 'Mot de passe automatique' },
          { icon: '📖', text: 'Livret d\'accueil' }
        ],
        pill: { text: 'Se connecter au Wi-Fi', bg: '#2476B8', color: '#fff' }
      }
    };

    function render(mode) {
      const cfg = CONFIG_UI[mode] || CONFIG_UI.carte;
      const starsHTML = cfg.stars ? '<div class="demo-stars">★★★★★</div>' : '';
      const linesHTML = cfg.lines.map(l => `<div class="demo-line"><span>${l.icon}</span><span>${l.text}</span></div>`).join('');
      const headerStyle = cfg.photo
        ? `background:linear-gradient(180deg, rgba(6,20,33,0.45) 0%, rgba(6,20,33,0.86) 100%), url('${cfg.photo}') center/cover no-repeat`
        : `background:${cfg.headerBg}`;
      const avatarHTML = cfg.avatarImg
        ? `<div class="demo-avatar demo-avatar-photo"><img src="${cfg.avatarImg}" alt=""></div>`
        : `<div class="demo-avatar" style="background:${cfg.avatarBg}; color:${cfg.avatarText === '★' ? '#052538' : '#fff'}">${cfg.avatarText}</div>`;
      screen.innerHTML = `
        <div class="demo-content">
          <div class="demo-header" style="${headerStyle}">
            ${avatarHTML}
            <h3>${cfg.title}</h3>
            <p>${cfg.subtitle}</p>
          </div>
          <div class="demo-body">
            ${starsHTML}
            ${linesHTML}
            <div class="demo-pill" style="background:${cfg.pill.bg}; color:${cfg.pill.color}">${cfg.pill.text}</div>
          </div>
        </div>
      `;
    }

    render('carte');

    document.querySelectorAll('.demo-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.demo-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        render(btn.dataset.demo);
      });
    });
  })();

  /* =========================================================
     6. Validation formulaire
     ========================================================= */
  (function quoteForm() {
    const form = document.getElementById('quote-form');
    if (!form) return;
    const feedback = document.getElementById('form-feedback');

    const showError = (group, msg) => {
      group.classList.add('invalid');
      const el = group.querySelector('.error-msg');
      if (el) el.textContent = window.avT(msg);
    };
    const clearError = (group) => {
      group.classList.remove('invalid');
      const el = group.querySelector('.error-msg');
      if (el) el.textContent = '';
    };

    const validate = () => {
      let ok = true;
      form.querySelectorAll('[required]').forEach(field => {
        const group = field.closest('.form-group');
        if (!group) return;
        clearError(group);
        if (field.type === 'checkbox') {
          if (!field.checked) { showError(group, "Merci d'accepter la politique de confidentialité."); ok = false; }
        } else if (!field.value.trim()) {
          'Ce champ est requis.'; ok = false;
        }
      });
      const emailField = document.getElementById('email');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailField && emailField.value.trim() && !emailRegex.test(emailField.value.trim())) {
        showError(emailField.closest('.form-group'), "Adresse e-mail invalide.");
        ok = false;
      }
      return ok;
    };

    form.querySelectorAll('input, select, textarea').forEach(field => {
      field.addEventListener('input', () => {
        const g = field.closest('.form-group');
        if (g) clearError(g);
        if (feedback) { feedback.textContent = ''; feedback.className = 'form-feedback'; }
      });
    });

    // Si le site est en ligne, revenir sur la page après le repli POST natif
    if (/^https?:/.test(location.protocol)) {
      const next = document.createElement('input');
      next.type = 'hidden'; next.name = '_next';
      next.value = location.origin + location.pathname + '#contact';
      form.appendChild(next);
    }

    const AJAX_URL = 'https://formsubmit.co/ajax/contact@avisazur.com';

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!validate()) {
        if (feedback) {
          feedback.textContent = 'Merci de corriger les champs indiqués.';
          feedback.className = 'form-feedback error';
        }
        const first = form.querySelector('.form-group.invalid');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      // Site ouvert en fichier local : on passe par l'application e-mail
      if (location.protocol === 'file:') {
        const fd = new FormData(form);
        let body = '';
        fd.forEach((v, k) => {
          if (!k.startsWith('_') && k !== 'Consentement RGPD' && String(v).trim()) body += k + ' : ' + v + '\n';
        });
        if (feedback) {
          feedback.textContent = 'Votre application e-mail va s\'ouvrir avec votre demande — appuyez sur Envoyer.';
          feedback.className = 'form-feedback success';
          feedback.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        window.location.href = 'mailto:contact@avisazur.com?subject=' +
          encodeURIComponent('Demande de devis — Avis Azur') + '&body=' + encodeURIComponent(body);
        return;
      }

      const btn = form.querySelector('button[type="submit"]');
      const btnHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Envoi en cours…'; }
      const restore = () => { if (btn) { btn.disabled = false; btn.innerHTML = btnHTML; } };
      const showOk = () => {
        if (feedback) {
          feedback.textContent = 'Merci ! Votre demande a bien été envoyée. Nous revenons vers vous sous 24h.';
          feedback.className = 'form-feedback success';
          feedback.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        form.reset();
      };
      fetch(AJAX_URL, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then((res) => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      }).then(() => { restore(); showOk(); })
        .catch(() => {
          // Repli : envoi classique via la page FormSubmit
          restore();
          form.submit();
        });
    });
  })();

  /* =========================================================
     6b. Carrousel de témoignages (autoplay + swipe)
     ========================================================= */
  (function testimonialsCarousel() {
    const root = document.getElementById('testimonials-carousel');
    const track = document.getElementById('testimonials-track');
    const prevBtn = document.getElementById('testi-prev');
    const nextBtn = document.getElementById('testi-next');
    const dotsWrap = document.getElementById('testi-dots');
    if (!root || !track) return;

    const slides = Array.from(track.children);
    const total = slides.length;
    let index = 0;
    let autoplayId = null;
    const AUTOPLAY_MS = 5000;

    const perView = () => {
      const w = window.innerWidth;
      if (w <= 640) return 1;
      if (w <= 1024) return 2;
      return 3;
    };

    const maxIndex = () => Math.max(0, total - perView());

    const update = () => {
      const pv = perView();
      const gap = 24;
      const wrap = track.parentElement;
      const slideW = (wrap.clientWidth - gap * (pv - 1)) / pv;
      slides.forEach(s => { s.style.flexBasis = slideW + 'px'; });
      const shift = index * (slideW + gap);
      track.style.transform = `translateX(-${shift}px)`;
      // dots
      const dotCount = maxIndex() + 1;
      dotsWrap.querySelectorAll('.carousel-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });
      // arrows
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= maxIndex();
    };

    const buildDots = () => {
      dotsWrap.innerHTML = '';
      const count = maxIndex() + 1;
      for (let i = 0; i < count; i++) {
        const b = document.createElement('button');
        b.className = 'carousel-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `Aller au groupe ${i + 1}`);
        b.addEventListener('click', () => { index = i; update(); resetAuto(); });
        dotsWrap.appendChild(b);
      }
    };

    const go = (dir) => {
      const max = maxIndex();
      index = (index + dir + max + 1) % (max + 1);
      update();
    };

    const startAuto = () => {
      stopAuto();
      autoplayId = setInterval(() => go(1), AUTOPLAY_MS);
    };
    const stopAuto = () => { if (autoplayId) { clearInterval(autoplayId); autoplayId = null; } };
    const resetAuto = () => { stopAuto(); startAuto(); };

    prevBtn.addEventListener('click', () => { go(-1); resetAuto(); });
    nextBtn.addEventListener('click', () => { go(1); resetAuto(); });

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAuto(); else startAuto();
    });

    // Swipe tactile
    let touchStartX = 0, touchDeltaX = 0, touching = false;
    track.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX; touchDeltaX = 0; touching = true;
      stopAuto();
    }, { passive: true });
    track.addEventListener('touchmove', e => {
      if (!touching) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });
    track.addEventListener('touchend', () => {
      if (!touching) return;
      touching = false;
      if (Math.abs(touchDeltaX) > 50) go(touchDeltaX < 0 ? 1 : -1);
      startAuto();
    });

    // Clavier
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { go(-1); resetAuto(); }
      if (e.key === 'ArrowRight') { go(1); resetAuto(); }
    });
    root.tabIndex = 0;

    // Redimensionnement
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        index = Math.min(index, maxIndex());
        buildDots(); update();
      }, 150);
    });

    buildDots();
    // petit délai pour que la largeur du wrap soit stable
    setTimeout(update, 60);
    startAuto();
  })();

  /* =========================================================
     7. Retour en haut
     ========================================================= */
  (function backToTop() {
    const btn = document.getElementById('back-to-top');
    if (!btn) return;
    const on = () => btn.classList.toggle('visible', window.scrollY > 500);
    on();
    window.addEventListener('scroll', on, { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  })();

  /* =========================================================
     8. Animations au défilement
     ========================================================= */
  (function reveal() {
    const els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(e => e.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver((entries, o) => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('visible');
          o.unobserve(en.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -60px 0px' });
    els.forEach(e => obs.observe(e));
  })();

  /* =========================================================
     9. Compteurs animés (stats bar)
     ========================================================= */
  (function counters() {
    const els = document.querySelectorAll('[data-target]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    const animate = (el) => {
      const target = parseInt(el.dataset.target, 10);
      if (isNaN(target)) return;
      const dur = 1400;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(eased * target);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const obs = new IntersectionObserver((entries, o) => {
      entries.forEach(e => {
        if (e.isIntersecting) { animate(e.target); o.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(e => obs.observe(e));
  })();

  /* =========================================================
     10. Année automatique
     ========================================================= */
  (function currentYear() {
    const el = document.getElementById('year');
    if (el) el.textContent = new Date().getFullYear();
  })();

  /* =========================================================
     V2 — 11. Diaporama du hero
     ========================================================= */
  (function heroSlideshow() {
    const slides = Array.from(document.querySelectorAll('.hero-slide'));
    const navs = Array.from(document.querySelectorAll('.hero-slidenav-item'));
    const captionEl = document.getElementById('hero-caption-text');
    const captions = [
      'Méditerranée — esprit Riviera',
      'La grande bleue, vue du ciel',
      'La côte au crépuscule',
      'Terrasse au bord de l\'eau'
    ];
    if (slides.length < 2) return;
    const DELAY = 7000;
    document.documentElement.style.setProperty('--hero-delay', DELAY + 'ms');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let i = 0, timer = null;

    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      navs.forEach((b, k) => b.classList.toggle('is-active', k === i));
      if (captionEl && captions[i]) captionEl.textContent = captions[i];
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => { if (reduced) return; stop(); timer = setInterval(() => show(i + 1), DELAY); };

    navs.forEach((b, k) => b.addEventListener('click', () => { show(k); start(); }));
    document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });
    // LCP : la rotation démarre à la première interaction (ou après 15 s) —
    // la diapo 1 reste la seule peinture du hero pendant la mesure.
    let armed = false;
    const arm = () => { if (armed) return; armed = true; start(); };
    ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'].forEach((ev) =>
      window.addEventListener(ev, arm, { once: true, passive: true }));
    setTimeout(arm, 15000);
  })();

  /* =========================================================
     V2 — 12. Inclinaison 3D du visuel hero
     ========================================================= */
  (function heroTilt() {
    const zone = document.querySelector('.hero');
    const tilt = document.getElementById('hero-tilt');
    if (!zone || !tilt) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    zone.addEventListener('mousemove', (e) => {
      const r = zone.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      tilt.style.transform = `rotateY(${(x * 9).toFixed(2)}deg) rotateX(${(-y * 7).toFixed(2)}deg)`;
    });
    zone.addEventListener('mouseleave', () => { tilt.style.transform = 'rotateY(0deg) rotateX(0deg)'; });
  })();

  /* =========================================================
     V2 — 13. Slider secteurs (drag + flèches)
     ========================================================= */
  (function sectorsSlider() {
    const slider = document.getElementById('sectors-slider');
    if (!slider) return;
    const prev = document.getElementById('sectors-prev');
    const next = document.getElementById('sectors-next');
    const step = () => {
      const card = slider.querySelector('.sector-photo-card');
      return (card ? card.offsetWidth : 280) + 18;
    };
    if (prev) prev.addEventListener('click', () => slider.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => slider.scrollBy({ left: step(), behavior: 'smooth' }));

    let down = false, startX = 0, startScroll = 0;
    slider.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; startX = e.clientX; startScroll = slider.scrollLeft;
      slider.classList.add('dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      slider.scrollLeft = startScroll - (e.clientX - startX);
    });
    ['pointerup', 'pointercancel'].forEach(ev =>
      window.addEventListener(ev, () => { down = false; slider.classList.remove('dragging'); })
    );
  })();

  /* =========================================================
     V2 — 14. Lightbox galerie
     ========================================================= */
  (function lightbox() {
    const items = Array.from(document.querySelectorAll('.gallery-item'));
    const lb = document.getElementById('lightbox');
    if (!items.length || !lb) return;
    const img = document.getElementById('lightbox-img');
    const cap = document.getElementById('lightbox-cap');
    const data = items.map(el => ({
      src: el.dataset.full || (el.querySelector('img') ? el.querySelector('img').src : ''),
      cap: el.querySelector('.gallery-caption') ? el.querySelector('.gallery-caption').textContent : ''
    }));
    let idx = 0;
    const openAt = (n) => {
      idx = (n + data.length) % data.length;
      img.src = data[idx].src;
      img.alt = data[idx].cap;
      cap.textContent = data[idx].cap;
      lb.classList.add('open');
      avLock();
    };
    const close = () => { lb.classList.remove('open'); avUnlock(); };
    items.forEach((el, k) => {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Agrandir : ' + (data[k].cap || 'image'));
      el.addEventListener('click', () => openAt(k));
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openAt(k); }
      });
    });
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    document.getElementById('lightbox-close').addEventListener('click', close);
    document.getElementById('lightbox-prev').addEventListener('click', () => openAt(idx - 1));
    document.getElementById('lightbox-next').addEventListener('click', () => openAt(idx + 1));
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') openAt(idx - 1);
      if (e.key === 'ArrowRight') openAt(idx + 1);
    });
  })();

  /* =========================================================
     V2 — 15. Parallax des bandes immersives
     ========================================================= */
  (function bandsParallax() {
    const imgs = Array.from(document.querySelectorAll('.band-bg img'));
    if (!imgs.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      imgs.forEach(im => {
        const band = im.closest('.band');
        const r = band.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        im.style.transform = `scale(1.18) translateY(${(p * -8).toFixed(2)}%)`;
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* =========================================================
     V2 — 16. Curseur personnalisé + boutons magnétiques
     ========================================================= */

  /* =========================================================
     V26 — 29. Fiches produits
     ========================================================= */
  (function fichesProduits() {
    const modal = document.getElementById('fiche-modal');
    if (!modal) return;
    const closeBtn = document.getElementById('fiche-close');
    const panels = modal.querySelectorAll('.fiche-panel');
    let lastFocus = null;

    // Galerie : la photo 1 est celle de la carte produit (aucune donnée dupliquée)
    document.querySelectorAll('.fiche-open').forEach((btn) => {
      const panel = modal.querySelector('.fiche-panel[data-fiche-panel="' + btn.dataset.fiche + '"]');
      if (!panel) return;
      const card = btn.closest('.solution-card');
      const cardImg = card ? card.querySelector('.solution-visual img') : null;
      if (cardImg) panel.querySelectorAll('[data-from-card]').forEach((el) => { el.src = cardImg.src; });
      const fb = panel.querySelector('.fi-b');
      if (fb) panel.querySelectorAll('[data-from-fib]').forEach((el) => { el.src = fb.src; });
      btn.addEventListener('click', () => {
        const wasOpen = modal.classList.contains('open');
        panels.forEach((p) => { p.hidden = (p !== panel); });
        modal.classList.add('open');
        modal.querySelector('.fiche-sheet').scrollTop = 0;
        avFichePhotos(panel, btn.dataset.fiche);
        if (!wasOpen) avLock();
        lastFocus = btn;
        try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
      });
    });

    const close = () => {
      if (!modal.classList.contains('open')) return;
      modal.classList.remove('open');
      avUnlock();
      if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    };
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });

    // Toute la carte produit ouvre sa fiche (pas seulement le lien)
    document.querySelectorAll('.solution-card').forEach((card) => {
      const opener = card.querySelector('.fiche-open');
      if (!opener) return;
      card.classList.add('has-fiche');
      card.addEventListener('click', (e) => {
        if (e.target.closest('.add-cart') || e.target.closest('.fiche-open') || e.target.closest('a')) return;
        opener.click();
      });
    });

    // V54 : mise en avant de la carte sélectionnée (sélection premium)
    document.addEventListener('pointerdown', (e) => {
      const slide = e.target.closest('.col-slide');
      if (!slide) return;
      const track = slide.closest('.col-track');
      if (!track) return;
      slide.classList.add('av-selecting');
      track.classList.add('av-dim');
      setTimeout(() => { slide.classList.remove('av-selecting'); track.classList.remove('av-dim'); }, 750);
    }, true);

    // Ouverture directe d'une fiche par sa clé (utilisée par la collection)
    var AV_FICHE_DEF = { plaque: 'avisplq', carte: 'visite', menu: 'menu', airbnb: 'airbnb', reseau: 'plqinsta' };
    var avFichePhotos = function (panel, pk) {
      try {
        pk = AV_FICHE_DEF[pk] || pk;
        var bank = document.getElementById('fiche-photo-bank');
        if (!bank || !panel) return;
        var imgs = Array.prototype.filter.call(
          bank.querySelectorAll('img[data-fk^="' + pk + '|"]'),
          function (im) { return /\|\d+$/.test(im.getAttribute('data-fk')); });
        if (!imgs.length) return;
        var gal = panel.querySelector('.fiche-gallery');
        if (!gal) return;
        var mainBox = gal.querySelector('.fiche-main');
        var thBox = gal.querySelector('.fiche-thumbs');
        if (!mainBox || !thBox) return;
        var main = '', th = '';
        imgs.forEach(function (im, i) {
          var s = im.getAttribute('src');
          var cap = im.getAttribute('data-cap') || '';
          main += '<div class="fiche-img av-real' + (i ? '' : ' is-active') + '"><img src="' + s + '" alt="' + cap + '" loading="lazy" decoding="async"></div>';
          th += '<button type="button" class="fiche-thumb' + (i ? '' : ' is-active') + '" data-fi="' + i + '" role="tab" aria-label="' + cap + '"><img src="' + s + '" alt="" loading="lazy" decoding="async"></button>';
        });
        mainBox.innerHTML = main;
        thBox.innerHTML = th;
        panel.dataset.avKey = pk;
        panel.querySelectorAll('.fiche-qr-opt').forEach(function (o) { o.remove(); });
        var qrImg = bank.querySelector('img[data-fk="' + pk + '|qr"]');
        if (qrImg) {
          var en = window.AVLANG === 'en';
          var opt = document.createElement('div');
          opt.className = 'fiche-qr-opt';
          opt.setAttribute('role', 'radiogroup');
          opt.setAttribute('aria-label', en ? 'Printed QR code' : 'QR code imprimé');
          opt.innerHTML = '<span class="fq-lab">' + (en ? 'Printed QR code' : 'QR code imprimé') + '</span>'
            + '<label class="fq-pill"><input type="radio" data-opt="qr" name="fqq-' + pk + '" value="sans" checked><span>' + (en ? 'Without' : 'Sans') + '</span></label>'
            + (function () {
              var qp = window.AV_PRICING.options.qr;
              var qtxt = qp ? (en ? 'With — +' : 'Avec — +') + (qp / 100).toFixed(2).replace('.', ',') + ' €'
                            : (en ? 'With — included' : 'Avec — inclus');
              return '<label class="fq-pill"><input type="radio" data-opt="qr" name="fqq-' + pk + '" value="avec"><span>' + qtxt + '</span></label>';
            })();
          var SOCLE_KEYS = ['avisplq', 'plqinsta', 'facebook', 'snapchat', 'linkedin', 'site', 'airbnb', 'perso', 'menu'];
          if (SOCLE_KEYS.indexOf(pk) !== -1) {
            var sp = window.AV_PRICING && window.AV_PRICING.options && window.AV_PRICING.options.socle;
            var socleTxt = sp ? (en ? 'With — +' : 'Avec — +') + (sp / 100).toFixed(2).replace('.', ',') + ' €'
                              : (en ? 'With — price confirmed at proof' : 'Avec — tarif confirmé au BAT');
            opt.innerHTML += '<span class="fq-lab fq-lab2">' + (en ? 'Stand' : 'Socle') + '</span>'
              + '<label class="fq-pill"><input type="radio" data-opt="socle" name="fqs-' + pk + '" value="sans" checked><span>' + (en ? 'Without' : 'Sans') + '</span></label>'
              + '<label class="fq-pill"><input type="radio" data-opt="socle" name="fqs-' + pk + '" value="avec"><span>' + socleTxt + '</span></label>';
          }
          var priceEl = panel.querySelector('.fiche-buy .fiche-price');
          if (priceEl) priceEl.insertAdjacentElement('afterend', opt);
          else thBox.insertAdjacentElement('afterend', opt);
          /* défaut cohérent : SANS QR -> pas de vue verso QR */
          panel.dataset.avQr = panel.dataset.avQr || '';
          var vQr = Array.prototype.find.call(panel.querySelectorAll('.fiche-thumb'), function (b) {
            return (b.getAttribute('aria-label') || '').indexOf('QR') !== -1 || +b.dataset.fi === 3;
          });
          if (vQr && !panel.dataset.avQr) {
            vQr.hidden = true;
            var v3 = panel.querySelectorAll('.fiche-img')[3];
            if (v3) v3.classList.remove('is-active');
          }
          /* remise à zéro : chaque ouverture démarre en Personnalisée, sans options */
          panel.dataset.avQr = '';
          panel.dataset.avSocle = '';
          var buyBox0 = panel.querySelector('.fiche-buy');
          if (buyBox0) {
            buyBox0.dataset.version = 'std'; /* V56 : standard par défaut */
            var ab0 = buyBox0.querySelector('.add-cart');
            if (ab0) {
              ab0.dataset.name = ab0.dataset.name
                .replace(/ — (Standard|Personnalisée)/, '')
                .replace(/( \(avec [^)]+\))+$/, '');
              ab0.dataset.name0 = ab0.dataset.name;
              if (ab0.id === 'fr-add') {
                /* panneau réseau partagé : fillReseau vient de poser le bon prix produit */
                ab0.dataset.base0 = ab0.dataset.price;
              } else if (ab0.dataset.base0) {
                ab0.dataset.price = ab0.dataset.base0;
              }
            }
            var pb0 = buyBox0.querySelector('.fiche-perso');
            if (pb0) pb0.hidden = false;
          }
          /* cohérence à l'ouverture : sans QR -> « NFC + QR code » devient « NFC » */
          panel.querySelectorAll('li, span').forEach(function (el) {
            var txt = (el.dataset.avqrTxt || el.textContent).trim();
            if (txt === 'NFC + QR code' || (el.dataset.avqrTxt === 'NFC + QR code')) {
              if (!el.dataset.avqrTxt) el.dataset.avqrTxt = 'NFC + QR code';
              el.textContent = panel.dataset.avQr ? 'NFC + QR code' : 'NFC';
            }
          });
        }
      } catch (e) {}
    };
    const openPanelByKey = (key, back) => {
      const panel = modal.querySelector('.fiche-panel[data-fiche-panel="' + key + '"]');
      if (!panel) return;
      const wasOpen = modal.classList.contains('open');
      panels.forEach((p) => { p.hidden = (p !== panel); });
      modal.classList.add('open');
      modal.querySelector('.fiche-sheet').scrollTop = 0;
      avFichePhotos(panel, (back && back.dataset && back.dataset.key) || key);
      if (!wasOpen) avLock();
      lastFocus = back || null;
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    };
    window.avOpenFiche = openPanelByKey;

    // Vignettes -> photo active
    modal.addEventListener('click', (e) => {
      const t = e.target.closest('.fiche-thumb');
      if (!t) return;
      const panel = t.closest('.fiche-panel');
      const i = +t.dataset.fi;
      panel.querySelectorAll('.fiche-thumb').forEach((b, k) => b.classList.toggle('is-active', k === i));
      panel.querySelectorAll('.fiche-img').forEach((im, k) => im.classList.toggle('is-active', k === i));
    });

    // Options QR + Socle : bascule visuelle + choix mémorisés pour la commande
    modal.addEventListener('change', (e) => {
      const inp = e.target.closest('.fiche-qr-opt input');
      if (!inp) return;
      const panel = inp.closest('.fiche-panel');
      const pk = panel.dataset.avKey;
      if (!pk) return;
      if (inp.dataset.opt === 'qr') panel.dataset.avQr = inp.value === 'avec' ? '1' : '';
      if (inp.dataset.opt === 'socle') panel.dataset.avSocle = inp.value === 'avec' ? '1' : '';
      const bank = document.getElementById('fiche-photo-bank');
      if (bank) {
        /* aperçu = f(QR, socle) : 4 états, jamais d'incohérence */
        const pick = (sfx) => bank.querySelector('img[data-fk="' + pk + '|' + sfx + '"]');
        const hasQ = panel.dataset.avQr === '1', hasS = panel.dataset.avSocle === '1';
        const srcImg = (hasS && hasQ && pick('socleqr')) || (hasS && pick('socle')) || (hasQ && pick('qr')) || pick('0');
        if (srcImg) {
          const slot0 = panel.querySelectorAll('.fiche-img')[0];
          const th0 = panel.querySelectorAll('.fiche-thumb')[0];
          if (slot0) { const im = slot0.querySelector('img'); if (im) im.src = srcImg.getAttribute('src'); }
          if (th0) { const im = th0.querySelector('img'); if (im) im.src = srcImg.getAttribute('src'); }
          panel.querySelectorAll('.fiche-thumb').forEach((b, k) => b.classList.toggle('is-active', k === 0));
          panel.querySelectorAll('.fiche-img').forEach((im, k) => im.classList.toggle('is-active', k === 0));
        }
      }
      /* cohérence : vue verso QR visible seulement AVEC QR */
      if (inp.dataset.opt === 'qr') {
        const th3 = panel.querySelectorAll('.fiche-thumb')[3];
        if (th3) th3.hidden = !panel.dataset.avQr;
      }
      /* cohérence : « NFC + QR code » -> « NFC » quand SANS QR */
      panel.querySelectorAll('li, span.chip, .fiche-chips span').forEach((el) => {
        const txt = (el.dataset.avqrTxt || el.textContent).trim();
        if (txt === 'NFC + QR code' || txt === 'NFC') {
          if (!el.dataset.avqrTxt) el.dataset.avqrTxt = txt === 'NFC' ? 'NFC' : 'NFC + QR code';
          if (el.dataset.avqrTxt === 'NFC + QR code') el.textContent = panel.dataset.avQr ? 'NFC + QR code' : 'NFC';
        }
      });
      /* le prix / nom / résumé se recalculent (refresh = autorité) */
      if (window.avTierRefreshAll) window.avTierRefreshAll();
    });

    // V52 : ouverture/fermeture PHYSIQUE des accordéons de fiche (ultra fluide)
    (function smoothDetails() {
      const reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
      modal.querySelectorAll('details').forEach((det) => {
        const summary = det.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          if (reduced || !det.animate) return; // natif si mouvement réduit
          e.preventDefault();
          if (det._busy) return;
          det._busy = true;
          const cs = getComputedStyle(det);
          const extra = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)
                      + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
          const startH = det.offsetHeight;
          const kids = () => Array.from(det.children).filter((c) => c !== summary);
          const finish = () => { det.style.height = ''; det.style.overflow = ''; det._busy = false; };
          if (!det.open) {
            det.open = true;
            const endH = det.offsetHeight;
            det.style.overflow = 'hidden';
            det.animate({ height: [startH + 'px', endH + 'px'] }, { duration: 480, easing: EASE }).onfinish = finish;
            kids().forEach((k) => k.animate(
              { opacity: [0, 1], transform: ['translateY(-8px)', 'none'] },
              { duration: 420, delay: 70, easing: EASE, fill: 'backwards' }));
          } else {
            const endH = summary.offsetHeight + extra;
            det.style.overflow = 'hidden';
            kids().forEach((k) => k.animate({ opacity: [1, 0] }, { duration: 180, easing: 'ease-out' }));
            det.animate({ height: [startH + 'px', endH + 'px'] }, { duration: 380, easing: EASE }).onfinish = () => {
              det.open = false; finish();
            };
          }
        });
      });
    })();

    // Ajout panier depuis la fiche : la fiche s'efface proprement (déverrouillage du scroll inclus)
    modal.querySelectorAll('.add-cart').forEach((b) => b.addEventListener('click', () => close()));
    // Lien devis : fermer proprement puis laisser le défilement se faire
    modal.querySelectorAll('.fiche-devis').forEach((a) => a.addEventListener('click', close));
  })();


  /* =========================================================
     V30 — Sortie parallaxe du hero (profondeur au scroll)
     ========================================================= */
  (function heroExit() {
    const hero = document.querySelector('.hero');
    if (!hero) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const h = hero.offsetHeight || 1;
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      hero.style.setProperty('--hx', Math.min(1, Math.max(0, y / (h * 0.85))).toFixed(3));
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  /* =========================================================
     V30 — Titres de sections : révélation mot à mot
     ========================================================= */
  (function titresCine() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.section-head h2').forEach((h2) => {
      const head = h2.closest('.section-head');
      if (!head || head.classList.contains('visible')) return;
      const wrap = (node) => {
        Array.from(node.childNodes).forEach((child) => {
          if (child.nodeType === 3) {
            if (!child.textContent.trim()) return;
            const frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach((part) => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              const o = document.createElement('span'); o.className = 'w2';
              const i = document.createElement('span'); i.className = 'w2i';
              i.textContent = part;
              o.appendChild(i); frag.appendChild(o);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) wrap(child);
        });
      };
      wrap(h2);
      h2.querySelectorAll('.w2i').forEach((el, k) => {
        el.style.transitionDelay = (0.05 + k * 0.055).toFixed(3) + 's';
      });
    });
  })();


  /* =========================================================
     V34 — LA COLLECTION : catalogue à onglets (formes réelles)
     ========================================================= */
  (function collectionShowroom() {
    const track = document.getElementById('col-track');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('.col-slide'));
    const thumbs = Array.from(document.querySelectorAll('.col-thumb'));
    const tabs = Array.from(document.querySelectorAll('.col-tab'));
    const tabsBar = document.getElementById('col-tabs');
    const ghost = document.getElementById('col-ghost');
    const nameEl = document.getElementById('col-name');
    const tagEl = document.getElementById('col-tag');
    const benEl = document.getElementById('col-ben');
    const addBtn = document.getElementById('col-add');
    const cfgBtn = document.getElementById('col-config');
    const priceEl = document.getElementById('col-price');
    const glow = document.getElementById('col-glow');
    const info = document.getElementById('col-info');
    const section = document.getElementById('collection');
    const ficheLink = document.getElementById('col-fiche-link');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = 0;

    const visibles = () => slides.filter((s) => !s.hidden);
    const centerOf = (el) => el.offsetLeft + el.offsetWidth / 2;
    let lockUntil = 0; // pendant un défilement programmé, la sélection est déjà engagée
    const goToSlide = (s, smooth) => {
      setActive(slides.indexOf(s));
      lockUntil = performance.now() + (smooth && !reduced ? 950 : 120);
      track.scrollTo({
        left: centerOf(s) - track.clientWidth / 2,
        behavior: smooth && !reduced ? 'smooth' : 'auto'
      });
    };
    const goTo = (i, smooth) => {
      const vis = visibles();
      if (!vis.length) return;
      const cur = slides[active];
      let idx = vis.indexOf(cur);
      if (idx === -1) idx = 0;
      i = Math.max(0, Math.min(vis.length - 1, i));
      goToSlide(vis[i], smooth);
    };
    const stepFrom = (delta) => {
      const vis = visibles();
      const idx = Math.max(0, vis.indexOf(slides[active]));
      const target = Math.max(0, Math.min(vis.length - 1, idx + delta));
      goToSlide(vis[target], true);
    };

    const setActive = (k) => {
      if (k === active && slides[k].classList.contains('is-on')) return;
      active = k;
      const d = slides[k].dataset;
      slides.forEach((s, x) => s.classList.toggle('is-on', x === k));
      thumbs.forEach((t, x) => {
        t.classList.toggle('is-on', x === k);
        t.setAttribute('aria-selected', x === k ? 'true' : 'false');
      });
      const th = thumbs[k];
      /* V58.1 : défilement HORIZONTAL isolé — scrollIntoView faisait bouger la page entière */
      if (th && th.parentElement) {
        const box = th.parentElement;
        const tgt = th.offsetLeft - (box.clientWidth - th.offsetWidth) / 2;
        const max = box.scrollWidth - box.clientWidth;
        box.scrollTo({ left: Math.max(0, Math.min(max, tgt)), behavior: 'smooth' });
      }
      if (ghost) ghost.textContent = d.name;
      if (section) section.style.setProperty('--col-a', d.accent);
      if (glow) glow.style.background = d.accent;
      const isConfig = d.fiche === 'config';
      if (addBtn) {
        addBtn.hidden = isConfig;
        if (!isConfig) { addBtn.dataset.name = d.cart; addBtn.dataset.price = d.price; addBtn.dataset.key = d.key; }
      }
      if (cfgBtn) {
        cfgBtn.textContent = isConfig ? 'Créer mon design' : 'Personnaliser';
        cfgBtn.classList.toggle('btn-gold', isConfig);
        cfgBtn.classList.toggle('btn-line', !isConfig);
      }
      if (priceEl) priceEl.textContent = d.pricetxt; if (window.avTierRefreshAll) window.avTierRefreshAll();
      if (info) { info.classList.remove('swap'); void info.offsetWidth; info.classList.add('swap'); }
      if (nameEl) nameEl.textContent = window.avT(d.name);
      if (tagEl) tagEl.textContent = window.avT(d.tag);
      if (benEl) benEl.innerHTML = d.ben.split('|').map((b) => '<li>' + window.avT(b) + '</li>').join('');
    };

    // ---- Onglets : filtre + état actif ----
    const setCat = (cat, scrollBack) => {
      tabs.forEach((t) => {
        const on = t.dataset.cat === cat;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slides.forEach((s) => { s.hidden = !(cat === 'tout' || s.dataset.cat.split(' ').indexOf(cat) !== -1); });
      thumbs.forEach((t, x) => { t.hidden = slides[x].hidden; });
      const vis = visibles();
      if (vis.length) {
        const first = vis[0];
        setActive(slides.indexOf(first));
        requestAnimationFrame(() => goToSlide(first, false));
      }
      if (scrollBack && tabsBar) {
        const y = tabsBar.getBoundingClientRect().bottom;
        if (y < 0 || y > window.innerHeight * 0.6) {
          document.getElementById('col-stage').scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
        }
      }
    };
    tabs.forEach((t) => t.addEventListener('click', () => setCat(t.dataset.cat, true)));

    // Ombre de la barre quand elle est collée
    if ('IntersectionObserver' in window && tabsBar) {
      const sent = document.getElementById('col-tabs-sentinel');
      if (sent) new IntersectionObserver((es) => {
        tabsBar.classList.toggle('is-stuck', !es[0].isIntersecting);
      }).observe(sent);
    }

    // ---- Fiche produit ----
    const fillReseau = (s) => {
      const d = s.dataset;
      const cardBox = document.getElementById('fr-card');
      if (cardBox) {
        cardBox.innerHTML = '';
        const src = s.querySelector('.nfc3d, .pq3d');
        if (src) {
          const clone = src.cloneNode(true);
          clone.querySelectorAll('.n3-badge').forEach((b) => b.remove());
          cardBox.appendChild(clone);
        }
      }
      const chipSrc = s.querySelector('.n3-mark, .pq3-mark');
      const pq = document.getElementById('fr-pq');
      if (pq && chipSrc) {
        pq.style.setProperty('--pqa', d.accent);
        pq.classList.toggle('pq-dark', d.key === 'snapchat');
        pq.classList.toggle('pq-insta', d.key === 'instagram' || d.key === 'plqinsta');
        const pqChip = document.getElementById('fr-pq-chip');
        pqChip.innerHTML = chipSrc.innerHTML;
        pqChip.style.background = (d.key === 'aviscarte' || d.key === 'avisplq') ? '#FFFFFF' : d.accent;
        document.getElementById('fr-pq-name').textContent = d.name.replace('Plaque ', '').replace('Carte ', '');
        document.getElementById('fr-pq-cta').textContent = '« ' + window.avT(d.cta) + ' »';
        const pat = document.getElementById('fr-pattern');
        pat.innerHTML = '';
        for (let k = 0; k < 7; k++) {
          const g = document.createElement('span');
          g.innerHTML = chipSrc.innerHTML;
          pat.appendChild(g);
        }
      }
      document.getElementById('fr-title').textContent = window.avT(d.cart);
      document.getElementById('fr-desc').textContent = window.avT(d.tag);
      document.getElementById('fr-step2').textContent = window.AVLANG === 'en'
        ? 'Your ' + d.name.replace('Plaque ', '').replace('Carte ', '') + ' ' + (d.key.indexOf('facebook') !== -1 ? 'page' : 'link') + ' opens — no app needed'
        : 'Votre ' + (d.key.indexOf('facebook') !== -1 ? 'page' : 'lien') + ' ' + d.name.replace('Plaque ', '').replace('Carte ', '') + " s'ouvre — sans application";
      document.getElementById('fr-ben').innerHTML =
        d.ben.split('|').map((b) => '<li>' + window.avT(b) + '</li>').join('') +
        '<li>NFC + QR code</li><li>' + window.avT('Sans abonnement') + '</li>';
      const fa = document.getElementById('fr-add');
      fa.dataset.name = d.cart; fa.dataset.price = d.price; fa.dataset.key = d.key;
      const fp = document.getElementById('fr-perso');
      if (fp) fp.dataset.perso = d.key;
      document.getElementById('fr-badge').textContent = window.avT(d.shape === 'rond' ? 'Support rond' : d.form === 'plq' ? 'Plaque comptoir & vitrine' : 'Carte format bancaire');
      // format plaque -> le visuel plaque en premier
      const panel = document.querySelector('.fiche-panel[data-fiche-panel="reseau"]');
      const squarePlq = d.form === 'plq' && d.shape !== 'rond';
      const first = squarePlq ? 1 : 0;
      panel.querySelectorAll('.fiche-thumb').forEach((b, x) => {
        b.classList.toggle('is-active', x === first);
        if (x === 1) b.hidden = !squarePlq;
      });
      panel.querySelectorAll('.fiche-img').forEach((im, x) => im.classList.toggle('is-active', x === first));
    };

    const openFicheFor = (s) => {
      const key = s.dataset.fiche;
      if (key === 'config') {
        const cfg = document.getElementById('config');
        if (cfg) cfg.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
        return;
      }
      if (!window.avOpenFiche) return;
      if (key === 'reseau') fillReseau(s);
      window.avOpenFiche(key, s);
    };

    slides.forEach((s, k) => {
      s.addEventListener('click', () => {
        if (k !== active) { goToSlide(s, true); return; }
        openFicheFor(s);
      });
    });
    if (ficheLink) ficheLink.addEventListener('click', () => openFicheFor(slides[active]));
    if (cfgBtn) cfgBtn.addEventListener('click', () => {
      if (window.avConfigFor) window.avConfigFor(slides[active].dataset.key);
    });

    // ---- Sélection = produit le plus proche du centre ----
    let ticking = false;
    const sync = () => {
      ticking = false;
      if (performance.now() < lockUntil) return;
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = -1, dist = Infinity;
      slides.forEach((s, k) => {
        if (s.hidden) return;
        const d2 = Math.abs(centerOf(s) - mid);
        if (d2 < dist) { dist = d2; best = k; }
      });
      if (best !== -1) setActive(best);
    };
    track.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });

    document.getElementById('col-prev').addEventListener('click', () => stepFrom(-1));
    document.getElementById('col-next').addEventListener('click', () => stepFrom(1));
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const s = slides[+t.dataset.i];
      if (!s.hidden) goToSlide(s, true);
    }));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); stepFrom(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); stepFrom(1); }
      if (e.key === 'Enter') { e.preventDefault(); openFicheFor(slides[active]); }
    });
    window.addEventListener('resize', () => { const s = slides[active]; if (!s.hidden) goToSlide(s, false); }, { passive: true });
    window.avColRefresh = () => { if (slides[active] && !slides[active].hidden) setActive(active); };
    requestAnimationFrame(() => { const v = visibles(); if (v.length) goToSlide(v[0], false); });
  })();


  /* =========================================================
     V35 — LE CONFIGURATEUR
     ========================================================= */
  (function configurateur() {
    const obj = document.getElementById('cf-obj');
    if (!obj) return;
    const front = document.getElementById('cf-front');
    const flip = document.getElementById('cf-flip');
    const logo = document.getElementById('cf-logo');
    const chip = document.getElementById('cf-chip');
    const nameEl = document.getElementById('cf-name-el');
    const subEl = document.getElementById('cf-sub-el');
    const glow = document.getElementById('cf-glow');
    const addBtn = document.getElementById('cf-add');
    const priceEl = document.getElementById('cf-price');
    const upmeta = document.getElementById('cf-upmeta');
    const hint = document.getElementById('cf-hint');
    const scale = document.getElementById('cf-scale');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const BGS = {
      navy: { fill: 'linear-gradient(155deg, #0E3355 0%, #071B2D 55%, #05121E 100%)', light: false },
      noir: { fill: 'linear-gradient(155deg, #262B33 0%, #14171C 55%, #0A0C0F 100%)', light: false },
      ivoire: { fill: 'linear-gradient(155deg, #FDFAF3 0%, #F1E7CF 60%, #E4D6B4 100%)', light: true }
    };
    const PLATS = {};
    document.querySelectorAll('#cf-plats [data-plat]').forEach((b) => {
      if (b.dataset.plat !== 'none') PLATS[b.dataset.plat] = { html: b.innerHTML, bg: b.style.getPropertyValue('--pb') || '#FFFFFF', label: b.dataset.name };
    });

    const state = { sup: 'carte', bg: 'navy', color: '#0A3D62', plat: 'none', name: '', sub: '', up: null, mode: 'logo', size: 36, x: 50, y: 34, rot: 0, accent0: '' };
    const history = [];
    const pushSnap = () => {
      history.push(JSON.stringify({ s: { ...state, up: state.up ? { url: state.up.url, name: state.up.name, ratio: state.up.ratio, color: state.up.color } : null } }));
      if (history.length > 15) history.shift();
    };

    const INSTA = 'linear-gradient(140deg, #FEDA75 0%, #FA7E1E 26%, #D62976 55%, #962FBF 80%, #4F5BD5 100%)';
    const lumOf = (hex) => {
      const c = (hex || '#000000').replace('#', '');
      return parseInt(c.substr(0, 2), 16) * 0.299 + parseInt(c.substr(2, 2), 16) * 0.587 + parseInt(c.substr(4, 2), 16) * 0.114;
    };
    const platAccent = () => state.plat !== 'none'
      ? (PLATS[state.plat].bg === '#FFFFFF' ? '#E1BC72' : PLATS[state.plat].bg)
      : (state.accent0 || '#E1BC72');
    const applyBg = () => {
      let fill, light;
      if (state.bg === 'plat') {
        if (state.plat === 'instagram') { fill = INSTA; light = false; }
        else {
          const a = platAccent();
          fill = 'linear-gradient(155deg, color-mix(in srgb, ' + a + ' 86%, #FFFFFF 14%) 0%, ' + a + ' 48%, color-mix(in srgb, ' + a + ' 70%, #000000 30%) 100%)';
          light = lumOf(a) > 168;
        }
      } else if (state.bg === 'custom') {
        fill = 'linear-gradient(155deg, color-mix(in srgb, ' + state.color + ' 82%, #FFFFFF 18%) 0%, ' + state.color + ' 50%, color-mix(in srgb, ' + state.color + ' 65%, #000000 35%) 100%)';
        light = lumOf(state.color) > 168;
      } else { fill = BGS[state.bg].fill; light = BGS[state.bg].light; }
      if (state.up && state.mode === 'fond') {
        front.style.background = 'center / cover no-repeat url("' + state.up.url + '"), ' + fill;
      } else {
        front.style.background = fill;
      }
      obj.classList.toggle('cf-light', light);
      chip.classList.toggle('cf-onbrand', state.bg === 'plat');
    };

    const summary = () => {
      const parts = [];
      parts.push(window.avT('Fond') + ' ' + (state.bg === 'custom' ? state.color : state.bg));
      if (state.plat !== 'none') parts.push(PLATS[state.plat].label);
      if (state.name) parts.push('« ' + state.name + (state.sub ? ' / ' + state.sub : '') + ' »');
      if (state.up) parts.push(window.avT(state.mode === 'fond' ? 'design complet fourni' : 'logo fourni'));
      return parts.join(' · ').slice(0, 140);
    };

    const applyAll = () => {
      // support (morphing)
      obj.classList.toggle('cfo-carte', state.sup === 'carte');
      obj.classList.toggle('cfo-plaque', state.sup === 'plaque');
      // plateforme
      if (state.plat === 'none') { chip.hidden = true; }
      else {
        chip.hidden = false;
        chip.innerHTML = PLATS[state.plat].html;
        chip.style.background = PLATS[state.plat].bg;
      }
      // textes (une plaque réseau affiche la plateforme par défaut)
      const defName = (state.sup === 'plaque' && state.plat !== 'none') ? window.avT(PLATS[state.plat].label) : window.avT('Votre Nom');
      nameEl.textContent = state.name || defName;
      subEl.textContent = state.sub || (state.plat !== 'none' ? (state.sup === 'plaque' ? window.avT('Approchez votre téléphone') : '@votre-compte') : window.avT('Votre activité · Votre ville'));
      nameEl.classList.toggle('cf-placeholder', !state.name);
      // logo
      if (state.up && state.mode === 'logo') {
        logo.hidden = false;
        logo.src = state.up.url;
        logo.style.width = state.size + '%';
        logo.style.left = state.x + '%';
        logo.style.top = state.y + '%';
        logo.style.transform = 'translate(-50%, -50%) rotate(' + (state.rot || 0) + 'deg)';
      } else { logo.hidden = true; }
      applyBg();
      // accent
      const accent = state.plat !== 'none' ? platAccent()
        : (state.up && state.up.color ? state.up.color : (state.accent0 || '#E1BC72'));
      obj.style.setProperty('--brand', accent);
      if (glow) glow.style.background = accent;
      // panier
      const isCarte = state.sup === 'carte';
      addBtn.dataset.name = (isCarte ? 'Carte' : 'Plaque') + ' personnalisée' + (state.plat !== 'none' ? ' · ' + PLATS[state.plat].label : '');
      addBtn.dataset.price = isCarte ? 4499 : 5999;
      addBtn.dataset.note = summary();
      priceEl.textContent = isCarte ? '44,99 €' : '59,99 €';
    };

    // ---- Support / fond / plateforme / mode : segments ----
    const seg = (rootId, attr, cb) => {
      const root = document.getElementById(rootId);
      if (!root) return;
      root.addEventListener('click', (e) => {
        const b = e.target.closest('[data-' + attr + ']');
        if (!b) return;
        pushSnap();
        root.querySelectorAll('[data-' + attr + ']').forEach((x) => x.classList.toggle('is-on', x === b));
        cb(b.dataset[attr]);
        applyAll();
      });
    };
    seg('cf-support', 'sup', (v) => { state.sup = v; });
    seg('cf-bg', 'bg', (v) => { state.bg = v; });
    seg('cf-plats', 'plat', (v) => { state.plat = v; });
    seg('cf-mode', 'mode', (v) => { state.mode = v; });
    document.getElementById('cf-color').addEventListener('input', (e) => {
      state.color = e.target.value; state.bg = 'custom';
      document.querySelectorAll('#cf-bg [data-bg]').forEach((x) => x.classList.remove('is-on'));
      e.target.closest('.cf-custom').classList.add('is-on');
      applyAll();
    });
    document.getElementById('cf-color').closest('.cf-custom').addEventListener('click', () => {});

    // ---- Textes ----
    document.getElementById('cf-name').addEventListener('input', (e) => { state.name = e.target.value.trim(); applyAll(); });
    document.getElementById('cf-sub').addEventListener('input', (e) => { state.sub = e.target.value.trim(); applyAll(); });

    // ---- Upload + analyse ----
    const fileInput = document.getElementById('cf-file');
    const drop = document.getElementById('cf-drop');
    const upmsg = document.getElementById('cf-upmsg');
    const upErr = (msg) => {
      if (upmsg) { upmsg.textContent = msg; upmsg.hidden = false; }
      fileInput.value = '';
    };
    const analyse = (file) => {
      if (!file) return;
      if (file.size > 25 * 1024 * 1024) {
        upErr(window.avT('Fichier trop lourd (25 Mo max). Compressez votre fichier et réessayez.')); return;
      }
      /* V58.1 : TOUS les formats sont acceptés. On ne se fie plus au type MIME
         (les photos iPhone et certains fichiers arrivent sans type déclaré et
         étaient écartés de l'aperçu à tort) : on tente le chargement réel, et
         on ne bascule sur le message « sans aperçu » que si l'image échoue. */
      var noPreview = function () {
        if (upmsg) {
          upmsg.textContent = '✓ ' + file.name + ' — '
            + (window.AVLANG === 'en'
              ? 'file received. No live preview for this format — we validate it together on the proof (BAT).'
              : 'fichier reçu. Pas d\'aperçu en direct pour ce format — nous le validons ensemble au BAT.');
          upmsg.hidden = false;
          upmsg.classList.add('up-ok');
        }
      };
      if (upmsg) upmsg.classList.remove('up-ok');
      if (state.up && state.up.url) { try { URL.revokeObjectURL(state.up.url); } catch (e) {} }
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onerror = () => { URL.revokeObjectURL(url); noPreview(); };
      img.onload = () => {
        if (upmsg) upmsg.hidden = true;
        const ratio = img.naturalWidth / Math.max(1, img.naturalHeight);
        // couleur dominante (échantillon 24x24)
        let color = '';
        try {
          const cv = document.createElement('canvas');
          cv.width = 24; cv.height = 24;
          const cx = cv.getContext('2d');
          cx.drawImage(img, 0, 0, 24, 24);
          const px = cx.getImageData(0, 0, 24, 24).data;
          let br = 0, bg2 = 0, bb = 0, bs = -1;
          for (let k = 0; k < px.length; k += 4) {
            const r = px[k], g = px[k + 1], b = px[k + 2], a = px[k + 3];
            if (a < 120) continue;
            const mx = Math.max(r, g, b), mn = Math.min(r, g, b);
            const sat = mx - mn, lum = (r + g + b) / 3;
            const score = sat * (lum > 30 && lum < 235 ? 1 : 0.15);
            if (score > bs) { bs = score; br = r; bg2 = g; bb = b; }
          }
          if (bs > 24) color = '#' + [br, bg2, bb].map((v) => v.toString(16).padStart(2, '0')).join('');
        } catch (e) { /* image non lisible en canvas : pas d'accent */ }
        state.up = { url, name: file.name, ratio, color };
        state.mode = ratio > 1.45 ? 'fond' : 'logo';
        state.size = 36; state.x = 50; state.y = 34;
        document.querySelectorAll('#cf-mode [data-mode]').forEach((x) => x.classList.toggle('is-on', x.dataset.mode === state.mode));
        document.getElementById('cf-upname').textContent = file.name.length > 26 ? file.name.slice(0, 24) + '…' : file.name;
        upmeta.hidden = false;
        hint.textContent = window.avT(state.mode === 'fond'
          ? 'Format paysage détecté : appliqué en design complet. Passez sur « Logo » pour le réduire.'
          : 'Logo détecté : glissez-le directement sur l\'aperçu pour le placer.');
        applyAll();
      };
      img.src = url;
    };
    fileInput.addEventListener('change', () => analyse(fileInput.files[0]));
    ['dragover', 'dragenter'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-drag'); }));
    ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-drag'); }));
    drop.addEventListener('drop', (e) => { if (e.dataTransfer.files[0]) analyse(e.dataTransfer.files[0]); });

    document.getElementById('cf-remove').addEventListener('click', () => {
      if (state.up && state.up.url) { try { URL.revokeObjectURL(state.up.url); } catch (e) {} }
      state.up = null; upmeta.hidden = true; fileInput.value = '';
      if (upmsg) upmsg.hidden = true;
      applyAll();
    });
    scale.addEventListener('change', pushSnap);
    scale.addEventListener('input', () => { state.size = +scale.value; applyAll(); });
    const rot = document.getElementById('cf-rot');
    rot.addEventListener('change', pushSnap);
    rot.addEventListener('input', () => { state.rot = +rot.value; applyAll(); });

    // ---- Drag du logo sur l'aperçu ----
    let dragging = false;
    logo.addEventListener('pointerdown', (e) => {
      pushSnap();
      dragging = true;
      logo.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    logo.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const r = front.getBoundingClientRect();
      state.x = Math.min(92, Math.max(8, ((e.clientX - r.left) / r.width) * 100));
      state.y = Math.min(88, Math.max(10, ((e.clientY - r.top) / r.height) * 100));
      logo.style.left = state.x + '%';
      logo.style.top = state.y + '%';
    });
    ['pointerup', 'pointercancel'].forEach((ev) => logo.addEventListener(ev, () => { dragging = false; applyAll(); }));

    // ---- Vues ----
    const syncUI = () => {
      document.querySelectorAll('#cf-support [data-sup]').forEach((x) => x.classList.toggle('is-on', x.dataset.sup === state.sup));
      document.querySelectorAll('#cf-bg [data-bg]').forEach((x) => x.classList.toggle('is-on', x.dataset.bg === state.bg));
      document.querySelector('#cf-bg .cf-custom').classList.toggle('is-on', state.bg === 'custom');
      document.querySelectorAll('#cf-plats [data-plat]').forEach((x) => x.classList.toggle('is-on', x.dataset.plat === state.plat));
      document.querySelectorAll('#cf-mode [data-mode]').forEach((x) => x.classList.toggle('is-on', x.dataset.mode === state.mode));
      document.getElementById('cf-name').value = state.name;
      document.getElementById('cf-sub').value = state.sub;
      scale.value = state.size; rot.value = state.rot || 0;
      upmeta.hidden = !state.up;
    };
    document.getElementById('cf-undo').addEventListener('click', () => {
      if (!history.length) return;
      const snap = JSON.parse(history.pop()).s;
      Object.assign(state, snap);
      syncUI(); applyAll();
    });

    window.avCfRefresh = () => { syncUI(); applyAll(); };
    // Personnaliser CE produit (collection / fiche)
    window.avConfigFor = (key) => {
      const s = document.querySelector('.col-slide[data-key="' + key + '"]');
      if (!s) return;
      const d = s.dataset;
      pushSnap();
      const MAP = { aviscarte: 'avis', avisplq: 'avis', instagram: 'instagram', plqinsta: 'instagram',
                    whatsapp: 'whatsapp', plqwa: 'whatsapp', snapchat: 'snapchat', tiktok: 'tiktok',
                    linkedin: 'linkedin', facebook: 'facebook' };
      state.sup = d.form === 'plq' ? 'plaque' : 'carte';
      state.plat = MAP[key] || 'none';
      state.accent0 = d.accent || '';
      state.bg = (state.plat !== 'none' && state.plat !== 'avis') ? 'plat' : (key === 'aviscarte' ? 'ivoire' : 'navy');
      const ctx = document.getElementById('cf-context');
      if (ctx) ctx.innerHTML = window.avT('Personnalisez votre') + ' <em>' + window.avT(d.name) + '</em>';
      syncUI(); applyAll();
    };
    document.querySelectorAll('.fiche-perso').forEach((b) => {
      b.addEventListener('click', () => {
        const modal = document.getElementById('fiche-modal');
        if (modal && modal.classList.contains('open')) { modal.classList.remove('open'); avUnlock(); }
        if (b.dataset.perso) window.avConfigFor(b.dataset.perso);
        const cfg = document.getElementById('config');
        if (cfg) cfg.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      });
    });

    document.getElementById('cf-rotate').addEventListener('click', function () {
      flip.classList.toggle('is-back');
      this.textContent = window.avT(flip.classList.contains('is-back') ? '↻ Voir le recto' : '↻ Voir le verso');
    });
    document.getElementById('cf-center').addEventListener('click', () => { state.x = 50; state.y = 34; applyAll(); });
    document.getElementById('cf-reset').addEventListener('click', () => {
      Object.assign(state, { sup: 'carte', bg: 'navy', color: '#0A3D62', plat: 'none', name: '', sub: '', up: null, mode: 'logo', size: 36, x: 50, y: 34, rot: 0, accent0: '' });
      history.length = 0;
      const ctx = document.getElementById('cf-context');
      if (ctx) ctx.textContent = window.avT('Personnalisez votre modèle');
      document.getElementById('cf-name').value = '';
      document.getElementById('cf-sub').value = '';
      fileInput.value = ''; upmeta.hidden = true;
      flip.classList.remove('is-back');
      document.getElementById('cf-rotate').textContent = '↻ Voir le verso';
      document.querySelectorAll('#cf-support [data-sup]').forEach((x) => x.classList.toggle('is-on', x.dataset.sup === 'carte'));
      document.querySelectorAll('#cf-bg [data-bg]').forEach((x) => x.classList.toggle('is-on', x.dataset.bg === 'navy'));
      document.querySelector('#cf-bg .cf-custom').classList.remove('is-on');
      document.querySelectorAll('#cf-plats [data-plat]').forEach((x) => x.classList.toggle('is-on', x.dataset.plat === 'none'));
      document.querySelectorAll('#cf-mode [data-mode]').forEach((x) => x.classList.toggle('is-on', x.dataset.mode === 'logo'));
      applyAll();
    });

    applyAll();
  })();



  /* =========================================================
     V36 — CRÉONS VOTRE SITE : fiche projet en 5 étapes
     ========================================================= */
  (function ficheProjet() {
    const form = document.getElementById('quote-form');
    if (!form || !form.classList.contains('site-flow')) return;
    const steps = Array.from(form.querySelectorAll('.sf-step'));
    const label = document.getElementById('sf-label');
    const bar = document.getElementById('sf-bar');
    const prev = document.getElementById('sf-prev');
    const next = document.getElementById('sf-next');
    const NAMES = ['Votre activité', 'Votre projet', 'Vos besoins', 'Votre identité', 'Vos coordonnées', 'Votre projet est prêt'];
    let cur = 1;

    const show = (n) => {
      cur = Math.max(1, Math.min(6, n));
      steps.forEach((s) => s.classList.toggle('is-on', +s.dataset.step === cur));
      label.textContent = (cur < 6 ? 'Étape 0' + cur + ' · ' : '') + NAMES[cur - 1];
      bar.style.width = (cur / 6 * 100) + '%';
      prev.hidden = cur === 1;
      next.hidden = cur >= 6;
      next.textContent = cur === 5 ? 'Voir mon projet →' : 'Continuer →';
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // choix simples (cartes) : étapes 1 & 2 -> avance automatique
    [['sf-c1', 'sf-activite'], ['sf-c2', 'sf-projet']].forEach(([rowId, hidId]) => {
      const row = document.getElementById(rowId);
      row.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-v]');
        if (!b) return;
        row.querySelectorAll('button').forEach((x) => x.classList.toggle('is-on', x === b));
        document.getElementById(hidId).value = b.dataset.v;
        setTimeout(() => show(cur + 1), 260);
      });
    });
    // besoins (multi)
    const c3 = document.getElementById('sf-c3');
    c3.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-v]');
      if (!b) return;
      b.classList.toggle('is-on');
      document.getElementById('sf-besoins').value =
        Array.from(c3.querySelectorAll('.is-on')).map((x) => x.dataset.v).join(', ');
    });
    // identité (oui/non)
    document.getElementById('sf-c4').addEventListener('click', (e) => {
      const b = e.target.closest('button[data-v]');
      if (!b) return;
      b.parentElement.querySelectorAll('button').forEach((x) => x.classList.toggle('is-on', x === b));
      document.getElementById('sf-identite').value =
        Array.from(document.querySelectorAll('.sf-idrow')).map((r) =>
          r.dataset.k + ' : ' + r.querySelector('.sf-yn .is-on').dataset.v).join(' · ');
    });
    document.getElementById('sf-identite').value = 'Logo : À créer · Charte graphique : À créer · Photos : À prévoir';

    const fieldOk = () => {
      const name = document.getElementById('fullname').value.trim();
      const phone = document.getElementById('phone').value.trim();
      const email = document.getElementById('email').value.trim();
      return name && phone.length >= 8 && /.+@.+\..+/.test(email) && document.getElementById('privacy').checked;
    };
    const recap = () => {
      const rows = [
        [window.avT('Activité'), document.getElementById('sf-activite').value],
        [window.avT('Type de site'), document.getElementById('sf-projet').value],
        [window.avT('Besoins'), document.getElementById('sf-besoins').value || window.avT('À préciser ensemble')],
        [window.avT('Éléments'), (function () { var v = document.getElementById('sf-fichiers'); var n = v && v.value ? v.value.split(' · ').length : 0; return n ? n + ' ' + window.avT(n > 1 ? 'fichiers' : 'fichier') + ' — ' + v.value : window.avT('Aucun fichier (envoi possible ensuite)'); })()],
        [window.avT('Identité'), document.getElementById('sf-identite').value],
        ['Contact', document.getElementById('fullname').value + ' · ' + document.getElementById('phone').value]
      ];
      document.getElementById('sf-recap').innerHTML =
        rows.map(([k, v]) => '<div><dt>' + k + '</dt><dd>' + String(v).replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])) + '</dd></div>').join('');
    };

    next.addEventListener('click', () => {
      if (cur === 1 && !document.getElementById('sf-activite').value) { show(1); return; }
      if (cur === 2 && !document.getElementById('sf-projet').value) { show(2); return; }
      if (cur === 5) {
        if (!fieldOk()) {
          const fb = document.getElementById('form-feedback');
          fb.textContent = window.avT('Merci de renseigner nom, téléphone, e-mail valide et d\'accepter la politique de confidentialité.');
          fb.className = 'form-feedback error';
          return;
        }
        document.getElementById('form-feedback').textContent = '';
        recap();
      }
      show(cur + 1);
    });
    prev.addEventListener('click', () => show(cur - 1));
    document.getElementById('sf-edit').addEventListener('click', () => show(1));
  })();

  /* curseur suiveur retiré (V19) */

  (function magneticButtons() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.btn-gold, .btn-azure, .carousel-arrow:not(.lightbox-btn)').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${(x * 0.18).toFixed(1)}px, ${(y * 0.22).toFixed(1)}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  })();


  /* =========================================================
     V5 — 17. Modales légales (mentions, confidentialité, CGV)
     ========================================================= */
  (function legalModals() {
    const modal = document.getElementById('legal-modal');
    if (!modal) return;
    const sheet = modal.querySelector('.legal-sheet');
    const open = (key) => {
      modal.querySelectorAll('.legal-article').forEach(a => a.classList.remove('active'));
      const el = document.getElementById('legal-' + key);
      if (el) el.classList.add('active');
      modal.classList.add('open');
      avLock();
      if (sheet) sheet.scrollTop = 0;
    };
    const close = () => { modal.classList.remove('open'); avUnlock(); };
    document.querySelectorAll('[data-legal]').forEach(a => {
      a.addEventListener('click', (e) => { e.preventDefault(); open(a.dataset.legal); });
    });
    document.getElementById('legal-close').addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  })();


  /* =========================================================
     V6 — 18. Barre sticky mobile : s'efface sur le formulaire
     ========================================================= */
  (function stickyCtaSmart() {
    const cta = document.getElementById('mobile-sticky-cta');
    const contact = document.getElementById('contact');
    if (!cta || !contact || !('IntersectionObserver' in window)) return;
    const acte2 = document.getElementById('transition');
    let inContact = false, inActe2 = false;
    const sync = () => cta.classList.toggle('near-contact', inContact || inActe2);
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { inContact = e.isIntersecting; sync(); });
    }, { threshold: 0.12 });
    obs.observe(contact);
    if (acte2) {
      let t = false;
      const onS = () => {
        t = false;
        inActe2 = acte2.getBoundingClientRect().top < window.innerHeight * 0.4;
        sync();
      };
      window.addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(onS); } }, { passive: true });
      onS();
    }
  })();


  /* =========================================================
     V58 — 18b. Retour en haut : s'efface quand il chevaucherait
     le bouton d'envoi du formulaire de devis (même pile flottante)
     ========================================================= */
  (function backToTopSmart() {
    const btt = document.getElementById('back-to-top');
    const recapActions = document.querySelector('.sf-recap-actions');
    if (!btt || !recapActions || !('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => btt.classList.toggle('cta-clash', e.isIntersecting));
    }, { threshold: 0.01, rootMargin: '0px 0px -160px 0px' });
    obs.observe(recapActions);
  })();


  /* =========================================================
     V12 — 19. Titres révélés mot à mot
     ========================================================= */
  (function splitTitles() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = [window.matchMedia('(max-width: 760px)').matches ? null : document.querySelector('.hero-title'), ...document.querySelectorAll('.section-head h2'), ...document.querySelectorAll('.band-quote')].filter(Boolean);
    let counter;
    const wrap = (node) => {
      const frag = document.createDocumentFragment();
      Array.from(node.childNodes).forEach(child => {
        if (child.nodeType === 3) {
          child.textContent.split(/(\s+)/).forEach(tok => {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.className = 'wi';
            i.style.setProperty('--i', counter++);
            i.textContent = tok;
            w.appendChild(i); frag.appendChild(w);
          });
        } else if (child.tagName === 'BR') {
          frag.appendChild(document.createElement('br'));
        } else {
          child.textContent.split(/(\s+)/).forEach(tok => {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.className = 'wi ' + child.className;
            i.style.setProperty('--i', counter++);
            i.textContent = tok;
            w.appendChild(i); frag.appendChild(w);
          });
        }
      });
      node.innerHTML = '';
      node.appendChild(frag);
    };
    targets.forEach(t => {
      if (t.querySelector('.wi')) return; // héros déjà éclaté en inline (LCP)
      counter = 0;
      wrap(t);
      t.classList.add('split');
      if (t.classList.contains('hero-title')) t.style.setProperty('--base', '1.35s');
    });
    if (!('IntersectionObserver' in window)) { targets.forEach(t => t.classList.add('split-in')); return; }
    const obs = new IntersectionObserver((entries, o) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('split-in'); o.unobserve(en.target); } });
    }, { threshold: 0.4 });
    targets.forEach(t => obs.observe(t));
  })();

  /* =========================================================
     V12 — 20. Parallax de profondeur (solutions + galerie)
     ========================================================= */
  (function depthParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const imgs = Array.from(document.querySelectorAll('.solution-visual img, .gallery-item img, .web-visual img, .web-img-main, .web-img-over'));
    if (!imgs.length) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      imgs.forEach(im => {
        const r = im.parentElement.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        im.style.setProperty('--py', (p * -16).toFixed(1) + 'px');
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  /* =========================================================
     V12 — 21. Menu plein écran : verrou du défilement
     ========================================================= */
  (function menuScrollLock() {
    const check = document.getElementById('nav-check');
    if (!check) return;
    check.addEventListener('change', () => {
      document.body.style.overflow = (check.checked && window.innerWidth <= 860) ? 'hidden' : '';
    });
  })();


  /* =========================================================
     V13 — 22. Process horizontal piloté par le scroll
     ========================================================= */
  (function processScroll() {
    const wrap = document.querySelector('.process-sticky');
    const stage = document.querySelector('.process-stage');
    const grid = document.querySelector('.process-sticky .process-grid');
    if (!wrap || !stage || !grid) return;
    const mq = window.matchMedia('(min-width: 1025px)');
    const rm = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;
    const update = () => {
      ticking = false;
      if (!mq.matches || rm.matches) { grid.style.setProperty('--px', '0px'); return; }
      const total = wrap.offsetHeight - stage.offsetHeight;
      if (total <= 0) return;
      const r = wrap.getBoundingClientRect();
      const headerH = 76;
      const p = Math.min(1, Math.max(0, (-r.top + headerH) / total));
      const dist = Math.max(0, grid.scrollWidth - stage.clientWidth);
      grid.style.setProperty('--px', (-p * dist).toFixed(1) + 'px');
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();


  /* =========================================================
     V14 — 23. Ancres robustes : défilement JS sans navigation
     (certaines visionneuses bloquent les sauts d'ancre natifs)
     ========================================================= */
  (function anchorScroll() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', (e) => {
        const id = a.getAttribute('href');
        if (!id || id.length < 2) return;
        let target = null;
        try { target = document.querySelector(id); } catch (err) { return; }
        if (!target) return;               // liens gérés ailleurs (modales légales)
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', id); } catch (err) {}
      });
    });
  })();


  /* =========================================================
     V16 — 24. Scène signature pilotée par le scroll
     ========================================================= */
  (function siteBuildScene() {
    const wrap = document.querySelector('.sig-wrap');
    const stage = document.querySelector('.sig-stage');
    if (!wrap || !stage) return;
    const ALL = ['b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b6c', 'b7', 'is-contact', 'is-final'];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ALL.forEach(c => stage.classList.add(c));
      stage.style.setProperty('--p', '1');
      return;
    }
    const SEUILS = [['b1', 0.06], ['b2', 0.16], ['b3', 0.24], ['b4', 0.34], ['b5', 0.44],
                    ['b6', 0.56], ['b6c', 0.68], ['b7', 0.76], ['is-contact', 0.72], ['is-final', 0.86]];
    let ticking = false;
    const update = () => {
      ticking = false;
      const total = wrap.offsetHeight - stage.offsetHeight;
      if (total <= 0) return;
      const p = Math.min(1, Math.max(0, -wrap.getBoundingClientRect().top / total));
      stage.style.setProperty('--p', p.toFixed(3));
      SEUILS.forEach(([c, s]) => stage.classList.toggle(c, p > s));
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Certains lecteurs mobiles défilent dans un conteneur interne (pas
    // d'événement window.scroll) : boucle rAF tant que la scène est visible.
    let looping = false;
    const loop = () => { if (!looping) return; update(); requestAnimationFrame(loop); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => {
        const vis = es.some((e) => e.isIntersecting);
        if (vis && !looping) { looping = true; requestAnimationFrame(loop); }
        else if (!vis) looping = false;
      }, { rootMargin: '20% 0px' }).observe(wrap);
    }
  })();

  /* =========================================================
     V29 — Relais de scroll : les défilements de conteneurs internes
     (lecteurs de fichiers mobiles) réveillent les scènes.
     ========================================================= */
  (function scrollRelay() {
    document.addEventListener('scroll', (e) => {
      if (e.target !== document && e.target !== document.documentElement && e.target !== document.body) {
        window.dispatchEvent(new Event('scroll'));
      }
    }, { passive: true, capture: true });
  })();

  /* =========================================================
     V29 — LA MÉTHODE : scène de construction pilotée par le scroll
     ========================================================= */
  /* Méthode v2 : pilote remplacé — voir MÉTHODE v2 en fin de document */


  /* =========================================================
     V17 — 25. Directeur de scroll : une progression par scène
     ========================================================= */
  (function cinemaDirector() {
    const scenes = Array.from(document.querySelectorAll('[data-cine]'));
    if (!scenes.length) return;
    // Ciel étoilé injecté dans chaque scène
    scenes.forEach(s => {
      const f = document.createElement('div');
      f.className = 'starfield';
      f.setAttribute('aria-hidden', 'true');
      s.prepend(f);
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      scenes.forEach(s => {
        const r = s.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        s.style.setProperty('--sp', p.toFixed(3));
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  /* =========================================================
     V17 — 26. Travelling automatique du slider métiers
     ========================================================= */
  (function sectorsDrift() {
    const s = document.getElementById('sectors-slider');
    if (!s) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let dir = 1, paused = false, inView = false, resumeTimer = null;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((e) => { inView = e[0].isIntersecting; }, { threshold: 0.25 }).observe(s);
    } else { inView = true; }
    const pause = () => { paused = true; s.classList.remove('drifting'); if (resumeTimer) clearTimeout(resumeTimer); };
    const resumeSoon = (ms) => { if (resumeTimer) clearTimeout(resumeTimer); resumeTimer = setTimeout(() => { paused = false; }, ms); };
    s.addEventListener('pointerenter', pause);
    s.addEventListener('pointerleave', () => resumeSoon(600));
    s.addEventListener('touchstart', pause, { passive: true });
    s.addEventListener('touchend', () => resumeSoon(3500), { passive: true });
    (function loop() {
      if (inView && !paused) {
        s.classList.add('drifting');
        s.scrollLeft += 0.55 * dir;
        const max = s.scrollWidth - s.clientWidth;
        if (s.scrollLeft >= max - 1) dir = -1;
        else if (s.scrollLeft <= 1) dir = 1;
      }
      requestAnimationFrame(loop);
    })();
  })();


  /* =========================================================
     V18 — 27. Vidéo du hero : respect de reduced-motion
     ========================================================= */
  (function heroVideo() {
    const v = document.querySelector('.hero-video');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay'); v.pause();
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) v.pause();
      else if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) v.play().catch(() => {});
    });
  })();


  /* =========================================================
     V20 — 28. Boutique : panier + commande directe
     ========================================================= */
  (function boutique() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (!drawer || !overlay) return;
    const btn = document.getElementById('cart-btn');
    const countEl = document.getElementById('cart-count');
    const itemsEl = document.getElementById('cart-items');
    const emptyEl = document.getElementById('cart-empty');
    const footEl = document.getElementById('cart-foot');
    const totalEl = document.getElementById('cart-total');
    const modal = document.getElementById('order-modal');
    const cart = []; // {name, price(centimes), qty}
    const CART_KEY = 'avisazur-panier-v1';
    try {
      (JSON.parse(localStorage.getItem(CART_KEY) || '[]') || []).forEach((it) => {
        if (it && it.name && (it.price | 0) > 0) {
          cart.push({ name: String(it.name).slice(0, 80), price: it.price | 0, qty: Math.min(99, Math.max(1, it.qty | 0)), note: String(it.note || '').slice(0, 140) });
        }
      });
    } catch (e) { /* stockage indisponible : panier de session */ }
    const save = () => { try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {} };

    const eur = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
    const lineUnit = (it) => {
      const t = window.avTier(window.avKind(it.base || it.price), it.qty);
      return t ? t.unit : it.price;
    };
    const lineSave = (it) => {
      const t = window.avTier(window.avKind(it.base || it.price), it.qty);
      return t ? t.save : 0;
    };
    const total = () => cart.reduce((s, it) => s + (lineUnit(it) + (it.opt || 0)) * it.qty, 0);

    const render = () => {
      if (SHOP) { renderShop(); return; }
      const n = cart.reduce((s, it) => s + it.qty, 0);
      countEl.textContent = n; countEl.hidden = n === 0;
      emptyEl.style.display = cart.length ? 'none' : '';
      footEl.hidden = !cart.length;
      const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      itemsEl.innerHTML = cart.map((it, i) => `
        <div class="cart-item">
          <div class="cart-item-name">${esc(it.name)}<small>${eur(lineUnit(it) + (it.opt || 0))} / unité${lineSave(it) > 0 ? ' · <span class="cart-item-save">−' + eur(lineSave(it)) + '</span>' : ''}</small>${it.note ? `<small class="cart-item-note">${esc(it.note)}</small>` : ''}<label class="cart-qr-link"><span>${window.AVLANG === 'en' ? 'Where should this redirect? (NFC + QR) *' : 'Vers où rediriger ? (NFC + QR) *'}</span><input type="url" inputmode="url" data-link="${i}" placeholder="https://g.page/votre-etablissement" value="${esc(it.link || '')}"><small class="cart-link-hint">${window.AVLANG === 'en' ? 'Same destination for the tap (NFC) and the QR code, if enabled.' : 'Même destination pour le geste (NFC) et le QR code, s\'il est activé.'}</small></label></div>
          <div class="cart-qty">
            <button data-i="${i}" data-d="-1" aria-label="Réduire la quantité">−</button>
            <b>${it.qty}</b>
            <button data-i="${i}" data-d="1" aria-label="Augmenter la quantité">+</button>
          </div>
          <button class="cart-del" data-del="${i}" aria-label="Retirer l'article">✕</button>
        </div>`).join('');
      totalEl.textContent = eur(total());
      (function () {
        var sv = cart.reduce((s, it) => s + lineSave(it), 0);
        var svEl = document.getElementById('cart-savings');
        if (!svEl && totalEl && totalEl.parentElement) {
          svEl = document.createElement('p');
          svEl.id = 'cart-savings'; svEl.className = 'cart-savings';
          totalEl.parentElement.insertAdjacentElement('afterend', svEl);
        }
        if (svEl) {
          svEl.hidden = sv <= 0;
          svEl.textContent = sv > 0 ? ((window.AVLANG === 'en' ? 'Total savings: ' : 'Économies totales : ') + eur(sv)) : '';
        }
        /* cross-sell discret */
        var foot = footEl;
        var xs = document.getElementById('cart-xsell');
        if (!xs && foot) {
          xs = document.createElement('div');
          xs.id = 'cart-xsell';
          foot.insertAdjacentElement('beforebegin', xs);
        }
        if (xs) {
          var kinds = cart.map((it) => window.avKind(it.base || it.price));
          var hasC = kinds.indexOf('carte') !== -1, hasP = kinds.indexOf('plaque') !== -1;
          var en = window.AVLANG === 'en';
          var sug = [];
          if (hasC && !hasP) sug = [['plaque', en ? 'Google review plate' : 'Plaque Avis Google'], ['menu', en ? 'Table NFC menu' : 'Menu NFC de table']];
          else if (hasP && !hasC) sug = [['carte', en ? 'NFC business card' : 'Carte de visite NFC']];
          xs.hidden = !cart.length || !sug.length;
          xs.innerHTML = sug.length ? ('<p class="xs-t">' + (en ? 'Complete your visibility' : 'Complétez votre visibilité') + '</p>' +
            sug.map((s) => '<button type="button" class="xs-link" data-xs="' + s[0] + '">' + s[1] + ' →</button>').join('')) : '';
        }
      })();
      save();
    };

    const open = () => {
      drawer.classList.add('open'); overlay.classList.add('open'); avLock();
      const t = document.getElementById('cart-toast'); if (t) t.classList.remove('show');
    };
    const close = () => { drawer.classList.remove('open'); overlay.classList.remove('open'); avUnlock(); };

    const flyToCart = (from) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !from.animate) return 0;
      const t = btn.getBoundingClientRect();
      const r = from.getBoundingClientRect();
      if (!t.width || !r.width) return 0;
      const dot = document.createElement('span');
      dot.className = 'cart-fly';
      dot.style.left = (r.left + r.width / 2) + 'px';
      dot.style.top = (r.top + r.height / 2) + 'px';
      document.body.appendChild(dot);
      const dx = t.left + t.width / 2 - (r.left + r.width / 2);
      const dy = t.top + t.height / 2 - (r.top + r.height / 2);
      dot.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
        { transform: `translate(calc(-50% + ${dx * 0.55}px), calc(-50% + ${dy * 0.55 - 70}px)) scale(0.72)`, opacity: 1, offset: 0.55 },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(0.2)`, opacity: 0.35 }
      ], { duration: 480, easing: 'cubic-bezier(.45,-.05,.3,1)' }).onfinish = () => {
        dot.remove();
        btn.classList.add('cart-pulse');
        setTimeout(() => btn.classList.remove('cart-pulse'), 550);
      };
      return 280;
    };
    /* V56 : cinématique d'ajout — particules or + morph ✓ du bouton + halo */
    const avCelebrate = (btn) => {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const r = btn.getBoundingClientRect();
      const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const burst = document.createElement('div');
      burst.className = 'av-burst';
      burst.style.left = cx + 'px'; burst.style.top = cy + 'px';
      for (let i = 0; i < 14; i++) {
        const s = document.createElement('i');
        const a = (Math.PI * 2 * i) / 14 + (i % 3) * 0.21;
        const d = 46 + (i % 5) * 16;
        s.style.setProperty('--tx', Math.cos(a) * d + 'px');
        s.style.setProperty('--ty', Math.sin(a) * d - 18 + 'px');
        s.style.setProperty('--dl', (i % 7) * 22 + 'ms');
        s.style.setProperty('--sz', (4 + (i % 3) * 2) + 'px');
        burst.appendChild(s);
      }
      const halo = document.createElement('span');
      halo.className = 'av-burst-halo';
      burst.appendChild(halo);
      document.body.appendChild(burst);
      setTimeout(() => burst.remove(), 1100);
      /* morph du bouton : ✓ Ajouté */
      if (!btn.dataset.celebrating) {
        btn.dataset.celebrating = '1';
        const old = btn.textContent;
        btn.classList.add('av-added');
        btn.textContent = window.AVLANG === 'en' ? '✓ Added' : '✓ Ajouté';
        setTimeout(() => {
          btn.classList.remove('av-added');
          btn.textContent = old;
          delete btn.dataset.celebrating;
        }, 1300);
      }
    };
    /* ============================================================
       MODE SHOPIFY — panier & checkout réels
       Actif uniquement quand le thème injecte window.AV_SHOP
       (variantes réelles via Liquid). Sur le site statique : inerte,
       le comportement historique est conservé.
       ============================================================ */
    const ON_SHOPIFY = !!window.Shopify || /\.myshopify\.com$/.test(location.hostname) ||
      !!document.querySelector('meta[name="shopify-checkout-api-token"]');
    const SHOP = window.AV_SHOP && window.AV_SHOP.products ? window.AV_SHOP
      : (ON_SHOPIFY ? { products: {} } : null); /* boutique dégradée plutôt que fausse commande */
    const K2H = { avisplq: 'plaque-nfc', plqinsta: 'plaque-nfc', facebook: 'plaque-nfc',
      snapchat: 'plaque-nfc', linkedin: 'plaque-nfc', site: 'plaque-nfc',
      airbnb: 'support-airbnb', plqwa: 'rond-whatsapp', menu: 'menu-nfc-table',
      visite: 'carte-de-visite-nfc', perso: 'plaque-personnalisee' };
    /* un seul produit Shopify pour toutes les plaques : le réseau part en propriété de ligne */
    const K2RESEAU = { avisplq: 'Avis Google', plqinsta: 'Instagram', facebook: 'Facebook',
      snapchat: 'Snapchat', linkedin: 'LinkedIn', site: 'Site Internet' };
    const OPTH = { qr: 'option-qr-code', socle: 'option-socle' };
    /* Un seul produit « Plaque réseaux sociaux » possible : le réseau devient une option de variante */
    const NETK = { plqinsta: 'instagram', facebook: 'facebook', snapchat: 'snapchat', linkedin: 'linkedin', site: 'site' };
    const H_COMMON = 'plaque-reseaux-sociaux';
    let scart = { items: [], item_count: 0, total_price: 0 };
    const pendingLinks = {};
    const sfetch = (url, opts) => fetch(url, Object.assign({
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin'
    }, opts)).then(r => {
      if (!r.ok) return r.json().catch(() => ({})).then(j => {
        throw new Error(j.description || j.message || ('HTTP ' + r.status));
      });
      return r.json();
    });
    const shopVariant = (handle, version) => {
      const p = SHOP && SHOP.products[handle];
      if (!p || !p.variants) return null;
      const v = p.variants;
      return v[version] || v['default title'] || v[Object.keys(v)[0]] || null;
    };
    const shopVariantNet = (net, version) => {
      const p = SHOP && SHOP.products[H_COMMON];
      if (!p || !p.variants) return null;
      const vm = version === 'personnalisée' ? 'personnalis' : 'standard';
      const k = Object.keys(p.variants).find((t) => t.indexOf(net) !== -1 && t.indexOf(vm) !== -1);
      return k ? p.variants[k] : null;
    };
    const shopImg = (handle) => (SHOP && SHOP.products[handle] && SHOP.products[handle].img) || '';
    const isOptLine = (it) => ((it.handle || '').indexOf('option-') === 0);
    const syncCart = () => sfetch('/cart.js').then(c => { scart = c; render(); return c; });
    const changeLine = (line, qty, props) => {
      const body = { line: line, quantity: qty };
      if (props) body.properties = props;
      return sfetch('/cart/change.js', { method: 'POST', body: JSON.stringify(body) })
        .then(c => { scart = c; render(); return c; });
    };
    const keyOfBtn = (b) => b.dataset.key ||
      (b.closest('.fiche-panel') && b.closest('.fiche-panel').dataset.avKey) ||
      (b.id === 'col-add' && (document.querySelector('.col-slide.is-on') || {}).dataset
        ? document.querySelector('.col-slide.is-on').dataset.key : '') ||
      (b.closest('.cf-buy') || b.closest('#config') ? 'perso' : '');
    const renderShop = () => {
      countEl.textContent = scart.item_count;
      countEl.hidden = scart.item_count === 0;
      emptyEl.style.display = scart.items.length ? 'none' : '';
      footEl.hidden = !scart.items.length;
      const esc = (t) => String(t).replace(/[&<>\"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[c]));
      const EN = window.AVLANG === 'en';
      itemsEl.innerHTML = scart.items.map((it, i) => {
        const line = i + 1;
        const opt = isOptLine(it);
        const props = it.properties || {};
        const title = esc(it.product_title || it.title || '') +
          (it.variant_title && it.variant_title !== 'Default Title' ? ' — ' + esc(it.variant_title) : '');
        const img = it.image || shopImg(it.handle || '');
        const noteBits = [];
        if (props['Réseau'] || props['Network']) noteBits.push(esc(props['Réseau'] || props['Network']));
        if (props['Détails']) noteBits.push(esc(props['Détails']));
        if (opt && props['_Pour']) noteBits.push((EN ? 'For: ' : 'Pour : ') + esc(props['_Pour']));
        const linkVal = pendingLinks[line] !== undefined ? pendingLinks[line] : (props['Lien'] || '');
        return `
        <div class="cart-item">
          ${img ? `<img class="cart-item-img" src="${esc(img)}" alt="" loading="lazy" decoding="async">` : ''}
          <div class="cart-item-name">${title}<small>${eur(it.final_price)} ${EN ? '/ unit' : '/ unité'} · ${EN ? 'Line total' : 'Total ligne'} : <b>${eur(it.final_line_price)}</b></small>${noteBits.length ? `<small class="cart-item-note">${noteBits.join(' · ')}</small>` : ''}${opt ? '' : `<label class="cart-qr-link"><span>${EN ? 'Where should this redirect? (NFC + QR) *' : 'Vers où rediriger ? (NFC + QR) *'}</span><input type="url" inputmode="url" data-linkline="${line}" placeholder="https://g.page/votre-etablissement" value="${esc(linkVal)}"><small class="cart-link-hint">${EN ? 'Same destination for the tap (NFC) and the QR code, if enabled.' : 'Même destination pour le geste (NFC) et le QR code, s\'il est activé.'}</small></label>`}</div>
          <div class="cart-qty">
            <button data-line="${line}" data-d="-1" aria-label="Réduire la quantité">−</button>
            <b>${it.quantity}</b>
            <button data-line="${line}" data-d="1" aria-label="Augmenter la quantité">+</button>
          </div>
          <button class="cart-del" data-delline="${line}" aria-label="Retirer l'article">✕</button>
        </div>`;
      }).join('');
      totalEl.textContent = eur(scart.total_price);
      const svEl = document.getElementById('cart-savings');
      if (svEl) { svEl.hidden = true; svEl.textContent = ''; }
    };
    if (SHOP) { syncCart().catch(() => {}); }
    /* état visible (diagnostic) : mode + nombre de produits connectés */
    (function avDiag() {
      try {
        const host = footEl && footEl.parentElement ? footEl : document.getElementById('cart-drawer');
        if (!host) return;
        const d = document.createElement('p');
        d.id = 'av-diag';
        d.style.cssText = 'font-size:12.5px;text-align:center;margin:10px 0 0;letter-spacing:.01em;color:#8F6420;font-weight:600';
        d.textContent = 'Livraison offerte · point relais ou domicile';
        (footEl || host).appendChild(d);
      } catch (e) {}
    })();

    document.querySelectorAll('.add-cart').forEach(b => {
      b.addEventListener('click', () => {
        const name = b.dataset.name, price = parseInt(b.dataset.price, 10);
        const buyBox = b.closest('.fiche-buy, .col-buy, .cf-buy');
        const qEl = buyBox ? buyBox.querySelector('.fiche-qty b') : null;
        const q = qEl ? Math.max(1, parseInt(qEl.textContent, 10) || 1) : 1;
        const note = b.dataset.note || '';
        if (q >= 100) {
          const c = document.getElementById('contact');
          if (c) c.scrollIntoView({ behavior: 'smooth' });
          showToast(window.AVLANG === 'en' ? 'Business pricing — contact us for a quote' : 'Tarif entreprise — demandez un devis', 1);
          return;
        }
        const pnl2 = b.closest('.fiche-panel');
        if (SHOP) {
          const EN = window.AVLANG === 'en';
          const key = keyOfBtn(b);
          const handle = K2H[key];
          const version = (buyBox && buyBox.dataset.version === 'perso') ? 'personnalisée' : 'standard';
          let mainV = handle && shopVariant(handle, version);
          if (!mainV && NETK[key]) mainV = shopVariantNet(NETK[key], version);
          if (!mainV) {
            showToast(EN ? 'This product is not configured in the shop yet — please contact us.'
                         : 'Ce produit n\'est pas encore configuré dans la boutique — contactez-nous.',-1);
            return;
          }
          const props = { 'Version': version === 'perso' || version === 'personnalisée' ? (EN ? 'Personalised' : 'Personnalisée') : 'Standard' };
          if (K2RESEAU[key]) props[EN ? 'Network' : 'Réseau'] = K2RESEAU[key];
          if (note) props['Détails'] = note;
          const items = [{ id: mainV.id, quantity: q, properties: props }];
          const wantQr = pnl2 && pnl2.dataset.avQr === '1';
          const wantSo = pnl2 && pnl2.dataset.avSocle === '1';
          let optMissing = '';
          if (wantQr) {
            const ov = shopVariant(OPTH.qr, 'standard');
            if (ov) items.push({ id: ov.id, quantity: q, properties: { '_Pour': name } });
            else optMissing = 'QR';
          }
          if (wantSo) {
            const ov = shopVariant(OPTH.socle, 'standard');
            if (ov) items.push({ id: ov.id, quantity: q, properties: { '_Pour': name } });
            else optMissing = optMissing ? optMissing + ' + Socle' : 'Socle';
          }
          if (optMissing) {
            showToast(EN ? ('Option not configured in the shop (' + optMissing + ') — please contact us.')
                         : ('Option non configurée dans la boutique (' + optMissing + ') — contactez-nous.'),-1);
            return;
          }
          if (b.dataset.busy) return;
          b.dataset.busy = '1';
          sfetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items }) })
            .then(() => syncCart())
            .then(() => {
              delete b.dataset.busy;
              avCelebrate(b);
              const delay = flyToCart(b);
              setTimeout(() => showToast(name, q), delay ? delay + 60 : 0);
            })
            .catch(() => {
              delete b.dataset.busy;
              showToast(EN ? 'Could not add to cart — please try again.'
                           : 'Ajout au panier impossible — réessayez.',-1);
            });
          return;
        }
        const optCents = window.avOptCents(pnl2 && pnl2.dataset.avQr === '1', pnl2 && pnl2.dataset.avSocle === '1');
        const ex = cart.find(it => it.name === name && (it.note || '') === note);
        if (ex) { ex.qty += q; ex.base = ex.base || price; ex.opt = optCents; }
        else cart.push({ name, price, base: price, opt: optCents, qty: q, note });
        render();
        avCelebrate(b);
        const delay = flyToCart(b);
        setTimeout(() => showToast(name, q), delay ? delay + 60 : 0);
      });
    });
    itemsEl.addEventListener('input', (e) => {
      const inpS = e.target.closest('input[data-linkline]');
      if (inpS) { pendingLinks[+inpS.dataset.linkline] = inpS.value; inpS.classList.remove('is-missing'); return; }
      const inp = e.target.closest('input[data-link]');
      if (!inp) return;
      const it = cart[+inp.dataset.link];
      if (it) { it.link = inp.value.trim(); save(); }
      inp.classList.remove('is-missing');
    });
    itemsEl.addEventListener('click', (e) => {
      const t = e.target;
      if (SHOP) {
        const EN = window.AVLANG === 'en';
        const fail = () => showToast(EN ? 'Cart update failed — please try again.' : 'Mise à jour du panier impossible — réessayez.',-1);
        if (t.dataset.delline !== undefined) { changeLine(+t.dataset.delline, 0).catch(fail); return; }
        if (t.dataset.line !== undefined && t.dataset.d !== undefined) {
          const it = scart.items[+t.dataset.line - 1];
          if (it) changeLine(+t.dataset.line, Math.max(0, it.quantity + (+t.dataset.d))).catch(fail);
          return;
        }
        return;
      }
      if (t.dataset.del !== undefined) { cart.splice(+t.dataset.del, 1); render(); return; }
      if (t.dataset.i !== undefined) {
        const it = cart[+t.dataset.i];
        it.qty += +t.dataset.d;
        if (it.qty <= 0) cart.splice(+t.dataset.i, 1);
        render();
      }
    });
    document.addEventListener('click', (e) => {
      const xsb = e.target.closest('.xs-link');
      if (!xsb) return;
      close();
      setTimeout(() => { if (window.avOpenFiche) window.avOpenFiche(xsb.dataset.xs, xsb); }, 250);
    });
    btn.addEventListener('click', open);
    document.getElementById('cart-close').addEventListener('click', close);
    overlay.addEventListener('click', close);
    const browse = document.getElementById('cart-browse');
    if (browse) browse.addEventListener('click', close);
    const cont = document.getElementById('cart-continue');
    if (cont) cont.addEventListener('click', close);
    // Toast « ajouté au panier » : on continue ses achats tranquillement
    const toast = document.getElementById('cart-toast');
    const toastBtn = document.getElementById('cart-toast-open');
    let toastTimer = null;
    const showToast = (name, q) => {
      if (!toast) { open(); return; }
      toast.classList.toggle('is-err', q === -1);
      document.getElementById('cart-toast-txt').textContent = (q > 1 ? q + ' × ' : '') + window.avT(name);
      toast.classList.add('show');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('show'), 3400);
    };
    if (toastBtn) toastBtn.addEventListener('click', () => { toast.classList.remove('show'); open(); });
    // Sélecteur de quantité des fiches
    document.querySelectorAll('.fiche-qty').forEach((wrapQ) => {
      const val = wrapQ.querySelector('b');
      wrapQ.addEventListener('click', (e) => {
        let v = parseInt(val.textContent, 10) || 1;
        if (e.target.closest('.fq-p')) v = Math.min(999, v + 1);
        else if (e.target.closest('.fq-m')) v = Math.max(1, v - 1);
        else return;
        val.textContent = v;
      });
    });
    if (cart.length) render();

    // ===== V53 : affichage dégressif (fiches + collection + éditeur) =====
    (function tiersUI() {
      const EN = () => window.AVLANG === 'en';
      const boxes = Array.from(document.querySelectorAll('.fiche-buy, .col-buy, .cf-buy'));
      const kindOf = (box) => window.avKind(parseInt(box.querySelector('.add-cart').dataset.price, 10));
      const versionsOf = (box) => {
        const addBtn = box.querySelector('.add-cart');
        if (!addBtn.dataset.base0) addBtn.dataset.base0 = addBtn.dataset.price; /* prix personnalisé d'origine */
        const panel = box.closest('.fiche-panel');
        const key = panel ? panel.dataset.avKey : (box.classList.contains("col-buy") ? ((document.querySelector(".col-slide.is-on") || {dataset:{}}).dataset.key || null) : null);
        const conf = key && window.AV_PRICING.byKey[key] ? window.AV_PRICING.byKey[key] : null;
        const perso = conf ? conf.personalized : parseInt(addBtn.dataset.base0, 10);
        const std = conf ? conf.standard : (perso === 4490 ? 2990 : perso === 5990 ? 3490 : null);
        return { std: std, perso: perso };
      };
      const qtyOf = (box) => Math.max(1, parseInt(String(box.querySelector('.fiche-qty b').textContent).replace(/[^0-9]/g, ''), 10) || 1);

      function buildGrid(box) {
        const kind = kindOf(box), q = qtyOf(box);
        const tiers = window.AV_PRICING.tiers[kind], badges = window.AV_PRICING.badges[kind];
        const unitW = EN() ? 'Unit price' : 'Prix / unité';
        let rows = tiers.map(([n, u]) => {
          const t = window.avTier(kind, n);
          const on = q >= n && (!t.next || q < t.next[0]) && q < 100;
          return '<tr class="' + (on ? 'is-on' : '') + '"><td>' + n + (badges[n] ? ' <span class="fb-badge">' + badges[n] + '</span>' : '') + '</td>' +
                 '<td>' + eur(u) + '</td><td>' + (t.pct > 0 ? '−' + t.pct + ' %' : '—') + '</td></tr>';
        }).join('');
        rows += '<tr class="' + (q >= 100 ? 'is-on' : '') + '"><td>100+</td><td colspan="2">' + (EN() ? 'Custom quote — business pricing' : 'Sur devis · tarif entreprise') + '</td></tr>';
        box._tier.querySelector('.fb-grid').innerHTML =
          '<table><thead><tr><th>' + (EN() ? 'Quantity' : 'Quantité') + '</th><th>' + unitW + '</th><th>' + (EN() ? 'Saving' : 'Économie') + '</th></tr></thead><tbody>' + rows + '</tbody></table>';
      }

      function refresh(box) {
        if (!box._tier) return;
        /* sélecteur de version : recalculé pour le produit réellement ouvert */
        const addBtnA = box.querySelector('.add-cart');
        if (box._vsel) {
          const vv = versionsOf(box);
          if (!vv.std) {
            box._vsel.hidden = true;
            box.dataset.version = 'perso';
          } else {
            box._vsel.hidden = false;
            box._renderSel();
          }
          /* AUTORITÉ UNIQUE : prix + nom + accès personnalisation suivent la version */
          const isStd = box.dataset.version === 'std' && vv.std;
          const want = isStd ? vv.std : vv.perso;
          if (+addBtnA.dataset.price !== want) addBtnA.dataset.price = String(want);
          const panelN = box.closest('.fiche-panel');
          /* base = nom COURANT sans suffixes (suit les changements de produit,
             ex. avColRefresh sur le bandeau collection) */
          const nameBase = (addBtnA.dataset.name || '')
            .replace(/ — (Standard|Personnalisée)/, '')
            .replace(/( \(avec [^)]+\))+$/, '');
          if (nameBase) {
            addBtnA.dataset.name = nameBase +
              (box._vsel.hidden ? '' : (isStd ? ' — Standard' : ' — Personnalisée')) +
              (panelN && panelN.dataset.avQr === '1' ? ' (avec QR code)' : '') +
              (panelN && panelN.dataset.avSocle === '1' ? ' (avec socle)' : '');
          }
          const pbtnA = box.querySelector('.fiche-perso');
          if (pbtnA) pbtnA.hidden = isStd;
        }
        const kind = kindOf(box), q = qtyOf(box);
        const t = window.avTier(kind, q);
        const label = box.querySelector('.fiche-price-from');
        const strong = box.querySelector('.fiche-price strong');
        const addBtn = box.querySelector('.add-cart');
        if (label) label.textContent = box._vsel
          ? (box.dataset.version === 'std' ? (EN() ? 'Standard version' : 'Version standard') : (EN() ? 'Personalised version' : 'Version personnalisée'))
          : (EN() ? 'From' : 'À partir de');
        const pnl0 = box.closest('.fiche-panel');
        const opt0 = window.avOptCents(pnl0 && pnl0.dataset.avQr === '1', pnl0 && pnl0.dataset.avSocle === '1');
        if (strong) strong.textContent = eur(t.base + opt0);
        let note = box.querySelector('.fb-note');
        if (!note) {
          note = document.createElement('span');
          note.className = 'fb-note';
          box.querySelector('.fiche-price').appendChild(note);
        }
        note.textContent = (box.dataset.version === 'std' && versionsOf(box).std) ? (function(){var p=box.closest('.fiche-panel');var k=p?p.dataset.avKey:((document.querySelector('.col-slide.is-on')||{dataset:{}}).dataset.key||null);var f=(k==='avisplq'||k==='plqinsta'||k==='plqwa');return f?(EN()?'Programmed, ready to use · ships within 48 h':'Programmé, prêt à poser · expédié sous 48 h'):(EN()?'Programmed, ready to use · ships in 5 to 15 working days':'Programmé, prêt à poser · expédié sous 5 à 15 jours ouvrés');})() : EN() ? 'Customisation included · 20 working days after approval'
                                : 'Personnalisation incluse · 20 jours ouvrés après validation';

        const line = box._tier.querySelector('.fb-line');
        const nudge = box._tier.querySelector('.fb-nudge');
        const gbtn = box._tier.querySelector('.fb-grid-btn');
        /* pulsation quand le prix affiché change */
        if (strong && strong.dataset.prev !== strong.textContent) {
          if (strong.dataset.prev) {
            strong.classList.remove('fb-pulse'); void strong.offsetWidth; strong.classList.add('fb-pulse');
          }
          strong.dataset.prev = strong.textContent;
        }
        /* ✓ nouveau tarif appliqué (passage de palier) */
        if (!t.devis && box._lastSeuil !== undefined && t.seuil > box._lastSeuil) {
          const ok = document.createElement('span');
          ok.className = 'fb-newtier';
          ok.textContent = EN() ? '✓ New rate applied' : '✓ Nouveau tarif appliqué';
          box._tier.insertAdjacentElement('afterbegin', ok);
          setTimeout(() => ok.remove(), 1900);
        }
        box._lastSeuil = t.devis ? box._lastSeuil : t.seuil;
        gbtn.textContent = box._tier.querySelector('.fb-grid').hidden
          ? (EN() ? 'See prices by quantity' : 'Voir les tarifs par quantité')
          : (EN() ? 'Hide prices' : 'Masquer les tarifs');
        if (!addBtn.dataset.addlabel) addBtn.dataset.addlabel = addBtn.textContent;
        if (t.devis) {
          line.innerHTML = '<b>' + (EN() ? 'Custom quote — business pricing' : 'Sur devis · tarif entreprise') + '</b>';
          nudge.textContent = EN() ? 'Dedicated support and business pricing from 100 units.'
                                   : 'Accompagnement dédié et tarif entreprise à partir de 100 unités.';
          addBtn.textContent = EN() ? 'Request a quote' : 'Demander un devis';
        } else {
          addBtn.textContent = window.avT ? window.avT(addBtn.dataset.addlabel) : addBtn.dataset.addlabel;
          const badge = window.AV_PRICING.badges[kind][t.seuil];
          const panelO = box.closest('.fiche-panel');
          const optQr = panelO && panelO.dataset.avQr === '1';
          const optSo = panelO && panelO.dataset.avSocle === '1';
          const optU = window.avOptCents(optQr, optSo); /* options : jamais remisées */
          const grand = t.total + optU * q;
          line.innerHTML = q + ' × ' + eur(t.unit) + (optU ? ' + ' + eur(optU) + (EN() ? ' options' : ' d\'options') : '') +
            ' = <b>' + eur(grand) + '</b>' +
            (t.save > 0 ? ' <span class="fb-save">' + (EN() ? 'You save ' : 'Économie ') + eur(t.save) + ' (−' + t.pct + ' %)</span>' : '') +
            (badge ? ' <span class="fb-badge">' + badge + '</span>' : '');
          /* résumé de configuration */
          const rc = box._tier.querySelector('.fb-recap');
          if (rc && panelO) {
            const o = window.AV_PRICING.options;
            const row = (k, v) => '<span>' + k + '</span><b>' + v + '</b>';
            rc.hidden = false;
            rc.innerHTML = '<p class="fb-recap-t">' + (EN() ? 'YOUR CONFIGURATION' : 'VOTRE CONFIGURATION') + '</p>' +
              row(EN() ? 'Version' : 'Version', box.dataset.version === 'std' ? 'Standard' : (EN() ? 'Personalised' : 'Personnalisée')) +
              row('QR code', optQr ? (o.qr ? '+' + eur(o.qr) : (EN() ? 'Included' : 'Inclus')) : (EN() ? 'Without' : 'Sans')) +
              row(EN() ? 'Stand' : 'Socle', optSo ? (o.socle ? '+' + eur(o.socle) : (EN() ? 'Price at proof stage' : 'Tarif au BAT')) : (EN() ? 'Without' : 'Sans')) +
              row(EN() ? 'Quantity' : 'Quantité', q) +
              row(EN() ? 'Unit price' : 'Prix unitaire', eur(t.unit)) +
              row('Total', eur(grand)) +
              (t.save > 0 ? row(EN() ? 'You save' : 'Économie', eur(t.save) + ' (−' + t.pct + ' %)') : '');
          } else if (rc) { rc.hidden = true; }
          if (t.next && q >= 1) {
            const miss = t.next[0] - q;
            const extra = t.next[0] * (t.unit - t.next[1]);
            const u = EN() ? (kind === 'carte' ? 'card' + (miss > 1 ? 's' : '') : 'plate' + (miss > 1 ? 's' : ''))
                           : (kind === 'carte' ? 'carte' + (miss > 1 ? 's' : '') : 'plaque' + (miss > 1 ? 's' : ''));
            nudge.textContent = EN()
              ? 'Only ' + miss + ' more ' + u + ' to reach ' + eur(t.next[1]) + '/unit — save an extra ' + eur(extra) + '.'
              : 'Plus que ' + miss + ' ' + u + ' pour passer à ' + eur(t.next[1]) + '/unité — soit ' + eur(extra) + ' d\'économie en plus.';
          } else {
            nudge.textContent = '';
          }
        }
        if (!box._tier.querySelector('.fb-grid').hidden) buildGrid(box);
        /* résumé sticky mobile (fiches) */
        const panel = box.closest('.fiche-panel');
        if (panel && !panel.hidden) {
          const sk = document.getElementById('fiche-sticky');
          if (sk) {
            sk.querySelector('.fs-txt').textContent = t.devis
              ? (EN() ? '100+ units — custom quote' : '100+ unités · sur devis')
              : q + (EN() ? ' unit' + (q > 1 ? 's' : '') : ' unité' + (q > 1 ? 's' : '')) + ' · ' + eur(t.unit) + (EN() ? '/unit' : '/unité');
            const pnl = box.closest('.fiche-panel');
            const oU = window.avOptCents(pnl && pnl.dataset.avQr === '1', pnl && pnl.dataset.avSocle === '1');
            sk.querySelector('.fs-add').textContent = t.devis
              ? (EN() ? 'Request a quote' : 'Demander un devis')
              : (EN() ? 'Add to cart — ' : 'Ajouter au panier — ') + eur(t.total + oU * q);
          }
        }
      }

      boxes.forEach((box) => {
        const strongEl = box.querySelector('.fiche-price strong');
        const addBtn = box.querySelector('.add-cart');
        const qtyEl = box.querySelector('.fiche-qty b');
        if (!strongEl || !addBtn || !qtyEl) return;
        qtyEl.setAttribute('contenteditable', 'true');
        qtyEl.setAttribute('inputmode', 'numeric');
        qtyEl.setAttribute('role', 'spinbutton');
        qtyEl.setAttribute('aria-label', EN() ? 'Quantity — type a number' : 'Quantité — saisissez un nombre');
        qtyEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); qtyEl.blur(); } });
        qtyEl.addEventListener('blur', () => {
          let v = parseInt(String(qtyEl.textContent).replace(/[^0-9]/g, ''), 10);
          if (!v || v < 1) v = 1;
          qtyEl.textContent = Math.min(999, v);
          refresh(box);
        });
        qtyEl.addEventListener('input', () => refresh(box));
        const wrap = document.createElement('div');
        wrap.className = 'fb-tier';
        wrap.innerHTML = '<p class="fb-line" aria-live="polite"></p><p class="fb-nudge"></p>' +
          '<button type="button" class="fb-grid-btn" aria-expanded="false"></button><div class="fb-grid" hidden></div>' +
          '<div class="fb-recap" hidden></div>';
        box.insertAdjacentElement('afterend', wrap);
        box._tier = wrap;
        /* --- sélecteur STANDARD / PERSONNALISÉ (piloté par AV_PRICING) --- */
        const addBtnI = box.querySelector('.add-cart');
        if (addBtnI && !addBtnI.dataset.name0) addBtnI.dataset.name0 = addBtnI.dataset.name;
        const vs = versionsOf(box);
        const isEditor = box.classList.contains('cf-buy') || !!box.closest('#config');
        if (vs.std && !isEditor) {
          const sel = document.createElement('div');
          sel.className = 'fb-version';
          sel.setAttribute('role', 'radiogroup');
          sel.setAttribute('aria-label', EN() ? 'Choose your version' : 'Choisissez votre version');
          box.insertAdjacentElement('beforebegin', sel);
          box._vsel = sel;
          box.dataset.version = 'std'; /* V56 : standard par défaut */
          const renderSel = () => {
            const v = versionsOf(box);
            const cur = box.dataset.version;
            sel.innerHTML =
              '<button type="button" class="fbv' + (cur === 'std' ? ' is-on' : '') + '" data-v="std">' +
                '<b>' + (EN() ? 'STANDARD' : 'STANDARD') + '</b><strong>' + eur(v.std) + '</strong>' +
                '<span>✓ NFC · ' + (EN() ? 'programmed, ready to use' : 'programmé, prêt à utiliser') + '</span></button>' +
              '<button type="button" class="fbv' + (cur === 'perso' ? ' is-on' : '') + '" data-v="perso">' +
                '<b>' + (EN() ? 'PERSONALISED' : 'PERSONNALISÉ') + '</b><strong>' + eur(v.perso) + '</strong>' +
                '<span>✓ ' + (EN() ? 'Your logo, colours, text, preview' : 'Votre logo, couleurs, texte, aperçu') + '</span></button>';
          };
          renderSel();
          box._renderSel = renderSel;
          sel.addEventListener('click', (e) => {
            const b = e.target.closest('.fbv');
            if (!b) return;
            box.dataset.version = b.dataset.v;
            renderSel();
            refresh(box);
            /* Personnalisé depuis une fiche : direction le configurateur, pré-réglé sur ce produit */
            if (b.dataset.v === 'perso') {
              const pnlV = box.closest('.fiche-panel');
              if (pnlV) {
                const keyV = pnlV.dataset.avKey || '';
                setTimeout(() => {
                  const fm = document.getElementById('fiche-modal');
                  if (fm && fm.classList.contains('open')) { fm.classList.remove('open'); window.avUnlock(); }
                  if (window.avConfigFor && keyV) { try { window.avConfigFor(keyV); } catch (err) {} }
                  const cfg = document.getElementById('config');
                  if (cfg) cfg.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
                }, 260);
              }
            }
          });
        }
        wrap.querySelector('.fb-grid-btn').addEventListener('click', () => {
          const g = wrap.querySelector('.fb-grid');
          g.hidden = !g.hidden;
          wrap.querySelector('.fb-grid-btn').setAttribute('aria-expanded', String(!g.hidden));
          refresh(box);
        });
        refresh(box);
      });

      /* résumé sticky mobile dans le modal fiche */
      const fmodal = document.getElementById('fiche-modal');
      if (fmodal) {
        const sheet = fmodal.querySelector('.fiche-sheet');
        if (sheet && !document.getElementById('fiche-sticky')) {
          const sk = document.createElement('div');
          sk.id = 'fiche-sticky';
          sk.innerHTML = '<span class="fs-txt"></span><button type="button" class="fs-add" aria-label="Ajouter au panier"></button>';
          sheet.appendChild(sk);
          sk.querySelector('.fs-add').addEventListener('click', () => {
            const b = fmodal.querySelector('.fiche-panel:not([hidden]) .add-cart');
            if (b) b.click();
          });
        }
      }

      /* rafraîchissements : steppers (clic), ouverture de fiche, langue */
      document.addEventListener('click', (e) => {
        const b = e.target.closest('.fiche-buy, .col-buy, .cf-buy');
        if (b && b._tier) requestAnimationFrame(() => refresh(b));
        if (e.target.closest('.col-thumb, .col-tab, .col-nav')) {
          requestAnimationFrame(() => setTimeout(window.avTierRefreshAll, 60));
        }
      });
      window.avTierRefreshAll = () => boxes.forEach((b) => b._tier && refresh(b));
      const lt = document.getElementById('lang-toggle');
      if (lt) lt.addEventListener('click', () => setTimeout(window.avTierRefreshAll, 80));
      if (window.avOpenFiche) {
        const prevOpen = window.avOpenFiche;
        window.avOpenFiche = function (k, back) { prevOpen(k, back); setTimeout(window.avTierRefreshAll, 60); };
      }
      setTimeout(window.avTierRefreshAll, 400);
    })();


    // ----- Commande -----
    const openOrder = () => {
      if (!cart.length) return;
      document.getElementById('order-recap').textContent =
        cart.map(it => `${it.qty} × ${it.name}${it.link ? ' → ' + it.link : ''}`).join(' · ') + ' — ' + eur(total());
      document.getElementById('order-form-wrap').hidden = false;
      document.getElementById('order-success').hidden = true;
      modal.classList.add('open');
    };
    const closeOrder = () => { modal.classList.remove('open'); avUnlock(); };
    document.getElementById('cart-checkout').addEventListener('click', () => {
      if (SHOP) {
        const ck = document.getElementById('cart-checkout');
        if (ck.dataset.busy) return;
        const EN = window.AVLANG === 'en';
        /* chaque article NFC a besoin d'une destination */
        const missing = [];
        scart.items.forEach((it, i) => {
          if (isOptLine(it)) return;
          const v = String(pendingLinks[i + 1] !== undefined ? pendingLinks[i + 1] : ((it.properties || {})['Lien'] || '')).trim();
          if (!/^https?:\/\/.+\..+/.test(v)) missing.push(i + 1);
        });
        if (missing.length) {
          missing.forEach((l) => {
            const inp = itemsEl.querySelector('input[data-linkline="' + l + '"]');
            if (inp) inp.classList.add('is-missing');
          });
          const first = itemsEl.querySelector('input[data-linkline="' + missing[0] + '"]');
          if (first) first.focus();
          showToast(EN ? 'Please enter the redirect link for each item'
                       : 'Indiquez le lien de redirection pour chaque article', 1);
          return;
        }
        ck.dataset.busy = '1'; ck.disabled = true;
        const old = ck.textContent;
        ck.textContent = EN ? 'Preparing payment…' : 'Préparation du paiement…';
        /* pousser les liens en propriétés de ligne, EN SÉRIE, puis rediriger vers le checkout Shopify */
        const steps = [];
        scart.items.forEach((it, i) => {
          if (isOptLine(it)) return;
          const l = i + 1;
          if (pendingLinks[l] === undefined) return;
          const props = Object.assign({}, it.properties || {}, { 'Lien': String(pendingLinks[l]).trim() });
          steps.push({ line: l, quantity: it.quantity, properties: props });
        });
        steps.reduce((p, s) => p.then(() =>
          sfetch('/cart/change.js', { method: 'POST', body: JSON.stringify(s) })
        ), Promise.resolve())
          .then(() => sfetch('/cart.js'))
          .then((c) => {
            if (!c.item_count) throw new Error('empty');
            window.location.href = '/checkout';
          })
          .catch(() => {
            delete ck.dataset.busy; ck.disabled = false; ck.textContent = old;
            showToast(EN ? 'An error occurred while preparing payment. Please try again.'
                         : 'Une erreur est survenue lors de la préparation du paiement. Veuillez réessayer.',-1);
          });
        return;
      }
      /* V58.2 : chaque article a besoin d'une destination (NFC + QR le cas échéant) */
      const missing = [];
      cart.forEach((it, i) => {
        if (!(it.link && /^https?:\/\/.+\..+/.test(it.link.trim()))) missing.push(i);
      });
      if (missing.length) {
        missing.forEach((i) => {
          const inp = itemsEl.querySelector('input[data-link="' + i + '"]');
          if (inp) { inp.classList.add('is-missing'); }
        });
        const first = itemsEl.querySelector('input[data-link="' + missing[0] + '"]');
        if (first) first.focus();
        showToast(window.AVLANG === 'en'
          ? 'Please enter the redirect link for each item'
          : 'Indiquez le lien de redirection pour chaque article', 1);
        return;
      }
      close(); avLock(); openOrder();
    });
    document.getElementById('order-close').addEventListener('click', closeOrder);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeOrder(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (modal.classList.contains('open')) closeOrder();
      else if (drawer.classList.contains('open')) close();
    });

    document.getElementById('order-send').addEventListener('click', () => {
      const name = document.getElementById('order-name').value.trim();
      const phone = document.getElementById('order-phone').value.trim();
      const email = document.getElementById('order-email').value.trim();
      const err = document.getElementById('order-error');
      if (!name || !phone || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = 'Merci de renseigner nom, téléphone et e-mail valide.';
        return;
      }
      err.textContent = '';
      const lignes = cart.map(it => `${it.qty} × ${it.name}${it.note ? ' [' + it.note + ']' : ''} — ${eur(it.price * it.qty)}`).join('\n');
      const sendBtn = document.getElementById('order-send');
      const old = sendBtn.textContent;
      const showOk = () => {
        document.getElementById('order-form-wrap').hidden = true;
        document.getElementById('order-success').hidden = false;
        cart.length = 0; render();
      };
      if (location.protocol === 'file:') {
        const body = 'NOUVELLE COMMANDE\n\n' + lignes + '\nTotal : ' + eur(total()) +
          '\n\nClient : ' + name + '\nTéléphone : ' + phone + '\nE-mail : ' + email +
          '\nAdresse : ' + document.getElementById('order-address').value +
          '\nPrécisions : ' + document.getElementById('order-notes').value;
        window.location.href = 'mailto:contact@avisazur.com?subject=' +
          encodeURIComponent('Commande — Avis Azur') + '&body=' + encodeURIComponent(body);
        showOk(); return;
      }
      sendBtn.disabled = true; sendBtn.textContent = 'Envoi en cours…';
      const fd = new FormData();
      fd.append('_subject', '🛒 NOUVELLE COMMANDE — Avis Azur');
      fd.append('_template', 'table');
      fd.append('_captcha', 'false');
      fd.append('Commande', lignes);
      fd.append('Total', eur(total()));
      fd.append('Nom et prénom', name);
      fd.append('Téléphone', phone);
      fd.append('email', email);
      fd.append('Adresse de livraison', document.getElementById('order-address').value);
      fd.append('Précisions', document.getElementById('order-notes').value);
      fetch('https://formsubmit.co/ajax/contact@avisazur.com', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(r => { if (!r.ok) throw 0; return r.json(); })
        .then(() => { sendBtn.disabled = false; sendBtn.textContent = old; showOk(); })
        .catch(() => {
          sendBtn.disabled = false; sendBtn.textContent = old;
          err.textContent = "Envoi impossible — appelez-nous au 06 37 87 11 19 ou réessayez.";
        });
    });
  })();

  
  /* =========================================================
     V39 — MICRO-INTERACTIONS & ADAPTATION DE PUISSANCE
     ========================================================= */
  (function power() {
    var lite = (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
               (navigator.connection && navigator.connection.saveData);
    if (lite) document.documentElement.classList.add('lite');
  })();

  (function magnetic() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.btn').forEach(function (b) {
      var raf = 0;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var mx = e.clientX - r.left, my = e.clientY - r.top;
        b.style.setProperty('--hx', (mx / r.width * 100).toFixed(1) + '%');
        b.style.setProperty('--hy', (my / r.height * 100).toFixed(1) + '%');
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          var dx = (mx - r.width / 2) / r.width, dy = (my - r.height / 2) / r.height;
          b.style.transform = 'perspective(620px) translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 5).toFixed(1) + 'px) rotateX(' + (dy * -3.4).toFixed(2) + 'deg) rotateY(' + (dx * 4.2).toFixed(2) + 'deg)';
        });
      });
      b.addEventListener('pointerleave', function () {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        b.style.transform = '';
      });
    });
  })();

  (function sceneTilt() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var stage = document.querySelector('.sig-stage');
    var scene = document.querySelector('.sig-scene');
    if (!stage || !scene) return;
    var raf = 0;
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      var dy = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(function () {
        raf = 0;
        scene.style.setProperty('--tiltX', (dy * -2.6).toFixed(2) + 'deg');
        scene.style.setProperty('--tiltY', (dx * 3.4).toFixed(2) + 'deg');
      });
    });
    stage.addEventListener('pointerleave', function () {
      scene.style.setProperty('--tiltX', '0deg');
      scene.style.setProperty('--tiltY', '0deg');
    });
  })();

  /* =========================================================
     V39 — FINALE
     ========================================================= */
  (function finale() {
    var fin = document.querySelector('.finale');
    if (!fin) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { fin.classList.add('is-live'); io.disconnect(); }
        });
      }, { threshold: 0.3 });
      io.observe(fin);
    } else { fin.classList.add('is-live'); }
    var top = document.getElementById('fin-top');
    if (top) top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  })();

  /* =========================================================
     V39 — FICHE PROJET : VOS ÉLÉMENTS (multi-upload local)
     ========================================================= */
  (function projetFichiers() {
    var drop = document.getElementById('sf-drop');
    if (!drop) return;
    var input = document.getElementById('sf-files-input');
    var list = document.getElementById('sf-files');
    var hidden = document.getElementById('sf-fichiers');
    var msg = document.getElementById('sf-upmsg');
    var files = [];
    var MAX = 15, MAXSIZE = 25 * 1048576;
    var kindOf = function (f) {
      if (/^image\//.test(f.type)) return 'img';
      if (f.type === 'application/pdf' || /\.pdf$/i.test(f.name)) return 'PDF';
      if (/^video\//.test(f.type)) return 'VIDÉO';
      return 'DOC';
    };
    var fmt = function (n) { return n > 1048576 ? (n / 1048576).toFixed(1) + ' Mo' : Math.max(1, Math.round(n / 1024)) + ' Ko'; };
    var err = function (t) { if (msg) { msg.textContent = t; msg.hidden = false; } };
    var render = function () {
      list.innerHTML = '';
      files.forEach(function (f, i) {
        var li = document.createElement('li');
        var vis = f.url
          ? '<img class="sff-thumb" alt="" src="' + f.url + '">'
          : '<span class="sff-ico">' + f.kind + '</span>';
        li.innerHTML = vis +
          '<span class="sff-meta"><span class="sff-name"></span><span class="sff-size">' + fmt(f.size) + '</span></span>' +
          '<button type="button" class="sff-del" data-i="' + i + '" aria-label="Retirer ce fichier">×</button>';
        li.querySelector('.sff-name').textContent = f.name;
        list.appendChild(li);
      });
      hidden.value = files.map(function (f) { return f.name; }).join(' · ');
    };
    var add = function (fl) {
      if (msg) msg.hidden = true;
      Array.prototype.forEach.call(fl, function (f) {
        if (files.length >= MAX) { err(window.avT('15 fichiers maximum — retirez-en un pour continuer.')); return; }
        if (f.size > MAXSIZE) { err(window.avT('Fichier trop lourd (25 Mo max) : ') + f.name); return; }
        var kind = kindOf(f);
        files.push({ name: f.name, size: f.size, kind: kind === 'img' ? 'img' : kind,
                     url: kind === 'img' ? URL.createObjectURL(f) : '' });
      });
      render();
    };
    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    ['dragover', 'dragenter'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
    });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer.files.length) add(e.dataTransfer.files); });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('.sff-del');
      if (!b) return;
      var i = +b.dataset.i;
      if (files[i] && files[i].url) { try { URL.revokeObjectURL(files[i].url); } catch (er) {} }
      files.splice(i, 1);
      render();
    });
  })();

  /* =========================================================
     V39 — FR / EN instantané (dictionnaire : window.AV_I18N)
     ========================================================= */
  (function i18n() {
    var dict = window.AV_I18N || {};
    var dictH = window.AV_I18N_HTML || {};
    var rev = {};
    Object.keys(dict).forEach(function (k) { rev[dict[k]] = k; });
    var norm = function (s) { return s.replace(/\s+/g, ' ').trim(); };
    var splitEls = [], nodes = [], attrEls = [], built = false;
    var build = function () {
      if (built) return;
      built = true;
      document.querySelectorAll('h1, h2, h3, p').forEach(function (el) {
        if (!el.querySelector('.wi') && !el.querySelector('.lt')) return;
        for (var i = 0; i < splitEls.length; i++) { if (splitEls[i].el.contains(el)) return; }
        splitEls.push({ el: el, key: norm(el.textContent), fr: el.innerHTML });
      });
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || !norm(n.nodeValue)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode && n.parentNode.nodeName;
          if (p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
          for (var i = 0; i < splitEls.length; i++) { if (splitEls[i].el.contains(n)) return NodeFilter.FILTER_REJECT; }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nd;
      while ((nd = walker.nextNode())) nodes.push(nd);
      var ATTRS = ['placeholder', 'aria-label', 'alt', 'title'];
      ATTRS.forEach(function (a) {
        document.querySelectorAll('[' + a + ']').forEach(function (el) { attrEls.push([el, a]); });
      });
    };
    (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(build);
    var frBtn, enBtn;
    var apply = function (lang) {
      build();
      var map = lang === 'en' ? dict : rev;
      window.AVLANG = lang;
      splitEls.forEach(function (s) {
        if (lang === 'en' && dictH[s.key]) s.el.innerHTML = dictH[s.key];
        else if (lang === 'fr') s.el.innerHTML = s.fr;
      });
      nodes.forEach(function (n2) {
        var cur = n2.nodeValue, key = norm(cur), tr = map[key];
        if (tr) {
          var lead = cur.match(/^\s*/)[0], tail = cur.match(/\s*$/)[0];
          n2.nodeValue = lead + tr + tail;
        }
      });
      attrEls.forEach(function (pair) {
        var v = pair[0].getAttribute(pair[1]);
        if (v) { var tr = map[norm(v)]; if (tr) pair[0].setAttribute(pair[1], tr); }
      });
      document.documentElement.lang = lang;
      var tt = map[norm(document.title)];
      if (tt) document.title = tt;
      var md = document.querySelector('meta[name="description"]');
      if (md) { var mt = map[norm(md.getAttribute('content'))]; if (mt) md.setAttribute('content', mt); }
      if (frBtn && enBtn) {
        frBtn.classList.toggle('is-on', lang === 'fr');
        enBtn.classList.toggle('is-on', lang === 'en');
      }
      var tg = document.getElementById('lang-toggle');
      if (tg) tg.setAttribute('aria-pressed', lang === 'en' ? 'true' : 'false');
      try { localStorage.setItem('avisazur-lang', lang); } catch (e) {}
      if (window.avColRefresh) window.avColRefresh();
      if (window.avCfRefresh) window.avCfRefresh();
      if (window.avHeaderCta) window.avHeaderCta();
    };
    var tg = document.getElementById('lang-toggle');
    if (tg) {
      frBtn = tg.querySelector('.lt-fr');
      enBtn = tg.querySelector('.lt-en');
      tg.addEventListener('click', function () {
        apply(window.AVLANG === 'en' ? 'fr' : 'en');
      });
    }
    var saved = '';
    try { saved = localStorage.getItem('avisazur-lang') || ''; } catch (e) {}
    if (saved === 'en') apply('en');
  })();


  /* =========================================================
     V40 — TRANSITION CINÉMATIQUE ENTRE LES DEUX UNIVERS
     ========================================================= */
  (function acte2Scene() {
    var wrap = document.querySelector('.a2-wrap');
    var stage = document.querySelector('.a2-stage');
    if (!wrap || !stage) return;
    var ALL = ['a1', 'a2', 'a3', 'a4'];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ALL.forEach(function (c) { stage.classList.add(c); });
      stage.style.setProperty('--pp', '1');
      return;
    }
    var SEUILS = [['a1', 0.04], ['a2', 0.18], ['a3', 0.44], ['a4', 0.72]];
    var ticking = false;
    var update = function () {
      ticking = false;
      var r = wrap.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var ppv = (Math.round(p * 100) / 100).toFixed(2);
      if (stage._pp !== ppv) { stage._pp = ppv; stage.style.setProperty('--pp', ppv); }
      SEUILS.forEach(function (s) { stage.classList.toggle(s[0], p >= s[1]); });
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function () { onScroll(); }); },
        { rootMargin: '40% 0px' }).observe(wrap);
    }
    update();
  })();


  /* =========================================================
     V41 — CTA HEADER CONTEXTUEL (acte NFC vs acte Sites)
     ========================================================= */
  (function headerCta() {
    var cta = document.querySelector('.header-cta');
    var trans = document.getElementById('transition');
    if (!cta || !trans || !('IntersectionObserver' in window)) return;
    var mode = 'site';
    var set = function (m) {
      if (m === mode) return;
      mode = m;
      if (m === 'nfc') {
        cta.textContent = window.avT('Commander ma plaque');
        cta.setAttribute('href', '#collection');
      } else {
        cta.textContent = window.avT('Devis site web');
        cta.setAttribute('href', '#contact');
      }
    };
    var onScroll = function () {
      var r = trans.getBoundingClientRect();
      set(r.top > window.innerHeight * 0.5 ? 'nfc' : 'site');
    };
    var t = false;
    window.addEventListener('scroll', function () {
      if (!t) { t = true; requestAnimationFrame(function () { t = false; onScroll(); }); }
    }, { passive: true });
    window.avHeaderCta = function () { var m = mode; mode = ''; set(m); };
    onScroll();
  })();


  /* =========================================================
     V43 — LES PLAQUES RÉAGISSENT AU CURSEUR
     ========================================================= */
  (function colTilt() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var stage = document.getElementById('col-stage');
    if (!stage) return;
    var raf = 0;
    stage.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var on = stage.querySelector('.col-slide.is-on');
        if (!on) return;
        var r = on.getBoundingClientRect();
        var dx = (e.clientX - r.left) / Math.max(1, r.width) - 0.5;
        var dy = (e.clientY - r.top) / Math.max(1, r.height) - 0.5;
        on.style.setProperty('--kx', (dy * -4).toFixed(2) + 'deg');
        on.style.setProperty('--ky', (dx * 5).toFixed(2) + 'deg');
      });
    });
    stage.addEventListener('pointerleave', function () {
      var on = stage.querySelector('.col-slide.is-on');
      if (on) { on.style.setProperty('--kx', '0deg'); on.style.setProperty('--ky', '0deg'); }
    });
  })();


;

  /* =========================================================
     CINE-INTRO DRIVER — la caméra du film d'ouverture
     - une seule inscription dans la boucle rAF d'AVCine
     - le scroll pilote une caméra qui traverse un corridor 3D
     - WebGL : tunnel de particules avec traînées lumineuses
     - souris / tactile : parallaxe de caméra
     - reduced-motion : version posée gérée en CSS, zéro JS
     ========================================================= */
  (function () {
    'use strict';
    if (!window.AVCine) return;
    var scene = document.getElementById('cine-intro');
    if (!scene) return;
    var doc = document.documentElement;

    /* Version sans mouvement : cadre statique CSS, on ne démarre rien. */
    if (AVCine.reduced) return;

    doc.classList.add('av-in-cine');

    var vp     = document.getElementById('ci-vp');
    var world  = document.getElementById('ci-world');
    var canvas = document.getElementById('ci-gl');
    var hint   = scene.querySelector('.ci-hint');
    var els    = [].slice.call(scene.querySelectorAll('.ci-el'));
    var isTouch = AVCine.isTouch;

    /* ---------- outils ---------- */
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function sstep(a, b, v) { v = clamp((v - a) / (b - a), 0, 1); return v * v * (3 - 2 * v); }
    function lerp(a, b, t) { return a + (b - a) * t; }

    /* ---------- trajectoire de la caméra (unités corridor) ----------
       Départ immobile, plateau sur le logo, accélération WOW
       (0.76 → 0.90), décélération et arrêt progressif. */
    var CAM_END = 5400;
    var PATH = [[0, 0], [0.05, 0.004], [0.16, 0.05], [0.30, 0.155], [0.44, 0.30], [0.62, 0.47], [0.76, 0.60], [0.90, 0.925], [1, 1]];
    function camAt(p) {
      for (var i = 1; i < PATH.length; i++) {
        if (p <= PATH[i][0]) {
          var a = PATH[i - 1], b = PATH[i];
          return lerp(a[1], b[1], sstep(a[0], b[0], p)) * CAM_END;
        }
      }
      return CAM_END;
    }

    /* ---------- éléments du corridor ---------- */
    var items = els.map(function (el) {
      return {
        el: el,
        kind: el.dataset.ci,
        z: parseFloat(el.dataset.z) || 0,
        x: parseFloat(el.dataset.x) || 0,
        y: parseFloat(el.dataset.y) || 0,
        r: parseFloat(el.dataset.r) || 0,
        seed: Math.random() * Math.PI * 2,
        lastT: '', lastF: '', lastO: -1
      };
    });

    /* ---------- WebGL : tunnel de particules + traînées ---------- */
    var gl = null, glo = {};
    (function initGL() {
      try {
        gl = canvas.getContext('webgl', { alpha: true, antialias: false, depth: false, preserveDrawingBuffer: true, premultipliedAlpha: true });
      } catch (e) { gl = null; }
      if (!gl) { canvas.hidden = true; return; }
      function sh(type, src) {
        var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
        return s;
      }
      function prog(vs, fs) {
        var p = gl.createProgram();
        gl.attachShader(p, sh(gl.VERTEX_SHADER, vs));
        gl.attachShader(p, sh(gl.FRAGMENT_SHADER, fs));
        gl.linkProgram(p);
        if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
        return p;
      }
      try {
        /* poussière dorée / azur en profondeur */
        glo.pp = prog(
          'attribute vec3 aP; attribute float aS;' +
          'uniform float uCam,uDepth,uPersp,uAspect,uDpr;' +
          'uniform vec2 uPtr;' +
          'varying float vA; varying float vS;' +
          'void main(){' +
          '  float d = mod(aP.z - uCam, uDepth);' +
          '  float pd = max(d, 8.0);' +
          '  vec2 xy = aP.xy + uPtr * (1.0 - d / uDepth) * 120.0;' +
          '  vec2 clip = vec2(xy.x / uAspect, xy.y) * (uPersp / pd) * 0.0026;' +
          '  gl_Position = vec4(clip, 0.0, 1.0);' +
          '  gl_PointSize = clamp(uPersp / pd * (1.4 + aS * 2.6) * uDpr, 1.0, 30.0);' +
          '  vA = smoothstep(uDepth, uDepth * 0.5, d) * smoothstep(6.0, 90.0, d) * (0.3 + aS * 0.7);' +
          '  vS = aS;' +
          '}',
          'precision mediump float; varying float vA; varying float vS; uniform float uGlow;' +
          'void main(){' +
          '  float r = length(gl_PointCoord - vec2(0.5));' +
          '  float a = smoothstep(0.5, 0.04, r) * vA * uGlow;' +
          '  vec3 gold = vec3(0.922, 0.843, 0.631);' +
          '  vec3 mist = vec3(0.776, 0.871, 0.933);' +
          '  vec3 c = mix(gold, mist, step(0.7, fract(vS * 7.31)));' +
          '  c = mix(c, vec3(1.0), step(0.88, fract(vS * 3.17)) * 0.85);' +
          '  gl_FragColor = vec4(c * a, a);' +
          '}');
        /* voile d'estompage — laisse des traînées de lumière */
        glo.fp = prog(
          'attribute vec2 aQ; void main(){ gl_Position = vec4(aQ, 0.0, 1.0); }',
          'precision mediump float; uniform float uFade;' +
          'void main(){ gl_FragColor = vec4(0.0, 0.0, 0.0, uFade); }');
      } catch (e) { gl = null; canvas.hidden = true; return; }

      var N = isTouch ? 950 : 2300;
      var DEPTH = 2400, SPREAD = 900;
      var buf = new Float32Array(N * 4);
      for (var i = 0; i < N; i++) {
        var a = Math.random() * Math.PI * 2;
        var rad = Math.pow(Math.random(), 0.5) * SPREAD;
        buf[i * 4]     = Math.cos(a) * rad * (1 + Math.random() * 0.4);
        buf[i * 4 + 1] = Math.sin(a) * rad * 0.72;
        buf[i * 4 + 2] = Math.random() * DEPTH;
        buf[i * 4 + 3] = Math.random();
      }
      glo.vb = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, glo.vb);
      gl.bufferData(gl.ARRAY_BUFFER, buf, gl.STATIC_DRAW);
      glo.qb = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, glo.qb);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      glo.N = N; glo.DEPTH = DEPTH;
      glo.u = {
        cam: gl.getUniformLocation(glo.pp, 'uCam'),
        depth: gl.getUniformLocation(glo.pp, 'uDepth'),
        persp: gl.getUniformLocation(glo.pp, 'uPersp'),
        aspect: gl.getUniformLocation(glo.pp, 'uAspect'),
        dpr: gl.getUniformLocation(glo.pp, 'uDpr'),
        ptr: gl.getUniformLocation(glo.pp, 'uPtr'),
        glow: gl.getUniformLocation(glo.pp, 'uGlow'),
        fade: gl.getUniformLocation(glo.fp, 'uFade')
      };
      glo.aP = gl.getAttribLocation(glo.pp, 'aP');
      glo.aS = gl.getAttribLocation(glo.pp, 'aS');
      glo.aQ = gl.getAttribLocation(glo.fp, 'aQ');
    })();

    var dpr = 1;
    function sizeGL() {
      if (!gl) return;
      dpr = Math.min(window.devicePixelRatio || 1, isTouch ? 1.5 : 1.75);
      dpr = Math.max(0.5, Math.min(dpr, 2560 / Math.max(1, vp.clientWidth)));
      var w = Math.round(vp.clientWidth * dpr), h = Math.round(vp.clientHeight * dpr);
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w; canvas.height = h;
        gl.viewport(0, 0, w, h);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
      }
    }
    sizeGL();
    window.addEventListener('resize', sizeGL, { passive: true });

    function drawGL(cam01, boost, glow, px, py) {
      if (!gl) return;
      /* voile d'estompage : traînées plus longues pendant le WOW */
      gl.useProgram(glo.fp);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ZERO, gl.ONE_MINUS_SRC_ALPHA);
      gl.bindBuffer(gl.ARRAY_BUFFER, glo.qb);
      gl.enableVertexAttribArray(glo.aQ);
      gl.vertexAttribPointer(glo.aQ, 2, gl.FLOAT, false, 0, 0);
      gl.uniform1f(glo.u.fade, lerp(0.34, 0.10, boost));
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.disableVertexAttribArray(glo.aQ);
      /* particules en fusion additive */
      gl.useProgram(glo.pp);
      gl.blendFunc(gl.ONE, gl.ONE);
      gl.bindBuffer(gl.ARRAY_BUFFER, glo.vb);
      gl.enableVertexAttribArray(glo.aP);
      gl.enableVertexAttribArray(glo.aS);
      gl.vertexAttribPointer(glo.aP, 3, gl.FLOAT, false, 16, 0);
      gl.vertexAttribPointer(glo.aS, 1, gl.FLOAT, false, 16, 12);
      gl.uniform1f(glo.u.cam, cam01 * glo.DEPTH * 2.4 + performance.now() * 0.008);
      gl.uniform1f(glo.u.depth, glo.DEPTH);
      gl.uniform1f(glo.u.persp, 720);
      gl.uniform1f(glo.u.aspect, canvas.width / Math.max(1, canvas.height));
      gl.uniform1f(glo.u.dpr, dpr);
      gl.uniform2f(glo.u.ptr, px, py);
      gl.uniform1f(glo.u.glow, glow);
      gl.drawArrays(gl.POINTS, 0, glo.N);
      gl.disableVertexAttribArray(glo.aP);
      gl.disableVertexAttribArray(glo.aS);
    }

    /* ---------- passer l'intro ---------- */
    var skip = document.getElementById('ci-skip');
    if (skip) skip.addEventListener('click', function () {
      var from = window.scrollY;
      var to = scene.offsetTop + scene.offsetHeight - window.innerHeight + 2;
      var t0 = performance.now();
      var prevSB = doc.style.scrollBehavior;
      doc.style.scrollBehavior = 'auto'; /* le tween ne doit pas subir le smooth CSS */
      (function step(now) {
        var t = clamp((now - t0) / 850, 0, 1), e = 1 - Math.pow(1 - t, 3);
        window.scrollTo(0, lerp(from, to, e));
        if (t < 1) requestAnimationFrame(step);
        else { doc.style.scrollBehavior = prevSB; jumpTo = 1; }
      })(t0);
    });

    /* ---------- boucle image par image ---------- */
    var sp = 0, spx = 0, spy = 0, settled = false, jumpTo = null;
    var maxBlur = isTouch ? 5 : 9;

    AVCine.onFrame(function (t, st) {
      var p = AVCine.pinProgress(scene);

      /* scène entièrement traversée : figer le dernier photogramme */
      if (p >= 1 && sp >= 0.999) {
        if (!settled) { doc.classList.remove('av-in-cine'); sp = 1; settled = true; }
        return;
      }
      settled = false;

      /* saut volontaire (bouton passer, ancre, restauration) : coupe franche */
      if (jumpTo !== null) { sp = jumpTo; jumpTo = null; }
      if (Math.abs(p - sp) > 0.5) sp = p;
      else sp += (p - sp) * (Math.abs(p - sp) > 0.25 ? 0.4 : 0.16);
      if (Math.abs(p - sp) < 0.0004) sp = p;

      var mob = st.vw <= 760;
      var persp = mob ? 640 : Math.min(Math.max(st.vw, st.vh) * 0.9, 1050);
      var xUnit = Math.min(st.vw, st.vh) / 100; /* 1 unité data-x/y = 1vmin */

      /* pointeur lissé (souris ou tactile) */
      spx += ((st.pointer.x - 0.5) - spx) * 0.06;
      spy += ((st.pointer.y - 0.5) - spy) * 0.06;
      var pk = mob ? 0.55 : 1;

      /* phases du film */
      var cam    = camAt(sp);
      var boost  = sstep(0.76, 0.84, sp) * (1 - sstep(0.88, 0.945, sp));  /* Scène 07 — WOW */
      var calm   = sstep(0.90, 0.985, sp);                                 /* Scène 08 — arrivée */
      var logoIn = sstep(0.055, 0.24, sp);                                 /* Scène 02 */
      var sheen  = sstep(0.15, 0.30, sp);
      var draw   = sstep(0.24, 0.46, sp);                                  /* Scène 03 */
      var far    = sstep(0.18, 0.40, sp) * (1 - calm * 0.6);
      var uvl    = sstep(0.34, 0.46, sp);                                 /* Scène 04 — entrée des produits */
      var coreS  = 0.35 + sstep(0.02, 0.22, sp) * 0.5 + boost * 0.35 + calm * 1.5;
      var coreA  = 0.10 + sstep(0.015, 0.16, sp) * 0.5 + boost * 0.5 + calm * 0.35;

      /* variables écran — chaque valeur n'est écrite que si elle change */
      var S = vp.style;
      if (!vp._pv) vp._pv = {};
      var _pv = vp._pv;
      var setP = function (k, v) { if (_pv[k] !== v) { _pv[k] = v; S.setProperty(k, v); } };
      setP('--ci-bars', (1 - sstep(0.0, 0.05, sp)).toFixed(3));
      setP('--ci-core', coreS.toFixed(3));
      setP('--ci-corea', Math.min(coreA, 1).toFixed(3));
      setP('--ci-px', (spx * pk).toFixed(3));
      setP('--ci-py', (spy * pk).toFixed(3));
      var raysA = boost * 0.9 + calm * 0.18;
      setP('--ci-rays', raysA.toFixed(3));
      if (raysA > 0.004) setP('--ci-rayr', (Math.round(((t * 0.004) % 360) * 4) / 4) + 'deg');
      setP('--ci-ch', calm.toFixed(3));
      setP('--ci-gla', (1 - calm * 0.55).toFixed(3));
      setP('--ci-sheen', sheen.toFixed(3));
      setP('--ci-persp', persp.toFixed(0) + 'px');
      if (hint && (sp > 0.004 || hint.hasAttribute('data-off'))) {
        hint.setAttribute('data-off', '');
        var hv = (1 - sstep(0.004, 0.03, sp)).toFixed(3);
        if (hint._v !== hv) { hint._v = hv; hint.style.setProperty('--ci-hint', hv); }
      }

      /* Scènes 05/06 : la caméra — le monde tourne et avance */
      world.style.transform =
        'rotateY(' + (-spx * pk * 7).toFixed(2) + 'deg)' +
        ' rotateX(' + (spy * pk * 4.4).toFixed(2) + 'deg)' +
        ' translate3d(' + (-spx * pk * 26).toFixed(1) + 'px,' + (-spy * pk * 18).toFixed(1) + 'px,' + cam.toFixed(1) + 'px)';

      /* les éléments du corridor */
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var vz = cam - it.z;      /* > 0 : la caméra l'a dépassé */
        var ahead = -vz;          /* distance devant la caméra   */
        var o = 0, tr = it.lastT, fl = it.lastF;

        if (ahead > persp * 3.4 || vz > 480) {
          o = 0;
        } else if (it.kind === 'blob') {
          o = far;
          tr = 'translate3d(' + (it.x * xUnit).toFixed(1) + 'px,' + (it.y * xUnit).toFixed(1) + 'px,' + (-it.z).toFixed(0) + 'px) scale(2.6)';
          fl = '';
        } else if (it.kind === 'gate') {
          o = sstep(3600, 2000, ahead) * (1 - sstep(-20, 240, vz));
          var dv = draw.toFixed(3);
          if (it.lastD !== dv) { it.lastD = dv; it.el.style.setProperty('--ci-draw', dv); }
          tr = 'translate3d(0px,0px,' + (-it.z).toFixed(0) + 'px) rotateZ(' + (Math.sin(t * 0.0001 + it.z) * 4).toFixed(2) + 'deg)';
          fl = '';
        } else if (it.kind === 'logo') {
          /* Scène 02 : profondeur, mise au point, halo — puis il frôle la caméra */
          o = logoIn * (1 - sstep(-20, 340, vz));
          var lb = (1 - logoIn) * 12 + sstep(60, 340, Math.max(vz, 0)) * 6;
          fl = lb > 0.35 ? 'blur(' + (Math.round(lb * 2) / 2) + 'px)' : '';
          tr = 'translate(-50%,-50%) translate3d(0px,' + (-(1 - logoIn) * 30).toFixed(1) + 'px,' + (-it.z).toFixed(0) + 'px)';
          var hv2 = (logoIn * (1 - sstep(0, 260, Math.max(vz, 0)))).toFixed(3);
          if (it.lastH !== hv2) { it.lastH = hv2; it.el.style.setProperty('--ci-halo', hv2); }
        } else {
          /* Scène 04 : le produit émerge du fond, révélé par la lumière,
             puis passe à côté de la caméra */
          o = uvl * sstep(3050, 2150, ahead) * (1 - sstep(110, 330, vz));
          var lit = sstep(1800, 750, ahead) * (1 - sstep(60, 320, vz));
          var dof = clamp((Math.abs(ahead - 480) - 300) / 1500, 0, 1) * maxBlur;
          var bob = Math.sin(t * 0.00045 + it.seed) * 7;
          fl = 'drop-shadow(0 26px 44px rgba(1,6,11,0.6))';
          if (lit > 0.03) fl += ' drop-shadow(0 0 ' + Math.round(18 + lit * 16) + 'px rgba(235,215,161,' + (lit * 0.5).toFixed(2) + '))';
          if (dof > 0.4) fl += ' blur(' + (Math.round(dof * 2) / 2) + 'px)';
          tr = 'translate3d(' + (it.x * xUnit).toFixed(1) + 'px,' + (it.y * xUnit + bob).toFixed(1) + 'px,' + (-it.z).toFixed(0) + 'px)' +
               ' rotateY(' + (it.r + Math.sin(t * 0.0003 + it.seed) * 2.5).toFixed(2) + 'deg)' +
               ' rotateZ(' + (Math.sin(t * 0.00025 + it.seed * 2) * 1.6).toFixed(2) + 'deg)';
        }

        o = clamp(o, 0, 1);
        var oR = Math.round(o * 200) / 200;
        if (oR > 0) {
          if (tr !== it.lastT) { it.el.style.transform = tr; it.lastT = tr; }
          if (fl !== it.lastF) { it.el.style.filter = fl; it.lastF = fl; }
        }
        if (oR !== it.lastO) {
          it.el.style.opacity = oR;
          it.el.style.visibility = oR <= 0 ? 'hidden' : 'visible';
          it.lastO = oR;
        }
      }

      /* WebGL */
      sizeGL();
      drawGL(sp, boost, 0.55 + boost * 0.8 + sstep(0.02, 0.2, sp) * 0.35, spx * pk, -spy * pk);

      /* interface du site masquée pendant le film */
      doc.classList.toggle('av-in-cine', sp < 0.96);
    });
  })();
  